var common =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _blocksTrackerTracker = __webpack_require__(140);
	
	var _blocksTrackerTracker2 = _interopRequireDefault(_blocksTrackerTracker);
	
	var _calltrackingMango = __webpack_require__(355);
	
	var _calltrackingMango2 = _interopRequireDefault(_calltrackingMango);
	
	var _blocksTrackerEvents = __webpack_require__(131);
	
	var _blocksTrackerEvents2 = _interopRequireDefault(_blocksTrackerEvents);
	
	var functions = __webpack_require__(163);
	
	__webpack_require__(356);
	__webpack_require__(367);
	__webpack_require__(369);
	__webpack_require__(371);
	__webpack_require__(373);
	__webpack_require__(375);
	__webpack_require__(377);
	__webpack_require__(379);
	__webpack_require__(381);
	__webpack_require__(383);
	__webpack_require__(386);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(392);
	__webpack_require__(395);
	__webpack_require__(397);
	__webpack_require__(400);
	__webpack_require__(407);
	__webpack_require__(410);
	__webpack_require__(412);
	__webpack_require__(419);
	__webpack_require__(422);
	__webpack_require__(425);
	__webpack_require__(428);
	__webpack_require__(431);
	__webpack_require__(291);
	__webpack_require__(433);
	__webpack_require__(315);
	__webpack_require__(436);
	__webpack_require__(437);
	__webpack_require__(440);
	
	__webpack_require__(443);
	__webpack_require__(453);
	__webpack_require__(306);
	__webpack_require__(457);
	__webpack_require__(459);
	__webpack_require__(303);
	
	__webpack_require__(334);
	__webpack_require__(460);
	__webpack_require__(461);
	
	__webpack_require__(465);
	__webpack_require__(467);
	
	/* Для корректногй работы popup-карточки на любой странице */
	__webpack_require__(468);
	//require('./blocks/product-card/product-card');
	__webpack_require__(473);
	__webpack_require__(475);
	__webpack_require__(220);
	/* Popup корзина необходима на любой странице */
	
	__webpack_require__(478);
	__webpack_require__(480);
	
	__webpack_require__(482);
	
	__webpack_require__(484);
	window.picturefill();
	
	var trackers = new _blocksTrackerTracker2['default']();
	var events = new _blocksTrackerEvents2['default']();
	events.init();
	
	jQuery(function ($) {
	    /*const mango = new Mango();
	    mango.init();*/
	
	    //это нужно чтобы на ай-осях клик срабатывал.
	    //на боди кликаем когда хотим закрыть что-нибудь выпадающее
	    if (functions.isIOS()) $('body').css('cursor', 'pointer');
	
	    var $mainContainer = $('.main-container');
	    $mainContainer.append('<div class="overlay" id="overlay" />');
	
	    $('.js-scroll-link').click(function (e) {
	        var $this = $(this);
	        var target = this.hash;
	
	        var $clickedTarget = $(e.target);
	
	        if (!$this.is('a, button')) {
	            if ($clickedTarget.is('a, button') || $clickedTarget.closest('a, button').length > 0) return;
	
	            target = '#' + $this.data('href');
	        }
	        e.preventDefault();
	        var $target = $(target);
	        var top = $target.offset().top - 10;
	
	        $('html, body').stop().animate({
	            scrollTop: top
	        }, 700, 'swing', function () {
	            //window.location.hash = target;
	        });
	    });
	
	    $('.js-consult-button').click(function () {
	        trackers.onAdviserWindow();
	    });
	
	    $('#carrotquest-messenger-reply-button').click(function () {
	        trackers.onAdviserReply();
	    });
	
	    $(document).on('click', '#js-carrotquest-clicker', function () {
	        //$('#carrotquest-messenger-collapsed').click();
	        $('.b24-widget-button-wrapper').click();
	    });
	
	    /**
	     *  Событие на отправку сообщение в чат bitrix 24
	     *  Добавляем Google Client Id
	     */
	    window.addEventListener('onBitrixLiveChat', function (event) {
	        // Проверяем корректность параметров события
	        if (!event || !event.detail || !event.detail.widget) {
	            return;
	        }
	
	        var widget = event.detail.widget;
	        var ga = 'GoogleAnalyticsUserID=' + functions.getCookie('_ga');
	        widget.setCustomData(ga);
	    });
	
	    window.addEventListener('b24:form:init', function (event) {
	        var form = event.detail.object;
	
	        form.setProperty('_ym_uid', functions.getCookie('_ym_uid'));
	        form.setProperty("uf_lead_utm_campaign_hidden_form", functions.getCookie('utm_campaign'));
	        form.setProperty("uf_lead_utm_medium_hidden_form", functions.getCookie('utm_medium'));
	        form.setProperty("uf_lead_utm_source_hidden_form", functions.getCookie('utm_source'));
	    });
	
	    /**
	     * Это обработчики отправки битриксовых форм, они нужны для отправки данных
	     * с форм в сервис трекинга calltouch
	     */
	    /*window.addEventListener('b24:form:init', (event) => {
	        let form = event.detail.object;
	        setTimeout(function() {
	            let forms = document.forms;
	            let countForm = document.forms.length;
	            for (let i = 0; i < countForm; i++) {
	                let jqForm = $(forms[i]);
	                if (jqForm.hasClass('jqiform')) {
	                    continue;
	                }
	                 if (jqForm.find('[class^="b24"]').length !== 0) {
	                    jqForm.on('submit', function(e) {
	                        e.preventDefault();
	                        let data = $(e.target).serializeArray();
	                        data.push({name: 'formId', value: form.identification.id});
	                        let params = {
	                            sessionId: window.ct('calltracking_params', 'a23hd404').sessionId,
	                            requestUrl: window.location.href,
	                            form: data
	                        };
	                        $.post(
	                            '/ajax/action/widget_calltracking/calltouch/',
	                            params,
	                            function(data) {
	                                console.log(data);
	                            },
	                            'json'
	                        );
	                    });
	                }
	            }
	        }, 1000);
	    });*/
	
	    trackers.backendPageViewed();
	    trackers.clientTimeSite();
	});
	
	// Полифилл для closest
	(function () {
	    if (!Element.prototype.closest) {
	        Element.prototype.closest = function (css) {
	            var node = this;
	            while (node) {
	                if (node.matches(css)) return node;else node = node.parentElement;
	            }
	            return null;
	        };
	    }
	})();
	
	(function (doc, win) {
	    $(doc).ready(function () {
	        var searchForm = document.querySelector('.simple-search-form form');
	        if (!searchForm) {
	            return;
	        }
	
	        searchForm.onsubmit = function () {
	            trackers.onSearch({
	                fbpixel: {
	                    content_name: this.firstElementChild.value
	                }
	            });
	        };
	
	        trackers.onContentView({ fbpixel: win.location.pathname.split('/')[1] });
	    });
	})(document, window);
	
	$('body').on('click', '.subscribe__form .follow-by-email-submit', function (e) {
	    var email = $('.subscribe__form input[name="sf_EMAIL"]').val();
	    var emailPattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
	
	    if (emailPattern.test(email)) {
	        $.ajax({
	            type: 'POST',
	            url: '/ajax/action/subscribe_form/subscribe/',
	            data: {
	                email: email
	            },
	            success: function success(response) {
	                if (response.message == 'ok') {
	                    $('.subscribe__form .flex-row-email.block-email').html('Вы успешно подписаны!');
	                    $('.subscribe__form .flex-row-email.block-email').addClass('success');
	                    $('.block-email-fotter').css('display', 'none');
	                    trackers.onSubscriptionDone();
	                } else {
	                    $('.subscribe__form .flex-row-email.block-email .subscribe-form__error').html(response.message + '!');
	                }
	            },
	            dataType: 'json'
	        });
	    }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    debounce: function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    },
	
	    setResizeDebounce: function setResizeDebounce(func, wait, immediate) {
	        wait = wait || 250;
	        immediate = immediate || false;
	        var thisD = this;
	        var debouncedFunc = thisD.debounce(func, wait, immediate);
	        $(window).resize(debouncedFunc);
	    }
	};

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(113);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperty: __webpack_require__(65).f });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(117);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var PreLoader = (function () {
	    function PreLoader(options) {
	        _classCallCheck(this, PreLoader);
	
	        var defaults = PreLoader.getDefaultOptions();
	        this.options = _jquery2['default'].isPlainObject(options) ? _jquery2['default'].extend(true, defaults, options) : defaults;
	        this.$element = (0, _jquery2['default'])(this.options.selector);
	        this.$loader = (0, _jquery2['default'])(this.options.block);
	        this.$loader.addClass(this.options['class']);
	    }
	
	    _createClass(PreLoader, [{
	        key: 'show',
	        value: function show(speed) {
	            speed = this.speed(speed);
	            this.$element.append(this.$loader);
	            this.$loader.stop(true).fadeIn(speed);
	        }
	    }, {
	        key: 'hide',
	        value: function hide(speed) {
	            speed = this.speed(speed);
	            var loader = this.$loader;
	            loader.stop(true).fadeOut(speed, function () {
	                loader.detach();
	            });
	        }
	    }, {
	        key: 'speed',
	        value: function speed(_speed) {
	            return _jquery2['default'].isNumeric(_speed) ? parseInt(_speed) | 0 : this.options.speed;
	        }
	    }], [{
	        key: 'getDefaultOptions',
	        value: function getDefaultOptions() {
	            return {
	                speed: 200,
	                selector: 'body',
	                block: '<div class="maximaster-preloader"></div>',
	                'class': ''
	            };
	        }
	    }, {
	        key: 'isString',
	        value: function isString(variable, noEmpty) {
	            var answer = !!(variable === '' || variable && variable.split);
	            if (noEmpty === true) {
	                answer = answer && variable.length > 0;
	            }
	
	            return answer;
	        }
	    }]);
	
	    return PreLoader;
	})();
	
	exports['default'] = PreLoader;
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _tracker = __webpack_require__(140);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	Element.prototype.parents = function (selector) {
	    var elements = [];
	    var elem = this;
	    var ishaveselector = selector !== undefined;
	
	    while ((elem = elem.parentElement) !== null) {
	        if (elem.nodeType !== Node.ELEMENT_NODE) {
	            continue;
	        }
	
	        if (!ishaveselector || elem.matches(selector)) {
	            elements.push(elem);
	        }
	    }
	
	    return elements;
	};
	
	var Events = (function () {
	    function Events() {
	        _classCallCheck(this, Events);
	
	        this.searchData = [];
	    }
	
	    _createClass(Events, [{
	        key: 'init',
	        value: function init() {
	            var self = this;
	            this.onClickSoc();
	            this.onClickCity();
	            this.onClickSocIcon();
	            this.onClickProductTabs();
	            this.onClickProductPdf();
	            this.onClickPhone();
	            this.onClickTabs();
	            this.showMainBanner();
	            this.showSpecBanner();
	            this.onClickMainPromo();
	            this.onShowWatched();
	            this.onShowAnalog();
	            this.onClickProductCatalogBlock();
	            this.onClickWatched();
	            this.onClickAnalog();
	            this.onShowCatalogProducts();
	
	            setTimeout(function () {
	                self.onShowNewProducts();
	                self.onClickNewProducts();
	            }, 1000);
	        }
	    }, {
	        key: 'onClickSoc',
	        value: function onClickSoc() {
	            $('body').on('click', '.footer__column--social a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickTabs',
	        value: function onClickTabs() {
	            $('body').on('click', '.tabs__tab--cloud', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickPhone',
	        value: function onClickPhone() {
	            $('body').on('click', '.city-data-block__phones-link', function (e) {
	                var trackers = new _tracker2['default']();
	                trackers.onPMbtnTel();
	            });
	        }
	    }, {
	        key: 'onClickProductTabs',
	        value: function onClickProductTabs() {
	            $('body').on('click', '.product-card__tabs .tabs__tab', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickProductPdf',
	        value: function onClickProductPdf() {
	            $('body').on('click', '.product-card__previews-item--pdf', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickPdf(data);
	            });
	        }
	    }, {
	        key: 'onClickSocIcon',
	        value: function onClickSocIcon() {
	            $('body').on('click', '.bottom-menu__text-contacts-icon', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickCity',
	        value: function onClickCity() {
	            $('body').on('click', '.cities-list .cities-list__item a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent({
	                    event: 'PMbtnSelectCity',
	                    param: data.code
	                });
	            });
	        }
	
	        /**
	         * ловим события баннера на главной странице
	         */
	    }, {
	        key: 'showMainBanner',
	        value: function showMainBanner() {
	            var localBanners = [];
	            var self = this;
	            $('.js-slick-fullwidth-slider').on('init', function (event, slick) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'showSpecBanner',
	        value: function showSpecBanner() {
	            var localBanners = [];
	            var specBanners = document.querySelectorAll('.block-list--promos a.tiles__item--promo');
	            var self = this;
	
	            specBanners.forEach(function (element, index) {
	                var banner = {
	                    id: element.dataset.id,
	                    name: element.dataset.name,
	
	                    position: 'slot' + index
	                };
	                var bannerId = self.sendItemBanner(localBanners, banner, 'indexBannerSpec');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'sendItemBanner',
	        value: function sendItemBanner(localBanners, activeBanner, name) {
	
	            if (activeBanner !== undefined) {
	                if (localBanners.indexOf(activeBanner.id) === -1) {
	                    var _trackers = new _tracker2['default']();
	                    _trackers.onViewPromo({
	                        'promoView': {
	                            'promotions': [{
	                                'id': activeBanner.id,
	                                'name': name,
	                                'creative': activeBanner.name,
	                                'position': activeBanner.position
	                            }]
	                        }
	                    });
	                    localBanners.push(activeBanner.id);
	                    return activeBanner.id;
	                }
	            }
	        }
	    }, {
	        key: 'onClickMainPromo',
	        value: function onClickMainPromo() {
	            $('body').on('click', '.block-list.block-list--promos a', function (e) {
	                var dataId = this.getAttribute('data-id');
	                var dataName = this.getAttribute('data-name');
	                var trackers = new _tracker2['default']();
	                var dataNumber = 0;
	                if (this.parentNode.classList.contains('tiles__item--action-content')) {
	                    dataNumber = parseInt($(this.parentNode.parentNode).index()) + 1;
	                } else {
	                    dataNumber = parseInt($(this).index()) + 1;
	                }
	                trackers.onClickPromo({
	                    'promoClick': {
	                        'promotions': [{
	                            'id': dataId,
	                            'name': dataName,
	                            'creative': 'banner' + dataNumber,
	                            'position': 'slot' + dataNumber
	                        }]
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.products-slider .products-slider__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'newProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowNewProducts({
	                    'impressions': productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowWatched',
	        value: function onShowWatched() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.also-viewed .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowWatchedProducts({
	                    'impressions': productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowAnalog',
	        value: function onShowAnalog() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.site-block .tabs__content .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowAnalogProducts({
	                    'impressions': productData
	                });
	            }
	        }
	
	        /**
	         * отображение каталога, отправляем пачками по 8 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowCatalogProducts',
	        value: function onShowCatalogProducts() {
	            var products = [];
	            var productNodes = document.querySelectorAll('.catalog #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 8 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (products.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 8);
	                                    var productsList = [];
	
	                                    products.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'catalogProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            'impressions': productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	
	        /**
	         * отображение каталога в поиске, отправляем пачками по 10 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowSearchProducts',
	        value: function onShowSearchProducts() {
	            var productNodes = document.querySelectorAll('.search_container #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 10 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (self.searchData.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 10);
	                                    var productsList = [];
	
	                                    self.searchData.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'searchProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            'impressions': productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'onClickProductCatalogBlock',
	        value: function onClickProductCatalogBlock() {
	            var self = this;
	
	            $(".grid.catalog .product").on("click", 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'catalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    'click': {
	                        'actionField': {
	                            'list': 'catalogProducts'
	                        }
	                    },
	                    'products': [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickProductSearchBlock',
	        value: function onClickProductSearchBlock() {
	            var self = this;
	            $(".search_container .grid .product").on("click", 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    list: 'searchProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'searchProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    'click': {
	                        'actionField': {
	                            'list': 'searchProducts'
	                        }
	                    },
	                    'products': [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var self = this;
	            $(".also-viewed.grid .product").on("click", 'a, img', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.also-viewed .grid__item') + 1;
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'WatchedProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickWatched({
	                    'click': {
	                        'actionField': {
	                            'list': 'WatchedProducts'
	                        }
	                    },
	                    'products': [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var self = this;
	            $(".site-block .tabs__content .grid__item .product").on("click", 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.site-block .tabs__content .grid__item') + 1;
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'AnalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickAnalog({
	                    'click': {
	                        'actionField': {
	                            'list': 'AnalogProducts'
	                        }
	                    },
	                    'products': [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var self = this;
	            $(".products-slider .products-slider__item .product").on("click", 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.products-slider__item')[0]).index('.products-slider .products-slider__item') + 1;
	                var product = _extends({
	                    list: 'newProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'newProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickNewProducts({
	                    'click': {
	                        'actionField': {
	                            'list': 'newProducts'
	                        }
	                    },
	                    'products': [product]
	                });
	            });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var self = this;
	            if ($('.product-card').length > 0) {
	                var productDom = $('.product-card')[0];
	                var _productData = self.prepareData(productDom);
	                var product = _extends({}, _productData);
	
	                var _trackers2 = new _tracker2['default']();
	                _trackers2.onShowProductCard({
	                    'detail': {
	                        'actionField': {
	                            'list': localStorage.getItem('list')
	                        }
	                    },
	                    'products': [product]
	                });
	            }
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var self = this;
	            var productDom = $('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({}, productData);
	
	            var trackers = new _tracker2['default']();
	            trackers.onShowProductCardPopup({
	                'detail': {
	                    'actionField': {
	                        'list': localStorage.getItem('list')
	                    }
	                },
	                'products': [product]
	            });
	        }
	    }, {
	        key: 'onAddToCardProduct',
	        value: function onAddToCardProduct(elem) {
	            //проверяем откуда клик на добавление в корзину (карточка, списки)
	            if (elem.hasClass('product-card__btn')) {
	                this.addToCardFromCard(elem);
	            } else {
	                this.addToCardFromList(elem);
	            }
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard(elem) {
	            var self = this;
	            var productDom = elem.parents('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({
	                quantity: 1
	            }, productData);
	            var trackers = new _tracker2['default']();
	            trackers.addToCardFromCard({
	                'add': {
	                    'products': [product]
	                }
	            });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList(elem) {
	            var self = this;
	            var productDom = elem.parents('.product')[0];
	            var position = 0;
	            var list = '';
	            var productData = self.prepareData(productDom);
	
	            if (elem.parents('.catalog #catalog__products').length > 0) {
	                list = 'catalogProducts';
	                position = $(elem.parents('.grid__item')).index('#catalog__products .grid__item') + 1;
	            } else if (elem.parents('.slick-track').length > 0) {
	                list = 'newProducts';
	                position = $(elem.parents('.products-slider__item')).index('.slick-track .products-slider__item') + 1;
	            } else if (elem.parents('div[data-tab="analogs"]').length > 0) {
	                list = 'AnalogProducts';
	                position = $(elem.parents('.grid__item')).index('div[data-tab="analogs"] .grid__item') + 1;
	            } else if (elem.parents('.also-viewed').length > 0) {
	                list = 'WatchedProducts';
	                position = $(elem.parents('.grid__item')).index('.also-viewed .grid__item') + 1;
	            } else if (elem.parents('.search_container').length > 0) {
	                list = 'searchProducts';
	                position = $(elem.parents('.grid__item')).index('.search_container .grid__item') + 1;
	            }
	            var trackers = new _tracker2['default']();
	
	            var product = _extends({
	                list: list,
	                position: position
	            }, productData);
	
	            trackers.onClickCatalogProducts({
	                'click': {
	                    'actionField': {
	                        'list': list
	                    }
	                },
	                'products': [product]
	            });
	
	            product = _extends({}, productData);
	
	            trackers.onShowProductCard({
	                'detail': {
	                    'actionField': {
	                        'list': list
	                    }
	                },
	                'products': [product]
	            });
	
	            product = _extends({
	                quantity: 1
	            }, productData);
	
	            trackers.addToCardFromList({
	                'add': {
	                    'products': [product]
	                }
	
	            });
	        }
	    }, {
	        key: 'onClickCartAddProduct',
	        value: function onClickCartAddProduct(dataProductId, quantityOld, quantityChange) {
	
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityChange - quantityOld
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickAddProduct({
	                    'add': productData
	                });
	            }
	        }
	    }, {
	        key: 'onClickCartRemoveProduct',
	        value: function onClickCartRemoveProduct(dataProductId, quantityOld, quantityChange) {
	
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityOld - quantityChange
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickRemoveProduct({
	                    'remove': productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1(data) {
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    'checkout': {
	                        'actionField': {
	                            'step': 1
	                        },
	                        'products': productData
	                    }
	                });
	            }
	        }
	
	        /**
	         * подгоовка данных
	         * @param elem
	         * @returns {{price: number, name: string, category: number, brand: number}}
	         */
	    }, {
	        key: 'prepareData',
	        value: function prepareData(elem) {
	            var name = '';
	            if (elem.querySelector('[data-name]') !== null && elem.querySelector('[data-name]').dataset.name !== undefined) {
	                name = elem.querySelector('[data-name]').dataset.name;
	            }
	
	            var productId = '';
	            if (elem.querySelector('[data-product-id]') !== null && elem.querySelector('[data-product-id]').dataset.productId !== undefined) {
	                productId = elem.querySelector('[data-product-id]').dataset.productId;
	            }
	
	            var price = 0;
	            if (elem.querySelector('[data-price]') !== null && elem.querySelector('[data-price]').dataset.price !== undefined) {
	                price = elem.querySelector('[data-price]').dataset.price;
	            }
	
	            var brand = 0;
	            if (elem.querySelector('[data-brand]') !== null && elem.querySelector('[data-brand]').dataset.brand !== undefined) {
	                brand = elem.querySelector('[data-brand]').dataset.brand;
	            }
	
	            var category = 0;
	            if (elem.querySelector('[data-category]') !== null && elem.querySelector('[data-category]').dataset.category !== undefined) {
	                category = elem.querySelector('[data-category]').dataset.category;
	            }
	
	            return {
	                name: name,
	                price: price,
	                brand: brand,
	                category: category,
	                id: productId
	            };
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    'checkout': {
	                        'actionField': {
	                            'step': 1
	                        },
	                        'products': productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep(param) {
	            var step = 1;
	            if (param) {
	                step = param;
	            }
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var products = document.querySelectorAll('.cart .cart__item.basket__cart__item.cart__item--checkout');
	            products.forEach(function (item, index) {
	
	                var name = '';
	                if (item.getAttribute('data-product-name') !== null && item.getAttribute('data-product-name') !== undefined) {
	                    name = item.getAttribute('data-product-name');
	                }
	
	                var price = 0;
	                if (item.getAttribute('data-product-price') !== null && item.getAttribute('data-product-price') !== undefined) {
	                    price = item.getAttribute('data-product-price');
	                }
	
	                var brand = 0;
	                if (item.getAttribute('data-product-brand') !== null && item.getAttribute('data-product-brand') !== undefined) {
	                    brand = item.getAttribute('data-product-brand');
	                }
	
	                var category = 0;
	                if (item.getAttribute('data-product-category') !== null && item.getAttribute('data-product-category') !== undefined) {
	                    category = item.getAttribute('data-product-category');
	                }
	
	                var quantity = 0;
	                if (item.querySelectorAll(".quantity__value")[0].value !== null && item.querySelectorAll(".quantity__value")[0].value !== undefined) {
	                    quantity = item.querySelectorAll(".quantity__value")[0].value;
	                }
	
	                var product = {
	                    name: name,
	                    id: item.getAttribute('data-product-id'),
	                    price: price,
	                    brand: brand,
	                    category: category,
	                    quantity: quantity
	                };
	
	                productData.push(product);
	            });
	
	            if (productData.length > 0) {
	                trackers.onShowOrderStep({
	                    'checkout': {
	                        'actionField': {
	                            'step': step
	                        },
	                        'products': productData
	                    }
	                });
	            }
	        }
	    }]);
	
	    return Events;
	})();
	
	exports['default'] = Events;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = __webpack_require__(61).Object.assign;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(59);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(136) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(69);
	var getKeys = __webpack_require__(76);
	var gOPS = __webpack_require__(137);
	var pIE = __webpack_require__(138);
	var toObject = __webpack_require__(139);
	var IObject = __webpack_require__(79);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _gtm = __webpack_require__(141);
	
	var _gtm2 = _interopRequireDefault(_gtm);
	
	var _fbpixel = __webpack_require__(142);
	
	var _fbpixel2 = _interopRequireDefault(_fbpixel);
	
	var _mailru = __webpack_require__(143);
	
	var _yandexMetrika = __webpack_require__(144);
	
	__webpack_require__(145);
	__webpack_require__(146);
	
	var Trackers = (function () {
	    function Trackers() {
	        var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, Trackers);
	
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	
	        this.instances = {
	            gtm: new _gtm2['default'](),
	            fbpixel: new _fbpixel2['default']()
	        };
	        if (!arg.onlyTrackers) {
	            return;
	        }
	
	        for (var track in this.instances) {
	            if (arg.onlyTrackers.indexOf(track) === -1 && this.instances.hasOwnProperty(track)) {
	                delete this.instances[track];
	            }
	        }
	    }
	
	    _createClass(Trackers, [{
	        key: 'clientTimeSite',
	        value: function clientTimeSite() {
	            var time = arguments.length <= 0 || arguments[0] === undefined ? 190000 : arguments[0];
	
	            var _self = this;
	            setTimeout(function () {
	                _self.yandexMetrika.timeClient();
	            }, time);
	        }
	    }, {
	        key: 'trigger',
	        value: function trigger(evType, arg) {
	            for (var instName in this.instances) {
	                if (typeof this.instances[instName][evType] === 'function' && this.instances.hasOwnProperty(instName)) {
	                    this.instances[instName][evType](arg[instName]);
	                }
	            }
	        }
	    }, {
	        key: 'getTracker',
	        value: function getTracker(tracker) {
	            return this.instances[tracker];
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToCart', arg);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToFav', arg);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSearch', arg);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onContentView', arg);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUp', arg);
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUpEnd', arg);
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutStart', arg);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutEnd', arg);
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserWindow', arg);
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserReply', arg);
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('claimButton', arg);
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onTabClick', arg);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscribe', arg);
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscriptionDone', arg);
	            this.trigger('onPMfrmSubscribe', arg);
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackFormShow', arg);
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackButton', arg);
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackRequestSend', arg);
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onBasketRefresh', arg);
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyButton', arg);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyEnd', arg);
	        }
	    }, {
	        key: 'onPMbtnTel',
	        value: function onPMbtnTel() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnTel', arg);
	        }
	    }, {
	        key: 'onPMbtnFilter',
	        value: function onPMbtnFilter() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFilter', arg);
	        }
	    }, {
	        key: 'onClickEvent',
	        value: function onClickEvent() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onClickPdf',
	        value: function onClickPdf() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFavorite',
	        value: function onPMbtnFavorite() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFavorite', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtnAddToCart',
	        value: function onPMbtnAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAddToCart', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtn1Click',
	        value: function onPMbtn1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtn1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMfrm1Click',
	        value: function onPMfrm1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrm1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFAQ',
	        value: function onPMbtnFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFAQ', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMeContact',
	        value: function onPMfrmCallMeContact() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMeContact', arg);
	        }
	    }, {
	        key: 'onPMfrmFAQ',
	        value: function onPMfrmFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmFAQ', arg);
	        }
	    }, {
	        key: 'onPMbtnCallMe',
	        value: function onPMbtnCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMe',
	        value: function onPMfrmCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmReg',
	        value: function onPMfrmReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmReg', arg);
	        }
	    }, {
	        key: 'onPMbtnReg',
	        value: function onPMbtnReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnReg', arg);
	        }
	    }, {
	        key: 'onPMbtnComment',
	        value: function onPMbtnComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnComment', arg);
	        }
	    }, {
	        key: 'onPMfrmComment',
	        value: function onPMfrmComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmComment', arg);
	        }
	    }, {
	        key: 'onPMbtnAskQuestion',
	        value: function onPMbtnAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAskQuestion', arg);
	        }
	    }, {
	        key: 'onPMfrmAskQuestion',
	        value: function onPMfrmAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmAskQuestion', arg);
	        }
	    }, {
	        key: 'onClickPromo',
	        value: function onClickPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onViewPromo',
	        value: function onViewPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoView', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowWatchedProducts',
	        value: function onShowWatchedProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowAnalogProducts',
	        value: function onShowAnalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAddProduct',
	        value: function onClickAddProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickRemoveProduct',
	        value: function onClickRemoveProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceRemove', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowcatalogProducts',
	        value: function onShowcatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickCatalogProducts',
	        value: function onClickCatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'completeRegistration',
	        value: function completeRegistration() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('CompleteRegistration', arg);
	        }
	    }, {
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            this.mailru = new _mailru.MailRuTracker();
	            var route = $('.main-container').data('route');
	            switch (route) {
	                case 'index':
	                    this.indexPageViewed();
	                    break;
	                case 'catalog.section':
	                    this.categoryPageViewed();
	                    break;
	                case 'catalog.product':
	                    this.productPageViewed();
	                    break;
	                case 'cart':
	                    this.basketPageViewed();
	                    break;
	                case 'order':
	                    this.orderPageViewed();
	                    break;
	                case 'search':
	                    this.searchPageViewed();
	                    break;
	                default:
	                    this.otherPageViewed();
	                    break;
	            }
	        }
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.mailru.indexPageView();
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.mailru.categoryPageView();
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.mailru.productPageView($('.product-detail__action-btn').data('product-id'), $('.product-detail__price-sum').data('price'));
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {
	            this.mailru.otherPageView();
	        }
	    }, {
	        key: 'searchPageViewed',
	        value: function searchPageViewed() {
	            this.mailru.searchPageView();
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.mailru.orderPageView();
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            var ids = [];
	            var products = document.querySelectorAll('.cart__item .cart__item-content');
	            products.forEach(function (product) {
	                ids.push(product.getAttribute('data-product-id'));
	            });
	
	            this.mailru.basketPageView(ids, $('.basket-final-price').html());
	        }
	    }]);
	
	    return Trackers;
	})();
	
	exports['default'] = Trackers;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GTMEvents = (function () {
	    function GTMEvents() {
	        _classCallCheck(this, GTMEvents);
	
	        this.events = {
	            registrationDone: 'Registration_Done',
	            subscriptionButton: 'Subscription_Button',
	            subscriptionDone: 'Subscription_Done',
	            PMfrmSubscribe: 'PMfrmSubscribe',
	            add2CartButton: 'Add2Cart_Button',
	            oneClickBuyButton: 'oneClick_buy_Button',
	            accessoriesTab: 'accessories_tab',
	            faqTab: 'faq_tab',
	            reviewsTab: 'reviews_tab',
	            descriptionTab: 'description_tab',
	            onlineConsultant: 'online_consultant',
	            onlineConsultantButton: 'online_consultant_button',
	            onlineConsultantSent: 'online_consultant_sent',
	            backcall: 'backcall',
	            backcallButton: 'backcall_button',
	            backcallSent: 'backcall_sent',
	            claimButton: 'claim_button',
	            claimDone: 'claim_Done',
	            basketRefresh: 'basket_refresh',
	            basketOrder: 'basket_order',
	            contactLogin: 'contact_login',
	            contact1clickBuy: 'contact_1clickBuy',
	            contactRegistration: 'contact_registration',
	            contactRegistrationContinue: 'contact_registration_continue',
	            contactLoginContinue: 'contact_login_continue',
	            contact1clickBuyContinue: 'contact_1clickBuy_continue',
	            confirmOrder: 'confirm_order',
	            PMbtnSocial: 'PMbtnSocial',
	            PMbtnFAQ: 'PMbtnFAQ',
	            PMfrmFAQ: 'PMfrmFAQ',
	            PMbtnCallMe: 'PMbtnCallMe',
	            PMfrmCallMe: 'PMfrmCallMe',
	            PMbtnReg: 'PMbtnReg',
	            PMfrmReg: 'PMfrmReg',
	            PMbtnSelectCity: 'PMbtnSelectCity',
	            PMbtnTellAbout: 'PMbtnTellAbout',
	            PMbtnContact: 'PMbtnContact',
	            PMbtnComment: 'PMbtnComment',
	            PMfrmComment: 'PMfrmComment',
	            PMbtnAskQuestion: 'PMbtnAskQuestion',
	            PMfrmAskQuestion: 'PMfrmAskQuestion',
	            PMbtn1Click: 'PMbtn1Click',
	            PMfrm1Click: 'PMfrm1Click',
	            PMbtnFavorite: 'PMbtnFavorite',
	            PMbtnAddToCart: 'PMbtnAddToCart',
	            PMbtnTabs: 'PMbtnTabs',
	            PMbtnTel: 'PMbtnTel',
	            PMfrmCallMeContact: 'PMfrmCallMeContact',
	            PMbtnVariant: 'PMbtnVariant',
	            PMbtnFilter: 'PMbtnFilter',
	            ecommercePromoClick: 'ecommercePromoClick',
	            ecommercePromoView: 'ecommercePromoView',
	            ecommerceImpressions: 'ecommerceImpressions',
	            ecommerceClick: 'ecommerceClick',
	            ecommerceDetail: 'ecommerceDetail',
	            ecommerceAdd: 'ecommerceAdd',
	            ecommerceRemove: 'ecommerceRemove',
	            ecommerceCheckout: 'ecommerceCheckout',
	            completeRegistration: 'CompleteRegistration'
	        };
	    }
	
	    _createClass(GTMEvents, [{
	        key: 'onAddToCart',
	        value: function onAddToCart(arg) {
	            if (arg) {
	                this.push(_extends({
	                    event: 'addToCart'
	                }, arg));
	                return;
	            }
	            this.pushEvent('add2CartButton');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd(event) {
	            this.pushEvent(event);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            this.pushEvent('confirmOrder');
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            this.pushEvent('onlineConsultant');
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            this.pushEvent('onlineConsultantButton');
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            this.pushEvent('claimButton');
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick(tab) {
	            var tabMap = {
	                descr: 'descriptionTab',
	                reviews: 'reviewsTab',
	                faq: 'faqTab',
	                login: 'contactLogin',
	                reg: 'contactRegistration',
	                oneclick: 'contact1clickBuy'
	            };
	
	            if (!tabMap[tab]) {
	                return;
	            }
	
	            this.pushEvent(tabMap[tab]);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            this.pushEvent('subscriptionButton');
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            this.pushEvent('subscriptionDone');
	        }
	    }, {
	        key: 'onPMfrmSubscribe',
	        value: function onPMfrmSubscribe() {
	            this.pushEvent('PMfrmSubscribe');
	        }
	    }, {
	        key: 'PMbtnTel',
	        value: function PMbtnTel() {
	            this.pushEvent('PMbtnTel');
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            this.pushEvent('backcall');
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            this.pushEvent('backcallButton');
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            this.pushEvent('backcallSent');
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            this.pushEvent('basketOrder');
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            this.pushEvent('basketRefresh');
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            this.pushEvent('oneClickBuyButton');
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            this.pushEvent('contact1clickBuyContinue');
	        }
	    }, {
	        key: 'PMbtnSocial',
	        value: function PMbtnSocial(arg) {
	            this.push(_extends({
	                event: 'PMbtnSocial'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnVariant',
	        value: function PMbtnVariant(arg) {
	            this.push(_extends({
	                event: 'PMbtnVariant'
	            }, arg));
	        }
	    }, {
	        key: 'PMfrmCallMeContact',
	        value: function PMfrmCallMeContact(arg) {
	            this.push(_extends({
	                event: 'PMfrmCallMeContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTabs',
	        value: function PMbtnTabs(arg) {
	            this.push(_extends({
	                event: 'PMbtnTabs'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnAddToCart',
	        value: function PMbtnAddToCart(arg) {
	            this.push(_extends({
	                event: 'PMbtnAddToCart'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnSelectCity',
	        value: function PMbtnSelectCity(arg) {
	            this.push(_extends({
	                event: 'PMbtnSelectCity'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTellAbout',
	        value: function PMbtnTellAbout(arg) {
	            this.push(_extends({
	                event: 'PMbtnTellAbout'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtn1Click',
	        value: function PMbtn1Click() {
	            this.push({
	                event: 'PMbtn1Click'
	            });
	        }
	    }, {
	        key: 'PMfrm1Click',
	        value: function PMfrm1Click(arg) {
	            this.push(_extends({
	                event: 'PMfrm1Click'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFavorite',
	        value: function PMbtnFavorite(arg) {
	            this.push(_extends({
	                event: 'PMbtnFavorite'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnContact',
	        value: function PMbtnContact(arg) {
	            this.push(_extends({
	                event: 'PMbtnContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFAQ',
	        value: function PMbtnFAQ() {
	            this.push({
	                event: 'PMbtnFAQ'
	            });
	        }
	    }, {
	        key: 'PMfrmFAQ',
	        value: function PMfrmFAQ() {
	            this.push({
	                event: 'PMfrmFAQ'
	            });
	        }
	    }, {
	        key: 'PMbtnCallMe',
	        value: function PMbtnCallMe() {
	            this.push({
	                event: 'PMbtnCallMe'
	            });
	        }
	    }, {
	        key: 'PMfrmCallMe',
	        value: function PMfrmCallMe() {
	            this.push({
	                event: 'PMfrmCallMe'
	            });
	        }
	    }, {
	        key: 'PMbtnFilter',
	        value: function PMbtnFilter() {
	            this.push({
	                event: 'PMbtnFilter'
	            });
	        }
	    }, {
	        key: 'PMbtnReg',
	        value: function PMbtnReg() {
	            this.push({
	                event: 'PMbtnReg'
	            });
	        }
	    }, {
	        key: 'PMfrmReg',
	        value: function PMfrmReg() {
	            this.push({
	                event: 'PMfrmReg'
	            });
	        }
	    }, {
	        key: 'PMbtnComment',
	        value: function PMbtnComment() {
	            this.push({
	                event: 'PMbtnComment'
	            });
	        }
	    }, {
	        key: 'PMfrmComment',
	        value: function PMfrmComment() {
	            this.push({
	                event: 'PMfrmComment'
	            });
	        }
	    }, {
	        key: 'PMbtnAskQuestion',
	        value: function PMbtnAskQuestion() {
	            this.push({
	                event: 'PMbtnAskQuestion'
	            });
	        }
	    }, {
	        key: 'PMfrmAskQuestion',
	        value: function PMfrmAskQuestion() {
	            this.push({
	                event: 'PMfrmAskQuestion'
	            });
	        }
	    }, {
	        key: 'pushEvent',
	        value: function pushEvent(eventName) {
	            if (this.events[eventName] !== undefined) {
	                this.push({
	                    event: this.events[eventName]
	                });
	            }
	        }
	    }, {
	        key: 'ecommercePromoClick',
	        value: function ecommercePromoClick(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommercePromoView',
	        value: function ecommercePromoView(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoView'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceImpressions',
	        value: function ecommerceImpressions(arg) {
	            this.push(_extends({
	                event: 'ecommerceImpressions'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceClick',
	        value: function ecommerceClick(arg) {
	            this.push(_extends({
	                event: 'ecommerceClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceDetail',
	        value: function ecommerceDetail(arg) {
	            this.push(_extends({
	                event: 'ecommerceDetail'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceAdd',
	        value: function ecommerceAdd(arg) {
	            this.push(_extends({
	                event: 'ecommerceAdd'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceRemove',
	        value: function ecommerceRemove(arg) {
	            this.push(_extends({
	                event: 'ecommerceRemove'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceCheckout',
	        value: function ecommerceCheckout(arg) {
	            this.push(_extends({
	                event: 'ecommerceCheckout'
	            }, arg));
	        }
	    }, {
	        key: 'push',
	        value: function push(params) {
	            window.dataLayer.push(params);
	        }
	    }]);
	
	    return GTMEvents;
	})();
	
	exports['default'] = GTMEvents;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FBPixel = (function () {
	    function FBPixel() {
	        _classCallCheck(this, FBPixel);
	
	        var pageTitle = document.querySelector('h1');
	        this.title = pageTitle ? pageTitle.textContent : '';
	    }
	
	    _createClass(FBPixel, [{
	        key: 'track',
	        value: function track(type, args) {
	            if (typeof window.fbq !== 'function') {
	                return;
	            }
	            window.fbq('track', type, args);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView(location) {
	            var locations = ['categories', 'product', 'articles'];
	
	            if (locations.indexOf(location) === -1) {
	                return;
	            }
	
	            this.track('ViewContent', {
	                content_name: this.title
	            });
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart(args) {
	            this.withCurrency('InitiateCheckout', args);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd(args) {
	            this.withCurrency('Purchase', args);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd(args) {
	            this.onCheckoutEnd(args);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch(args) {
	            this.track('Search', args);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            this.track('Lead');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            this.withCurrency('CompleteRegistration', {
	                value: 100
	            });
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart(args) {
	            this.withCurrency('AddToCart', args);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav(args) {
	            this.withCurrency('AddToWishlist', _extends({}, args, {
	                content_name: this.title
	            }));
	        }
	    }, {
	        key: 'withCurrency',
	        value: function withCurrency(type) {
	            var args = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	            this.track(type, _extends({}, args, {
	                currency: 'RUB'
	            }));
	        }
	    }]);
	
	    return FBPixel;
	})();
	
	exports['default'] = FBPixel;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MailRuTracker = (function () {
	    function MailRuTracker() {
	        _classCallCheck(this, MailRuTracker);
	
	        this.init();
	    }
	
	    _createClass(MailRuTracker, [{
	        key: 'init',
	        value: function init() {
	            window._tmr = window._tmr || [];
	            return window._tmr;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window._tmr.push(query);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), { pagetype: 'home' }));
	        }
	    }, {
	        key: 'otherPageView',
	        value: function otherPageView() {
	            this.push(this.getQueryTemplate());
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'category',
	                productid: '',
	                totalvalue: ''
	            }));
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(ids, totalPrice) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'cart',
	                productid: ids,
	                totalvalue: totalPrice
	            }));
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(id, price) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'product',
	                productid: id,
	                totalvalue: parseFloat(price)
	            }));
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'purchase'
	            }));
	        }
	    }, {
	        key: 'searchPageView',
	        value: function searchPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'searchresults'
	            }));
	        }
	    }, {
	        key: 'getQueryTemplate',
	        value: function getQueryTemplate() {
	            return {
	                id: '3241057',
	                type: 'itemView',
	                productid: '',
	                pagetype: 'other',
	                totalvalue: '',
	                list: '3'
	            };
	        }
	    }]);
	
	    return MailRuTracker;
	})();

	exports.MailRuTracker = MailRuTracker;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexMetrika = (function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                window.ym(911516, code, eventCode);
	            } catch (e) {
	                //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }]);
	
	    return YandexMetrika;
	})();

	exports.YandexMetrika = YandexMetrika;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/*!
	Waypoints - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/*!
	Waypoints Inview Shortcut - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	(function() {
	  'use strict'
	
	  function noop() {}
	
	  var Waypoint = window.Waypoint
	
	  /* http://imakewebthings.com/waypoints/shortcuts/inview */
	  function Inview(options) {
	    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
	    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
	    this.waypoints = []
	    this.element = this.options.element
	    this.createWaypoints()
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoints = function() {
	    var configs = {
	      vertical: [{
	        down: 'enter',
	        up: 'exited',
	        offset: '100%'
	      }, {
	        down: 'entered',
	        up: 'exit',
	        offset: 'bottom-in-view'
	      }, {
	        down: 'exit',
	        up: 'entered',
	        offset: 0
	      }, {
	        down: 'exited',
	        up: 'enter',
	        offset: function() {
	          return -this.adapter.outerHeight()
	        }
	      }],
	      horizontal: [{
	        right: 'enter',
	        left: 'exited',
	        offset: '100%'
	      }, {
	        right: 'entered',
	        left: 'exit',
	        offset: 'right-in-view'
	      }, {
	        right: 'exit',
	        left: 'entered',
	        offset: 0
	      }, {
	        right: 'exited',
	        left: 'enter',
	        offset: function() {
	          return -this.adapter.outerWidth()
	        }
	      }]
	    }
	
	    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
	      var config = configs[this.axis][i]
	      this.createWaypoint(config)
	    }
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoint = function(config) {
	    var self = this
	    this.waypoints.push(new Waypoint({
	      context: this.options.context,
	      element: this.options.element,
	      enabled: this.options.enabled,
	      handler: (function(config) {
	        return function(direction) {
	          self.options[config[direction]].call(self, direction)
	        }
	      }(config)),
	      offset: config.offset,
	      horizontal: this.options.horizontal
	    }))
	  }
	
	  /* Public */
	  Inview.prototype.destroy = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].destroy()
	    }
	    this.waypoints = []
	  }
	
	  Inview.prototype.disable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].disable()
	    }
	  }
	
	  Inview.prototype.enable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].enable()
	    }
	  }
	
	  Inview.defaults = {
	    context: window,
	    enabled: true,
	    enter: noop,
	    entered: noop,
	    exit: noop,
	    exited: noop
	  }
	
	  Waypoint.Inview = Inview
	}())
	;

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    isIOS: function isIOS() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
	    },
	    getBodyScrollTop: function getBodyScrollTop() {
	        return self.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop;
	    },
	    getBodyMiddlePos: function getBodyMiddlePos() {
	        return this.getBodyScrollTop() + document.documentElement.clientHeight * 0.5;
	    },
	    //узнать настоящую полную высоту блока с заданным max-height
	    getTrueHeight: function getTrueHeight($block) {
	        var el = $block.clone().css({
	            height: 'auto',
	            width: $block.width(),
	            overflow: 'hidden',
	            'max-height': 'none'
	        }).insertAfter($block);
	
	        var trueHeight = el.outerHeight(true);
	        el.remove();
	
	        return trueHeight;
	    },
	    number_format: __webpack_require__(164),
	
	    setMaskedPhone: function setMaskedPhone($element) {
	        $element.mask('+7(999)999-99-99', { autoclear: false });
	    },
	    setMaskedPhoneCity: function setMaskedPhoneCity($element) {
	        $element.mask('+7(999)999-99-99 (городской)', { autoclear: false });
	    },
	    setMaskedPhoneMobile: function setMaskedPhoneMobile($element) {
	        $element.mask('+7(999)999-99-99 (мобильный)', { autoclear: false });
	    },
	
	    getCookie: function getCookie(name) {
	        var matches = document.cookie.match('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
	        return matches ? decodeURIComponent(matches[1]) : undefined;
	    },
	
	    setCookie: function setCookie(name, value, options) {
	        options = options || {};
	
	        var expires = options.expires;
	
	        if (typeof expires == 'number' && expires) {
	            var d = new Date();
	            d.setTime(d.getTime() + expires * 1000);
	            expires = options.expires = d;
	        }
	        if (expires && expires.toUTCString) {
	            options.expires = expires.toUTCString();
	        }
	
	        value = encodeURIComponent(value);
	
	        var updatedCookie = name + '=' + value;
	
	        for (var propName in options) {
	            updatedCookie += '; ' + propName;
	            var propValue = options[propName];
	            if (propValue !== true) {
	                updatedCookie += '=' + propValue;
	            }
	        }
	
	        document.cookie = updatedCookie;
	    },
	    deleteCookie: function deleteCookie(name) {
	        var cookie_date = new Date();
	        cookie_date.setTime(cookie_date.getTime() - 1);
	        document.cookie = name += "=; expires=" + cookie_date.toGMTString();
	    }
	};

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function number_format(number, decimals, decPoint, thousandsSep) {
	  // eslint-disable-line camelcase
	  //  discuss at: https://locutus.io/php/number_format/
	  // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // improved by: davook
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Theriault (https://github.com/Theriault)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // bugfixed by: Michael White (https://getsprink.com)
	  // bugfixed by: Benjamin Lupton
	  // bugfixed by: Allan Jensen (https://www.winternet.no)
	  // bugfixed by: Howard Yeend
	  // bugfixed by: Diogo Resende
	  // bugfixed by: Rival
	  // bugfixed by: Brett Zamir (https://brett-zamir.me)
	  //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  //  revised by: Luke Smith (https://lucassmith.name)
	  //    input by: Kheang Hok Chin (https://www.distantia.ca/)
	  //    input by: Jay Klehr
	  //    input by: Amir Habibi (https://www.residence-mixte.com/)
	  //    input by: Amirouche
	  //   example 1: number_format(1234.56)
	  //   returns 1: '1,235'
	  //   example 2: number_format(1234.56, 2, ',', ' ')
	  //   returns 2: '1 234,56'
	  //   example 3: number_format(1234.5678, 2, '.', '')
	  //   returns 3: '1234.57'
	  //   example 4: number_format(67, 2, ',', '.')
	  //   returns 4: '67,00'
	  //   example 5: number_format(1000)
	  //   returns 5: '1,000'
	  //   example 6: number_format(67.311, 2)
	  //   returns 6: '67.31'
	  //   example 7: number_format(1000.55, 1)
	  //   returns 7: '1,000.6'
	  //   example 8: number_format(67000, 5, ',', '.')
	  //   returns 8: '67.000,00000'
	  //   example 9: number_format(0.9, 0)
	  //   returns 9: '1'
	  //  example 10: number_format('1.20', 2)
	  //  returns 10: '1.20'
	  //  example 11: number_format('1.20', 4)
	  //  returns 11: '1.2000'
	  //  example 12: number_format('1.2000', 3)
	  //  returns 12: '1.200'
	  //  example 13: number_format('1 000,50', 2, '.', ' ')
	  //  returns 13: '100 050.00'
	  //  example 14: number_format(1e-8, 8, '.', '')
	  //  returns 14: '0.00000001'
	
	  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	  var n = !isFinite(+number) ? 0 : +number;
	  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	  var s = '';
	
	  var toFixedFix = function toFixedFix(n, prec) {
	    if (('' + n).indexOf('e') === -1) {
	      return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
	    } else {
	      var arr = ('' + n).split('e');
	      var sig = '';
	      if (+arr[1] + prec > 0) {
	        sig = '+';
	      }
	      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
	    }
	  };
	
	  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
	  if (s[0].length > 3) {
	    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	  }
	  if ((s[1] || '').length < prec) {
	    s[1] = s[1] || '';
	    s[1] += new Array(prec - s[1].length + 1).join('0');
	  }
	
	  return s.join(dec);
	};
	//# sourceMappingURL=number_format.js.map

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	__webpack_require__(221);
	var functions = __webpack_require__(163);
	
	var Basket = (function () {
	    /**
	     * В конструктор передается изменямый элемент
	     * @param element {HTMLElement}
	     */
	
	    function Basket(element) {
	        _classCallCheck(this, Basket);
	
	        this.element = $(element);
	        this.curItem = this.element.closest('.cart__item');
	        this.alsoItems = this.curItem.find('.cart__also-items');
	    }
	
	    /**
	     * Анимация показать сопуствующие товары
	     */
	
	    _createClass(Basket, [{
	        key: 'animateShowAlso',
	        value: function animateShowAlso() {
	            var $alsoItems = this.alsoItems;
	            this.alsoItems.css('max-height', 0).addClass('cart__also-items--visible');
	
	            var trueHeight = functions.getTrueHeight(this.alsoItems);
	
	            this.alsoItems.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $alsoItems.addClass('no-transition').css('max-height', 'none');
	            }, 550);
	
	            this.curItem.find('.js-cart-show-also-items').addClass('cart__also-link--hidden');
	            this.curItem.find('.js-cart-hide-also-items').removeClass('cart__also-link--hidden');
	        }
	
	        /**
	         * Анимация скрыть сопуствующие товары
	         */
	    }, {
	        key: 'animateHideAlso',
	        value: function animateHideAlso() {
	            var $alsoItems = this.alsoItems;
	            this.alsoItems.css('max-height', this.alsoItems.height() + 'px');
	
	            setTimeout(function () {
	                $alsoItems.removeClass('no-transition').css('max-height', 0);
	            }, 25);
	
	            setTimeout(function () {
	                $alsoItems.removeClass('cart__also-items--visible');
	            }, 550);
	
	            this.curItem.find('.js-cart-show-also-items').removeClass('cart__also-link--hidden');
	            this.curItem.find('.js-cart-hide-also-items').addClass('cart__also-link--hidden');
	        }
	
	        /**
	         * Анимация удалить товар
	         */
	    }, {
	        key: 'animateDeleteProduct',
	        value: function animateDeleteProduct() {
	            var $curItem = this.curItem;
	            var $to = $('<div class="cart__item cart__item--empty" />').insertAfter(this.curItem);
	
	            this.curItem.width(this.curItem.width());
	
	            $to.height(this.curItem.height());
	            this.curItem.css('top', this.curItem.position().top).addClass('cart__item--abs cart__item--deleting');
	            $curItem.remove();
	            $to.animate({ height: 0 }, 350, function () {
	                $to.remove();
	            });
	        }
	
	        /**
	         * Ajax запрос на обновление количества товара в корзине
	         * @param productId {number} - Ид товара
	         * @param quantity {number} Количество
	         * @param parentProductId {number} Ид товара родителя у связанных товаров
	         */
	    }, {
	        key: 'updateProductQuantity',
	        value: function updateProductQuantity(productId, quantity, parentProductId) {
	            if (parentProductId == undefined) {
	                parentProductId = 0;
	            }
	            return $.ajax({
	                url: '/ajax/action/basket_add_popup/add_to_basket_ajax/',
	                data: 'PRODUCT_ID=' + productId + '&QUANTITY=' + quantity + '&PARENT_PRODUCT_ID=' + parentProductId
	            }).then(function (result) {
	                $('input[name="QUANTITY_' + productId + '"]').val(result.data['QUANTITY']);
	                window.updateMiniBasket();
	            });
	        }
	    }]);
	
	    return Basket;
	})();
	
	module.exports = Basket;
	
	jQuery(function () {
	    $(document).on('click', '.js-cart-show-also-items', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateShowAlso();
	    });
	
	    $(document).on('click', '.js-cart-hide-also-items', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateHideAlso();
	    });
	
	    $(document).on('click', '.js-delete-cart-item', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateDeleteProduct();
	    });
	});

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(238);
	__webpack_require__(249);
	module.exports = __webpack_require__(61).Array.from;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(239)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(240)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var defined = __webpack_require__(81);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var $export = __webpack_require__(59);
	var redefine = __webpack_require__(241);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(242);
	var $iterCreate = __webpack_require__(243);
	var setToStringTag = __webpack_require__(246);
	var getPrototypeOf = __webpack_require__(248);
	var ITERATOR = __webpack_require__(247)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(64);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(244);
	var descriptor = __webpack_require__(73);
	var setToStringTag = __webpack_require__(246);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(64)(IteratorPrototype, __webpack_require__(247)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(66);
	var dPs = __webpack_require__(75);
	var enumBugKeys = __webpack_require__(90);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(71)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(245).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(60).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(65).f;
	var has = __webpack_require__(74);
	var TAG = __webpack_require__(247)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(87)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(60).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(74);
	var toObject = __webpack_require__(139);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(62);
	var $export = __webpack_require__(59);
	var toObject = __webpack_require__(139);
	var call = __webpack_require__(250);
	var isArrayIter = __webpack_require__(251);
	var toLength = __webpack_require__(83);
	var createProperty = __webpack_require__(252);
	var getIterFn = __webpack_require__(253);
	
	$export($export.S + $export.F * !__webpack_require__(255)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(66);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(242);
	var ITERATOR = __webpack_require__(247)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(254);
	var ITERATOR = __webpack_require__(247)('iterator');
	var Iterators = __webpack_require__(242);
	module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(80);
	var TAG = __webpack_require__(247)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(247)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(257), __esModule: true };

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(258);
	__webpack_require__(238);
	__webpack_require__(259);
	__webpack_require__(263);
	__webpack_require__(276);
	__webpack_require__(277);
	module.exports = __webpack_require__(61).Promise;


/***/ }),
/* 258 */
/***/ (function(module, exports) {



/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260);
	var global = __webpack_require__(60);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(242);
	var TO_STRING_TAG = __webpack_require__(247)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(261);
	var step = __webpack_require__(262);
	var Iterators = __webpack_require__(242);
	var toIObject = __webpack_require__(78);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(240)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var global = __webpack_require__(60);
	var ctx = __webpack_require__(62);
	var classof = __webpack_require__(254);
	var $export = __webpack_require__(59);
	var isObject = __webpack_require__(67);
	var aFunction = __webpack_require__(63);
	var anInstance = __webpack_require__(264);
	var forOf = __webpack_require__(265);
	var speciesConstructor = __webpack_require__(266);
	var task = __webpack_require__(267).set;
	var microtask = __webpack_require__(269)();
	var newPromiseCapabilityModule = __webpack_require__(270);
	var perform = __webpack_require__(271);
	var userAgent = __webpack_require__(272);
	var promiseResolve = __webpack_require__(273);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(247)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(274)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(246)($Promise, PROMISE);
	__webpack_require__(275)(PROMISE);
	Wrapper = __webpack_require__(61)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(255)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(62);
	var call = __webpack_require__(250);
	var isArrayIter = __webpack_require__(251);
	var anObject = __webpack_require__(66);
	var toLength = __webpack_require__(83);
	var getIterFn = __webpack_require__(253);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(66);
	var aFunction = __webpack_require__(63);
	var SPECIES = __webpack_require__(247)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(62);
	var invoke = __webpack_require__(268);
	var html = __webpack_require__(245);
	var cel = __webpack_require__(71);
	var global = __webpack_require__(60);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(80)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var macrotask = __webpack_require__(267).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(80)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(63);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var isObject = __webpack_require__(67);
	var newPromiseCapability = __webpack_require__(270);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(64);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var dP = __webpack_require__(65);
	var DESCRIPTORS = __webpack_require__(69);
	var SPECIES = __webpack_require__(247)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(59);
	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var speciesConstructor = __webpack_require__(266);
	var promiseResolve = __webpack_require__(273);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(59);
	var newPromiseCapability = __webpack_require__(270);
	var perform = __webpack_require__(271);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(52);
	__webpack_require__(292);
	
	var functions = __webpack_require__(163);
	
	jQuery(function ($) {
	    var checkHeightLimitBlock = function checkHeightLimitBlock($block) {
	        if ($block == undefined) $block = $('.js-height-limit');
	
	        //блок должен быть Jquery объектом а не какой-то левой фигней
	        if ($block.bind !== $.prototype.bind) $block = $('.js-height-limit');
	
	        if ($block.length == 0) return;
	
	        if (!$block.hasClass('js-height-limit')) return;
	
	        $block.each(function () {
	            var $this = $(this);
	            if ($this.hasClass('height-limit--full')) return;
	
	            if (!$this.is(':visible')) return;
	
	            var maxHeight = parseInt($this.css('max-height'));
	            $this.removeClass('height-limit--visible');
	
	            if ($this.innerHeight() < maxHeight) $this.addClass('height-limit--visible');
	        });
	    };
	
	    $(document).on('click', '.js-height-limit-more', function (e) {
	        e.preventDefault();
	        var $block = $(this).closest('.height-limit');
	        var trueHeight = functions.getTrueHeight($block);
	
	        if ($block.hasClass('height-limit--full')) {
	            $block.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $block.removeAttr('style');
	                $block.removeClass('no-transition');
	            }, 25);
	
	            setTimeout(function () {
	                $block.removeClass('height-limit--full');
	            }, 400);
	        } else {
	            $block.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $block.addClass('height-limit--full no-transition').css('max-height', 'none');
	            }, 400);
	        }
	    });
	
	    debounce.setResizeDebounce(checkHeightLimitBlock);
	
	    module.exports.checkHeightLimitBlock = checkHeightLimitBlock;
	});

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(298);
	__webpack_require__(299);
	
	var dropFile = __webpack_require__(303);
	var styledSelect = __webpack_require__(306);
	var ratingStars = __webpack_require__(312);
	var functions = __webpack_require__(163);
	
	jQuery(function () {
	    $.prompt.setDefaults({
	        promptspeed: 0,
	        overlayspeed: 300,
	        opacity: 0.5,
	        closeText: 'Закрыть',
	        loaded: function loaded() {
	            var $jqi = $('.jqi');
	            $jqi.addClass('shown');
	        },
	        beforeclose: function beforeclose(e) {
	            var $box = $(e.target);
	            $box.find('.jqi').removeClass('shown');
	        },
	        statechanging: function statechanging() {
	            var $form = $('.jqiform');
	
	            //выключить валидатор, чтоб не глючил в момент переключения состояний
	            $form.off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
	        },
	        statechanged: function statechanged(event, toStateName) {
	            var $jqi = $('.jqi');
	            var $form = $('.jqiform');
	            var $styledSelects = $jqi.find('.js-styled-select:visible');
	            styledSelect.styleSelects($styledSelects);
	            functions.setMaskedPhone($('.js-masked-phone'));
	
	            if ($form.find('.js-rating-stars').length > 0) {
	                ratingStars.setStars($form.find('.js-rating-stars'));
	            }
	
	            $form.find('.form__input--error').removeClass('form__input--error');
	            $form.find('.form__error-msg').remove();
	
	            if (toStateName == 'regFormStep3_specialist') dropFile.setDropFile($('#diploma-dropfile'));
	
	            if (toStateName == 'regFormStep2_organization') dropFile.setDropFile($('#requisites-dropfile'));
	        },
	        closeDelay: 350,
	        buttons: {}
	    });
	
	    $.prompt.setStateDefaults({
	        buttons: {}
	    });
	});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(root.jQuery);
		}
	}(this, function($) {
		'use strict';
	
		// ########################################################################
		// Base object
		// ########################################################################
	
		/**
		* Imp - Impromptu object - passing no params will not open, only return the instance
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return Imp - the instance of this Impromptu object
		*/
		var Imp = function(message, options){
			var t = this;
			t.id = Imp.count++;
	
			Imp.lifo.push(t);
	
			if(message){
				t.open(message, options);
			}
			return t;
		};
	
		// ########################################################################
		// static properties and methods
		// ########################################################################
	
		/**
		* defaults - the default options
		*/
		Imp.defaults = {
			prefix:'jqi',
			classes: {
				box: '',
				fade: '',
				prompt: '',
				form: '',
				close: '',
				title: '',
				message: '',
				buttons: '',
				button: '',
				defaultButton: ''
			},
			title: '',
			closeText: '&times;',
			buttons: {
				Ok: true
			},
			buttonTimeout: 1000,
			loaded: function(e){},
			submit: function(e,v,m,f){},
			close: function(e,v,m,f){},
			beforeclose: function(e,v,m,f){},
			statechanging: function(e, from, to){},
			statechanged: function(e, to){},
			opacity: 0.6,
			zIndex: 999,
			overlayspeed: 'slow',
			promptspeed: 'fast',
			show: 'fadeIn',
			hide: 'fadeOut',
			focus: 0,
			defaultButton: 0,
			useiframe: false,
			top: '15%',
			position: {
				container: null,
				x: null,
				y: null,
				arrow: null,
				width: null
			},
			persistent: true,
			timeout: 0,
			closeDelay: 10,
			states: {},
			initialState: 0,
			state: {
				name: null,
				title: '',
				html: '',
				buttons: {
					Ok: true
				},
				focus: 0,
				defaultButton: 0,
				position: {
					container: null,
					x: null,
					y: null,
					arrow: null,
					width: null
				},
				submit: function(e,v,m,f){
					return true;
				}
			}
		};
	
		/**
		* setDefaults - Sets the default options
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setDefaults = function(o) {
			Imp.defaults = $.extend({}, Imp.defaults, o);
		};
	
		/**
		* setStateDefaults - Sets the default options for a state
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setStateDefaults = function(o) {
			Imp.defaults.state = $.extend({}, Imp.defaults.state, o);
		};
	
		/**
		* @var Int - A counter used to provide a unique ID for new prompts
		*/
		Imp.count = 0;
	
		/**
		* @var Array - An array of Impromptu intances in a LIFO queue (last in first out)
		*/
		Imp.lifo = [];
	
		/**
		* getLast - get the last element from the queue (doesn't pop, just returns)
		* @return Imp - the instance of this Impromptu object or false if queue is empty
		*/
		Imp.getLast = function(){
			var l = Imp.lifo.length;
			return (l > 0)? Imp.lifo[l-1] : false;
		};
	
		/**
		* removeFromStack - remove an element from the lifo stack by its id
		* @param id int - id of the instance to remove
		* @return api - The api of the element removed from the stack or void
		*/
		Imp.removeFromStack = function(id){
			for(var i=Imp.lifo.length-1; i>=0; i--){
				if(Imp.lifo[i].id === id){
					return Imp.lifo.splice(i,1)[0];
				}
			}
		};
	
		// ########################################################################
		// extend our object instance properties and methods
		// ########################################################################
		Imp.prototype = {
	
			/**
			* @var Int - A unique id, simply an autoincremented number
			*/
			id: null,
	
			/**
			* open - Opens the prompt
			* @param message String/Object - String of html or Object of states
			* @param options Object - Options to set the prompt
			* @return Imp - the instance of this Impromptu object
			*/
			open: function(message, options) {
				var t = this;
	
				t.options = $.extend(true,{},Imp.defaults,options);
	
				// Be sure any previous timeouts are destroyed
				if(t.timeout){
					clearTimeout(t.timeout);
				}
				t.timeout = false;
	
				var opts = t.options,
					$body = $(document.body),
					$window = $(window);
	
				//build the box and fade
				var msgbox = '<div class="'+ opts.prefix +'box '+ opts.classes.box +'">';
				if(opts.useiframe && ($('object, applet').length > 0)) {
					msgbox += '<iframe src="javascript:false;" class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></iframe>';
				} else {
					msgbox += '<div class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></div>';
				}
				msgbox += '<div class="'+ opts.prefix +' '+ opts.classes.prompt +'">'+
							'<form action="#" class="'+ opts.prefix +'form '+ opts.classes.form +'">'+
								'<div class="'+ opts.prefix +'close '+ opts.classes.close +'">'+ opts.closeText +'</div>'+
								'<div class="'+ opts.prefix +'states"></div>'+
							'</form>'+
						'</div>'+
					'</div>';
	
				t.jqib = $(msgbox).appendTo($body);
				t.jqi = t.jqib.children('.'+ opts.prefix);
				t.jqif = t.jqib.children('.'+ opts.prefix +'fade');
	
				//if a string was passed, convert to a single state
				if(message.constructor === String){
					message = {
						state0: {
							title: opts.title,
							html: message,
							buttons: opts.buttons,
							position: opts.position,
							focus: opts.focus,
							defaultButton: opts.defaultButton,
							submit: opts.submit
						}
					};
				}
	
				//build the states
				t.options.states = {};
				var k,v;
				for(k in message){
					v = $.extend({},Imp.defaults.state,{name:k},message[k]);
					t.addState(v.name, v);
	
					if(t.currentStateName === ''){
						t.currentStateName = v.name;
					}
				}
	
				//Events
				t.jqi.on('click', '.'+ opts.prefix +'buttons button', function(e){
					var $t = $(this),
						$state = $t.parents('.'+ opts.prefix +'state'),
						statename = $state.data('jqi-name'),
						stateobj = t.options.states[statename],
						msg = $state.children('.'+ opts.prefix +'message'),
						clicked = stateobj.buttons[$t.text()] || stateobj.buttons[$t.html()],
						forminputs = {};
	
					// disable for a moment to prevent multiple clicks
					if(t.options.buttonTimeout > 0){
						t.disableStateButtons(statename);
						setTimeout(function(){
							t.enableStateButtons(statename);
						}, t.options.buttonTimeout);
					}
	
					// if for some reason we couldn't get the value
					if(clicked === undefined){
						for(var i in stateobj.buttons){
							if(stateobj.buttons[i].title === $t.text() || stateobj.buttons[i].title === $t.html()){
								clicked = stateobj.buttons[i].value;
							}
						}
					}
	
					if (clicked === undefined)
					{
						clicked = $t.val();
					}
	
					//collect all form element values from all states.
					$.each(t.jqi.children('form').serializeArray(),function(i,obj){
						if (forminputs[obj.name] === undefined) {
							forminputs[obj.name] = obj.value;
						} else if (typeof forminputs[obj.name] === Array || typeof forminputs[obj.name] === 'object') {
							forminputs[obj.name].push(obj.value);
						} else {
							forminputs[obj.name] = [forminputs[obj.name],obj.value];
						}
					});
	
					// trigger an event
					var promptsubmite = new $.Event('impromptu:submit');
					promptsubmite.stateName = stateobj.name;
					promptsubmite.state = $state;
					$state.trigger(promptsubmite, [clicked, msg, forminputs]);
	
					if(!promptsubmite.isDefaultPrevented()){
						t.close(true, clicked,msg,forminputs);
					}
				});
	
				// if the fade is clicked blink the prompt
				var fadeClicked = function(){
					if(opts.persistent){
						var offset = (opts.top.toString().indexOf('%') >= 0? ($window.height()*(parseInt(opts.top,10)/100)) : parseInt(opts.top,10)),
							top = parseInt(t.jqi.css('top').replace('px',''),10) - offset;
	
						//$window.scrollTop(top);
						$('html,body').animate({ scrollTop: top }, 'fast', function(){
							var i = 0;
							t.jqib.addClass(opts.prefix +'warning');
							var intervalid = setInterval(function(){
								t.jqib.toggleClass(opts.prefix +'warning');
								if(i++ > 1){
									clearInterval(intervalid);
									t.jqib.removeClass(opts.prefix +'warning');
								}
							}, 100);
						});
					}
					else {
						t.close(true);
					}
				};
	
				// listen for esc or tab keys
				var keyDownEventHandler = function(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
	
					//escape key closes
					if(key === 27) {
						fadeClicked();
					}
	
					//enter key pressed trigger the default button if its not on it, ignore if it is a textarea
					if(key === 13){
						var $defBtn = t.getCurrentState().find('.'+ opts.prefix +'defaultbutton');
						var $tgt = $(e.target);
	
						if($tgt.is('textarea,.'+opts.prefix+'button') === false && $defBtn.length > 0){
							e.preventDefault();
							$defBtn.click();
						}
					}
	
					//constrain tabs, tabs should iterate through the state and not leave
					if (key === 9){
						var $inputels = $('input,select,textarea,button',t.getCurrentState());
						var fwd = !e.shiftKey && e.target === $inputels[$inputels.length-1];
						var back = e.shiftKey && e.target === $inputels[0];
						if (fwd || back) {
							setTimeout(function(){
								if (!$inputels){
									return;
								}
								var el = $inputels[back===true ? $inputels.length-1 : 0];
	
								if (el){
									el.focus();
								}
							},10);
							return false;
						}
					}
				};
	
				t.position();
				t.style();
	
				// store copy of the window resize function for interal use only
				t._windowResize = function(e){
					t.position(e);
				};
				$window.resize({ animate: false }, t._windowResize);
	
				t.jqif.click(fadeClicked);
				t.jqi.find('.'+ opts.prefix +'close').click(function(){ t.close(); });
				t.jqi.find('.'+ opts.prefix +'form').submit(function(){ return false; });
				t.jqib.on("keydown",keyDownEventHandler)
							.on('impromptu:loaded', opts.loaded)
							.on('impromptu:beforeclose', opts.beforeclose)
							.on('impromptu:close', opts.close)
							.on('impromptu:statechanging', opts.statechanging)
							.on('impromptu:statechanged', opts.statechanged);
	
				// Show it
				t.jqif[opts.show](opts.overlayspeed);
				t.jqi[opts.show](opts.promptspeed, function(){
	
					t.goToState(
						isNaN(opts.initialState) ? opts.initialState : 
							t.jqi.find('.'+ opts.prefix +'states .'+ opts.prefix +'state').eq(opts.initialState).data('jqi-name')
					);
	
					t.jqib.trigger('impromptu:loaded');
				});
	
				// Timeout
				if(opts.timeout > 0){
					t.timeout = setTimeout(function(){ t.close(true); },opts.timeout);
				}
	
				return t;
			},
	
			/**
			* close - Closes the prompt
			* @param callCallback Function - called when the transition is complete
			* @param clicked String - value of the button clicked (only used internally)
			* @param msg jQuery - The state message body (only used internally)
			* @param formvals Object - key/value pairs of all form field names and values (only used internally)
			* @return Imp - the instance of this Impromptu object
			*/
			close: function(callCallback, clicked, msg, formvals){
				var t = this;
				t.jqib.trigger('impromptu:beforeclose', [clicked,msg,formvals]);
	
				if(t.timeout){
					clearTimeout(t.timeout);
					t.timeout = false;
				}
				Imp.removeFromStack(t.id);
	
				setTimeout(function(){
					if(t.jqib){
	
						t.jqib[t.options.hide](t.options.promptspeed,function(){
	
							t.jqib.trigger('impromptu:close', [clicked,msg,formvals]);
	
							t.jqib.remove();
	
							$(window).off('resize', t._windowResize);
	
							if(typeof callCallback === 'function'){
								callCallback();
							}
						});
					}
	
				}, t.options.closeDelay);
	
				t.currentStateName = "";
				return t;
			},
	
			/**
			* addState - Injects a state into the prompt
			* @param statename String - Name of the state
			* @param stateobj Object - options for the state
			* @param afterState String - selector of the state to insert after
			* @return jQuery - the newly created state
			*/
			addState: function(statename, stateobj, afterState) {
				var t = this,
					state = '',
					$state = null,
					arrow = '',
					title = '',
					opts = t.options,
					pos = $.isFunction(stateobj.position) ? stateobj.position() : stateobj.position,
					$jqistates = t.jqi.find('.'+ opts.prefix +'states'),
					buttons = [],
					showHtml,defbtn,k,v,l,i=0;
	
				stateobj = $.extend({},Imp.defaults.state, {name:statename}, stateobj);
	
				if($.isPlainObject(pos) && pos.arrow !== null){
					arrow = '<div class="'+ opts.prefix + 'arrow '+ opts.prefix + 'arrow'+ pos.arrow +'"></div>';
				}
				if(stateobj.title && stateobj.title !== ''){
					title = '<div class="lead '+ opts.prefix + 'title '+ opts.classes.title +'">'+  stateobj.title +'</div>';
				}
	
				showHtml = stateobj.html;
				if (typeof stateobj.html === 'function') {
					showHtml = 'Error: html function must return text';
				}
	
				state += '<div class="'+ opts.prefix + 'state" data-jqi-name="'+ statename +'">'+
							arrow + title +
							'<div class="'+ opts.prefix +'message '+ opts.classes.message +'">' + showHtml +'</div>'+
							'<div class="'+ opts.prefix +'buttons'+ ($.isEmptyObject(stateobj.buttons)? 'hide ':' ') + opts.classes.buttons +'">';
	
				// state buttons may be in object or array, lets convert objects to arrays
				if($.isArray(stateobj.buttons)){
					buttons = stateobj.buttons;
				}
				else if($.isPlainObject(stateobj.buttons)){
					for(k in stateobj.buttons){
						if(stateobj.buttons.hasOwnProperty(k)){
							buttons.push({ title: k, value: stateobj.buttons[k] });
						}
					}
				}
	
				// iterate over each button and create them
				for(i=0, l=buttons.length; i<l; i++){
					v = buttons[i],
					defbtn = stateobj.focus === i || (isNaN(stateobj.focus) && stateobj.defaultButton === i) ? (opts.prefix + 'defaultbutton ' + opts.classes.defaultButton) : '';
	
					state += '<button class="'+ opts.classes.button +' '+ opts.prefix + 'button '+ defbtn;
	
					if(typeof v.classes !== "undefined"){
						state += ' '+ ($.isArray(v.classes)? v.classes.join(' ') : v.classes) + ' ';
					}
	
					state += '" name="' + opts.prefix + '_' + statename + '_button' + v.title.replace(/[^a-z0-9]+/gi,'') + '" value="' + v.value + '">' + v.title + '</button>';
				}
				
				state += '</div></div>';
	
				$state = $(state).css({display:'none'});
	
				$state.on('impromptu:submit', stateobj.submit);
	
				if(afterState !== undefined){
					t.getState(afterState).after($state);
				}
				else{
					$jqistates.append($state);
				}
	
				t.options.states[statename] = stateobj;
	
				return $state;
			},
	
			/**
			* removeState - Removes a state from the prompt
			* @param state String - Name of the state
			* @param newState String - Name of the state to transition to
			* @return Boolean - returns true on success, false on failure
			*/
			removeState: function(state, newState) {
				var t = this,
					$state = t.getState(state),
					rm = function(){ $state.remove(); };
	
				if($state.length === 0){
					return false;
				}
	
				// transition away from it before deleting
				if($state.css('display') !== 'none'){
					if(newState !== undefined && t.getState(newState).length > 0){
						t.goToState(newState, false, rm);
					}
					else if($state.next().length > 0){
						t.nextState(rm);
					}
					else if($state.prev().length > 0){
						t.prevState(rm);
					}
					else{
						t.close();
					}
				}
				else{
					$state.slideUp('slow', rm);
				}
	
				return true;
			},
	
			/**
			* getApi - Get the api, so you can extract it from $.prompt stack
			* @return jQuery - the prompt
			*/
			getApi: function() {
				return this;
			},
	
			/**
			* getBox - Get the box containing fade and prompt
			* @return jQuery - the prompt
			*/
			getBox: function() {
				return this.jqib;
			},
	
			/**
			* getPrompt - Get the prompt
			* @return jQuery - the prompt
			*/
			getPrompt: function() {
				return this.jqi;
			},
	
			/**
			* getState - Get the state by its name
			* @param statename String - Name of the state
			* @return jQuery - the state
			*/
			getState: function(statename) {
				return this.jqi.find('[data-jqi-name="'+ statename +'"]');
			},
	
			/**
			* getCurrentState - Get the current visible state
			* @return jQuery - the current visible state
			*/
			getCurrentState: function() {
				return this.getState(this.getCurrentStateName());
			},
	
			/**
			* getCurrentStateName - Get the name of the current visible state/substate
			* @return String - the current visible state's name
			*/
			getCurrentStateName: function() {
				return this.currentStateName;
			},
	
			/**
			* disableStateButtons - Disables the buttons in a state
			* @param statename String - Name of the state containing buttons
			* @param buttons Array - Array of button values to disable. By default all are disabled
			* @param enable Boolean - True to enable the buttons instead of disabling (internally use only)
			* @return Void
			*/
			disableStateButtons: function(statename, buttons, enable) {
				var t = this;
	
				if($.isArray(statename)){
					buttons = statename;
					statename = null;
				}
				
				t.getState(statename || t.getCurrentStateName()).find('.'+ t.options.prefix + 'button').each(function(i,btn){
					if(buttons === undefined || $.inArray(btn.value, buttons) !== -1){
						btn.disabled = !enable;
					}
				});
			},
	
			/**
			* enableStateButtons - Enables the buttons in a state
			* @param statename String - Name of the state containing buttons. Defaults to current state
			* @param buttons Array - Array of button values to enable. By default all are enabled
			* @return Void
			*/
			enableStateButtons: function(statename, buttons) {
				this.disableStateButtons(statename, buttons, true);
			},
	
			/**
			* position - Repositions the prompt (Used internally)
			* @return void
			*/
			position: function(e){
				var t = this,
					restoreFx = $.fx.off,
					$state = t.getCurrentState(),
					stateObj = t.options.states[$state.data('jqi-name')],
					pos = stateObj ? $.isFunction(stateObj.position) ? stateObj.position() : stateObj.position : undefined,
					$window = $(window),
					bodyHeight = document.body.scrollHeight, //$(document.body).outerHeight(true),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					height = (bodyHeight > windowHeight) ? bodyHeight : windowHeight,
					scrollTop = parseInt($window.scrollTop(),10),
					top = scrollTop + (t.options.top.toString().indexOf('%') >= 0?
							(windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
				// when resizing the window turn off animation
				if(e !== undefined && e.data.animate === false){
					$.fx.off = true;
				}
	
				t.jqib.css({
					position: "absolute",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
				t.jqif.css({
					position: "fixed",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
	
				// tour positioning
				if(pos && pos.container){
					var offset = $(pos.container).offset(),
						hasScrolled = false;
						
					if($.isPlainObject(offset) && offset.top !== undefined){
						top = (offset.top + pos.y) - (t.options.top.toString().indexOf('%') >= 0? (windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
						t.jqi.css({
							position: "absolute"
						});
						t.jqi.animate({
							top: offset.top + pos.y,
							left: offset.left + pos.x,
							marginLeft: 0,
							width: (pos.width !== undefined)? pos.width : null
						}, function(){
							// if it didn't scroll before, check that the bottom is within view. Since width 
							// is animated we must use the callback before we know the height
							if(!hasScrolled && (offset.top + pos.y + t.jqi.outerHeight(true)) > (scrollTop + windowHeight)){
								$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
								hasScrolled = true;
							}
						});
	
						// scroll if the top is out of the viewing area
						if(top < scrollTop || top > scrollTop + windowHeight){
							$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
							hasScrolled = true;
						}
					}
				}
				// custom state width animation
				else if(pos && pos.width){
					t.jqi.css({
							position: "absolute",
							left: '50%'
						});
					t.jqi.animate({
							top: pos.y || top,
							left: pos.x || '50%',
							marginLeft: ((pos.width/2)*-1),
							width: pos.width
						});
				}
				// standard prompt positioning
				else{
					t.jqi.css({
						position: "absolute",
						top: top,
						left: '50%',//$window.width()/2,
						marginLeft: ((t.jqi.outerWidth(false)/2)*-1)
					});
				}
	
				// restore fx settings
				if(e !== undefined && e.data.animate === false){
					$.fx.off = restoreFx;
				}
			},
	
			/**
			* style - Restyles the prompt (Used internally)
			* @return void
			*/
			style: function(){
				var t = this;
				
				t.jqif.css({
					zIndex: t.options.zIndex,
					display: "none",
					opacity: t.options.opacity
				});
				t.jqi.css({
					zIndex: t.options.zIndex+1,
					display: "none"
				});
				t.jqib.css({
					zIndex: t.options.zIndex
				});
			},
	
			/**
			* goToState - Goto the specified state
			* @param state String - name of the state to transition to
			* @param subState Boolean - true to be a sub state within the currently open state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			goToState: function(state, subState, callback) {
				var t = this,
					$jqi = t.jqi,
					jqiopts = t.options,
					$state = t.getState(state),
					stateobj = jqiopts.states[$state.data('jqi-name')],
					promptstatechanginge = new $.Event('impromptu:statechanging'),
					opts = t.options;
	
				if(stateobj !== undefined){
	
	
					if (typeof stateobj.html === 'function') {
						var contentLaterFunc = stateobj.html;
						$state.find('.' + opts.prefix +'message ').html(contentLaterFunc());
					}
	
					// subState can be ommitted
					if(typeof subState === 'function'){
						callback = subState;
						subState = false;
					}
	
					t.jqib.trigger(promptstatechanginge, [t.getCurrentStateName(), state]);
	
					if(!promptstatechanginge.isDefaultPrevented() && $state.length > 0){
						t.jqi.find('.'+ opts.prefix +'parentstate').removeClass(opts.prefix +'parentstate');
	
						if(subState){ // hide any open substates
							// get rid of any substates
							t.jqi.find('.'+ opts.prefix +'substate').not($state)
								.slideUp(jqiopts.promptspeed)
								.removeClass('.'+ opts.prefix +'substate')
								.find('.'+ opts.prefix +'arrow').hide();
	
							// add parent state class so it can be visible, but blocked
							t.jqi.find('.'+ opts.prefix +'state:visible').addClass(opts.prefix +'parentstate');
	
							// add substate class so we know it will be smaller
							$state.addClass(opts.prefix +'substate');
						}
						else{ // hide any open states
							t.jqi.find('.'+ opts.prefix +'state').not($state)
								.slideUp(jqiopts.promptspeed)
								.find('.'+ opts.prefix +'arrow').hide();
						}
						t.currentStateName = stateobj.name;
	
						$state.slideDown(jqiopts.promptspeed,function(){
							var $t = $(this);
							t.enableStateButtons();
							
							// if focus is a selector, find it, else its button index
							if(typeof(stateobj.focus) === 'string'){
								$t.find(stateobj.focus).eq(0).focus();
							}
							else{
								$t.find('.'+ opts.prefix +'defaultbutton').focus();
							}
	
							$t.find('.'+ opts.prefix +'arrow').show(jqiopts.promptspeed);
	
							if (typeof callback === 'function'){
								t.jqib.on('impromptu:statechanged', callback);
							}
							t.jqib.trigger('impromptu:statechanged', [state]);
							if (typeof callback === 'function'){
								t.jqib.off('impromptu:statechanged', callback);
							}
						});
						if(!subState){
							t.position();
						}
					} // end isDefaultPrevented()	
				}// end stateobj !== undefined
	
				return $state;
			},
	
			/**
			* nextState - Transition to the next state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			nextState: function(callback) {
				var t = this,
					$next = t.getCurrentState().next();
				if($next.length > 0){
					t.goToState( $next.data('jqi-name'), callback );
				}
				return $next;
			},
	
			/**
			* prevState - Transition to the previous state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			prevState: function(callback) {
				var t = this,
					$prev = t.getCurrentState().prev();
				if($prev.length > 0){
					t.goToState( $prev.data('jqi-name'), callback );
				}
				return $prev;
			}
	
		};
	
		// ########################################################################
		// $.prompt will manage a queue of Impromptu instances
		// ########################################################################
	
		/**
		* $.prompt create a new Impromptu instance and push it on the stack of instances
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return jQuery - the jQuery object of the prompt within the modal
		*/
		$.prompt = function(message, options){
			var api = new Imp(message, options);
			return api.jqi;
		};
	
		/**
		* Copy over static methods
		*/
		$.each(Imp, function(k,v){
			$.prompt[k] = v;
		});
	
		/**
		* Create a proxy for accessing all instance methods. The close method pops from queue.
		*/
		$.each(Imp.prototype, function(k,v){
			$.prompt[k] = function(){
				var api = Imp.getLast(); // always use the last instance on the stack
	
				if(api && typeof api[k] === "function"){
					return api[k].apply(api, arguments);
				}
			};
		});
	
		// ########################################################################
		// jQuery Plugin and public access
		// ########################################################################
	
		/**
		* Enable using $('.selector').prompt({});
		* This will grab the html within the prompt as the prompt message
		*/
		$.fn.prompt = function(options){
			if(options === undefined){
				options = {};
			}
			if(options.withDataAndEvents === undefined){
				options.withDataAndEvents = false;
			}
	
			$.prompt($(this).clone(options.withDataAndEvents).html(),options);
		};
	
		/**
		* Export it as Impromptu and $.prompt
		* Can be used from here forth as new Impromptu(states, opts)
		*/
		window.Impromptu = Imp;
	
	}));


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(304);
	
	// reference: https://css-tricks.com/drag-and-drop-file-uploading/
	
	jQuery(function () {
	    // feature detection for drag&drop upload
	    var isAdvancedUpload = (function () {
	        var div = document.createElement('div');
	        return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
	    })();
	
	    module.exports.setDropFile = function ($dropContainer) {
	        // applying the effect for every form
	        $dropContainer.each(function () {
	            var $this = $(this),
	                $input = $this.find('input[type="file"]'),
	                $textContainer = $this.find('.drop-file__text'),
	
	            //$errorMsg	 = $this.find( '.box__error span' ),
	            droppedFiles = false,
	                showFiles = function showFiles(files) {
	                var $fileName = $textContainer.find('.drop-file__filename');
	                if ($fileName.length == 0) {
	                    $textContainer.append('<div class="drop-file__filename" />');
	                    $fileName = $textContainer.find('.drop-file__filename');
	                }
	
	                $fileName.text(files.length > 1 ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name);
	            };
	
	            // letting the server side to know we are going to make an Ajax request
	            //$this.append( '<input type="hidden" name="ajax" value="1" />' );
	
	            // automatically submit the form on file select
	            $input.on('change', function (e) {
	                showFiles(e.target.files);
	            });
	
	            // drag&drop files if the feature is available
	            if (isAdvancedUpload) {
	                $this.addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
	                .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
	                    // preventing the unwanted behaviours
	                    e.preventDefault();
	                    e.stopPropagation();
	                }).on('dragover dragenter', function () //
	                {
	                    $this.addClass('is-dragover');
	                }).on('dragleave dragend drop', function () {
	                    $this.removeClass('is-dragover');
	                }).on('drop', function (e) {
	                    droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
	                    showFiles(droppedFiles);
	                });
	            }
	        });
	    };
	});

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(307);
	__webpack_require__(309);
	
	var styleSelects = function styleSelects($select) {
	    $select.each(function () {
	        var $this = $(this);
	
	        $this.select2({
	            language: 'ru',
	            minimumResultsForSearch: Infinity,
	            dropdownParent: $this.parent()
	        }).on('select2:open', function () {
	            var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	
	            $options.mCustomScrollbar('destroy');
	            $options.mCustomScrollbar('update');
	
	            setTimeout(function () {
	                $options.mCustomScrollbar({
	                    axis: 'y',
	                    scrollbarPosition: 'inside',
	                    advanced: {
	                        updateOnContentResize: true
	                    },
	                    live: true
	                });
	            }, 0);
	        });
	    });
	};
	
	module.exports.styleSelects = styleSelects;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(310);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(313);
	
	jQuery(function () {
	    var setStars = function setStars($ratingStars) {
	        if ($ratingStars == undefined) $ratingStars = $('.js-rating-stars');
	
	        var $elementRate = $ratingStars.find('.rating-stars__star-yellow');
	        var curSelectedValElementRate = $elementRate.filter('.rating-stars__star-yellow--filled').length;
	
	        $ratingStars.each(function () {
	            var $this = $ratingStars;
	            var $stars = $this.find('.rating-stars__star');
	            var $input = $this.find('.rating-stars__hidden-value');
	
	            var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	            if (curSelectedVal >= 1) curSelectedVal -= 1;
	
	            $stars.hover(function () {
	                var $curStar = $(this);
	                $stars.removeClass('rating-stars__star--filled');
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--hover');
	            }, function () {
	                $stars.removeClass('rating-stars__star--hover');
	                $stars.slice(0, curSelectedVal).addClass('rating-stars__star--filled');
	            });
	
	            $stars.click(function () {
	                var $curStar = $(this);
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--filled');
	
	                curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	                $input.val(curSelectedVal);
	            });
	
	            if (curSelectedValElementRate >= 1) curSelectedValElementRate -= 1;
	
	            $elementRate.hover(function () {
	                var $curStar = $(this);
	                $elementRate.removeClass('rating-stars__star-yellow--filled');
	                $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--hover');
	            }, function () {
	                $elementRate.removeClass('rating-stars__star-yellow--hover');
	                $elementRate.slice(0, curSelectedValElementRate).addClass('rating-stars__star-yellow--filled');
	            });
	        });
	    };
	
	    setStars();
	
	    module.exports.setStars = setStars;
	});
	
	/* При клике на звездочку устаналиваем оценку для элемента */
	$('.js-rating-stars').find('.rating-stars__star-yellow').one('click', function () {
	    var $curStar = $(this);
	    $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--filled');
	    $.ajax({
	        url: '/ajax/action/element_rate/add/',
	        data: 'rating=' + $('.js-rating-stars').find('.rating-stars__star-yellow').filter('.rating-stars__star-yellow--filled').length + '&element_id=' + $('input[name="rate_element_id"]').val() + '&entity_id=' + $('input[name="rate_entity_id"]').val(),
	        success: function success() {
	            $.ajax({
	                url: '/ajax/component/maximaster:element.rate/element/',
	                data: 'ENTITY_ID=' + $('input[name="rate_entity_id"]').val() + '&ELEMENT_ID=' + $('input[name="rate_element_id"]').val(),
	                success: function success(result) {
	                    $('.product-card__element_rate-container').html(result.html);
	                }
	            });
	        }
	    });
	});
	
	/* Вызываем окно авторизации, если кликает не авторизированный пользователь */
	$(document).on('click', '.js-rating-show-auth', function () {
	    if (!$('.jqi').hasClass('shown')) {
	        $('.js-jqi-show-login').trigger('click');
	    }
	});

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(316);
	var functions = __webpack_require__(163);
	
	jQuery(function () {
	    module.exports.formValidateDefaults = {
	        errorPlacement: function errorPlacement(error, element) {
	            element.addClass('form__input--error');
	            element.removeClass('form__input--correct');
	            var $elParent = element.parent();
	            $elParent.removeClass('icon-field--correct');
	            error.addClass('form__error-msg');
	
	            if (element.attr('type') == 'checkbox' || element.attr('type') == 'radio' || element.attr('type') == 'file') {
	                var $formField = element.closest('.form__field');
	                var $headlabel = $formField.find('.prompt__head-label').first();
	                error.addClass('form__error-msg--custom');
	
	                if ($headlabel.length > 0) {
	                    error.insertAfter($headlabel);
	                } else {
	                    $formField.prepend(error);
	                }
	            } else {
	                error.insertBefore($elParent);
	            }
	        },
	        focusInvalid: false,
	        onkeyup: false,
	        success: function success(label, element) {
	            label.remove();
	            var $el = $(element).removeClass('form__input--error');
	            $el.addClass('form__input--correct');
	            var $elParent = $el.parent();
	            $elParent.addClass('icon-field--correct');
	        },
	        errorElement: 'div',
	        onclick: false
	    };
	
	    functions.setMaskedPhone($('.js-masked-phone'));
	    functions.setMaskedPhoneCity($('.js-masked-phone-city'));
	    functions.setMaskedPhoneMobile($('.js-masked-phone-mobile'));
	});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Адаптер для класса MCTWidget коллтрекинга
	 * на странице необходимо подключение скрипта
	 * <script type="text/javascript" src="//widget.mango-office.ru/js/c-t-w.min.js"></script>
	 *
	 * @param a
	 * @constructor
	 */
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	function MCTWidgetAdapter() {
	    window.MCTWidget.apply(this, arguments);
	    var $this = this;
	
	    /**
	     * Перезагрузка метода формирования виджета
	     * заменяем телефон так как нам надо
	     *
	     * @param phone {string}
	     */
	    this.buildWidget = function (phone) {
	        var phoneClean = phone.replace(/[() -]/g, '');
	        if ($this.elem.getAttribute('href')) {
	            $this.elem.setAttribute('href', 'tel:' + phoneClean);
	        } else {
	            var link = document.createElement('a');
	            link.className = 'city-data-block__phones-link';
	            link.setAttribute('href', 'tel:' + phoneClean);
	            link.innerText = phone;
	            $this.elem.innerHTML = '';
	            $this.elem.insertBefore(link, $this.elem.firstChild);
	        }
	    };
	}
	
	var Mango = (function () {
	    function Mango() {
	        _classCallCheck(this, Mango);
	
	        this.elements = document.getElementsByClassName('m-call-tracking-widget');
	        this.host = window.location.protocol + '//widget.mango-office.ru';
	    }
	
	    _createClass(Mango, [{
	        key: 'init',
	        value: function init() {
	            for (var i = 0; i < this.elements.length; i++) {
	                var element = this.elements[i];
	                if ('true' !== element.getAttribute('init')) {
	                    var widget = new MCTWidgetAdapter({
	                        host: this.host,
	                        elem: element
	                    });
	                    widget.initWidget();
	                    element.setAttribute('init', 'true');
	                }
	            }
	        }
	    }]);
	
	    return Mango;
	})();
	
	exports['default'] = Mango;
	module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */,
/* 369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */,
/* 371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */,
/* 375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */,
/* 377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */,
/* 379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */,
/* 381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */,
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(384);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-show-auth-links-block').click(function () {
	        if (window.innerWidth >= size.desktop) {
	            var $this = $(this);
	            var $links = $this.find('.personal-block__links');
	
	            $links.show();
	            setTimeout(function () {
	                $this.addClass('personal-block--hover');
	            }, 100);
	        }
	    });
	
	    $(document).click(function (e) {
	        var $personalBlock = $('.js-show-auth-links-block');
	        var $links = $personalBlock.find('.personal-block__links');
	
	        var $target = $(e.target);
	
	        if ($target.is($personalBlock) || $target.closest('.js-show-auth-links-block').length > 0) return;
	
	        $personalBlock.removeClass('personal-block--hover');
	        setTimeout(function () {
	            $links.hide();
	        }, 350);
	    });
	});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */,
/* 386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */,
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Promise = __webpack_require__(256)['default'];
	
	var updateMiniBasket = function updateMiniBasket() {
	    var p = $.ajax({
	        url: '/ajax/component/maximaster:small.basket.widget/'
	    });
	    var p2 = $.ajax({
	        url: '/ajax/component/maximaster:small.basket.widget/cart-preview/'
	    });
	
	    _Promise.all([p, p2]).then(function (data) {
	        var selectors = ['.js-cart-preview-head', '.js-cart-preview'];
	        for (var i in selectors) {
	            var html = data[i]['html'];
	            if (html) {
	                $(selectors[i]).html(html);
	            }
	        }
	    });
	};
	
	window.updateMiniBasket = updateMiniBasket;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */,
/* 391 */,
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(393);
	
	jQuery(function () {
	    $('.js-city-guess-hide').click(function () {
	        $.ajax({
	            url: '/ajax/action/region_widget/setCookie/',
	            data: 'code=' + $(this).data('code')
	        });
	        $(this).closest('.city-data-block__city-guess').fadeOut(300);
	    });
	});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */,
/* 395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(398);
	
	jQuery(function () {
	    $('.js-topmenu-item-dropdown').hover(function () {
	        var $this = $(this);
	        var $dropdown = $this.find('.topmenu__dropdown');
	
	        if ($dropdown.length > 0) {
	            $dropdown.stop().slideDown(200);
	        }
	    }, function () {
	        var $this = $(this);
	        var $dropdown = $this.find('.topmenu__dropdown');
	
	        if ($dropdown.length > 0) {
	            $dropdown.stop().slideUp(200);
	        }
	    });
	});

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */,
/* 400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */,
/* 412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(423);
	
	jQuery(function () {
	    function updateBaseHeight() {
	        var $mobileMenu = $('.mobilemenu');
	        var $base = $mobileMenu.closest('body');
	        var $baseContent = $base.find('.main-container');
	
	        $mobileMenu.addClass('autoheight');
	
	        if ($mobileMenu.innerHeight() > $baseContent.innerHeight()) $base.css('min-height', $mobileMenu.innerHeight() + 'px');
	        $mobileMenu.removeClass('autoheight');
	    }
	    function createMobileMenu() {
	        var $existedMobileMenu = $('.mobilemenu');
	        if ($existedMobileMenu.length > 0) return $existedMobileMenu;
	        var $mobileMenu = $('<div class="mobilemenu" />');
	        var $closeButton = $('<div class="mobilemenu__close-button js-closemobile" />');
	
	        var innerParentText = $('.js-topmenu__main-link--current-inner').text();
	        var $innerParent = $('<div class="mobilemenu__menu-head mobilemenu__menu-head--open" />').text(innerParentText);
	
	        var $innerMenu = $('<ul class="mobilemenu__menu mobilemenu__menu--inner js-menu-inner-show" />');
	
	        $('.topmenu__inner-list').find('.topmenu__inner-item').each(function () {
	            var $this = $(this);
	            if ($this.hasClass('js-topmenu__inner-item--also')) return true;
	
	            var $item = $this.clone();
	
	            /////////////////////////////////////////
	            var $dropLiIndex = $('<div class="mobilemenu__item mobilemenu__item_all mobilemenu__item--child" />');
	            var menuDrop = $item.find('.topmenu__inner-link').clone();
	
	            menuDrop[0].innerHTML = 'Все товары';
	            $dropLiIndex.append(menuDrop);
	
	            if ($item.hasClass('js-topmenu-item-dropdown')) {
	                $item.find('.topmenu__inner-link').removeAttr('href');
	                $item.find('.topmenu__inner-link').addClass('js-mobilemenu-show-children-a');
	            }
	
	            var $itemDrop = $item.find('.topmenu__dropdown').clone();
	            $item.find('.topmenu__dropdown').remove();
	            $itemDrop.append($dropLiIndex);
	            $item.append($itemDrop);
	            /////////////////////////////////////////
	
	            $item.removeClass('topmenu__inner-item').addClass('mobilemenu__menu-item');
	
	            if ($this.hasClass('hidden')) {
	                $item.addClass('hidden');
	            }
	
	            $item.find('.topmenu__lvl4-list').remove();
	            $item.find('.topmenu__dropdown').addClass('mobilemenu__list mobilemenu__list--children');
	            var $arrowSpan = $('<span class="mobilemenu__link mobilemenu__arrow-icon js-mobilemenu-show-children" />');
	
	            if ($item.hasClass('js-topmenu-item-dropdown')) {
	                $item.append($arrowSpan);
	            }
	
	            $item.find('.topmenu__inner-link').removeClass('topmenu__inner-link').addClass('mobilemenu__menu-link mobilemenu__link mobilemenu__link--parent js-mobilemenu-show-parent-children');
	
	            $innerMenu.append($item);
	        });
	
	        $('.js-topmenu__inner-item--also').find('.topmenu__dropdown-column--lvl2').each(function () {
	            var $this = $(this);
	            var $item = $this.clone();
	
	            /////////////////////////////////////////
	            var $dropLiIndex = $('<div class="mobilemenu__item mobilemenu__item_all mobilemenu__item--child mobilemenu__item_all--lv2" />');
	            var menuDrop = $item.find('.topmenu__lvl2-link').clone();
	
	            menuDrop[0].innerHTML = 'Все товары';
	            $dropLiIndex.append(menuDrop);
	
	            $item.find('.topmenu__lvl2-link').removeAttr('href');
	            $item.find('.topmenu__lvl2-link').addClass('js-mobilemenu-show-children-a');
	            /////////////////////////////////////////
	
	            $item.removeClass('topmenu__lvl2-link topmenu__dropdown-column topmenu__dropdown-column--lvl2').addClass('js-topmenu-item-dropdown mobilemenu__menu-item');
	
	            if ($this.hasClass('hidden')) {
	                $item.addClass('hidden');
	            }
	
	            $item.find('.topmenu__lvl4-list').remove();
	
	            var $itemList = $('<div class="topmenu__dropdown mobilemenu__list mobilemenu__list--children" />');
	
	            $itemList.append($dropLiIndex);
	
	            $itemList.append($item.find('.topmenu__dropdown-column--lvl3'));
	            $item.append($itemList);
	
	            var $arrowSpan = $('<span class="mobilemenu__link mobilemenu__arrow-icon js-mobilemenu-show-children" />');
	            $item.append($arrowSpan);
	
	            $item.find('.topmenu__lvl2-link').removeClass('topmenu__lvl2-link').addClass('mobilemenu__menu-link mobilemenu__link mobilemenu__link--parent js-mobilemenu-show-parent-children');
	            $innerMenu.append($item);
	        });
	
	        var $ordMenu = $('.js-topmenu__main-list--main').clone();
	        $ordMenu.removeClass('topmenu__main-list').addClass('mobilemenu__menu');
	        $ordMenu.find('.js-topmenu__main-item--special').remove();
	        $ordMenu.find('.topmenu__main-item').removeClass('topmenu__main-item').removeClass('topmenu__main-item--mobile').addClass('mobilemenu__menu-item');
	        $ordMenu.find('.topmenu__main-link').removeClass('topmenu__main-link topmenu__main-link--catalog topmenu__main-link--current js-topmenu__main-link--current-inner topmenu__main-link--ico-phone topmenu__main-link--ico-discount').addClass('mobilemenu__menu-link');
	
	        var $cityBlock = $('.header__city').clone();
	        $cityBlock.removeClass('header__city').addClass('city-data-block--all-white mobilemenu__menu-item');
	        $cityBlock.find('.city-data-block__content').addClass('mobilemenu__menu-link');
	        $cityBlock.find('.city-data-block__phones').remove();
	
	        var $cart = $('.header__cart').clone();
	        $cart.removeClass('header__cart mini-cart--responsive').addClass('mini-cart--side');
	
	        $ordMenu.find('.mobilemenu__menu-item').each(function (i, el) {
	            if ('mobilename' in el.dataset) {
	                el.firstElementChild.textContent = el.dataset.mobilename;
	            }
	
	            if ('beforelast' in el.dataset) {
	                el.parentNode.insertBefore(el, el.parentNode.lastElementChild);
	            }
	
	            if ('adviser' in el.dataset) {
	                /*global carrotquest*/
	                /*if (carrotquest && carrotquest.messenger && carrotquest.messenger._collapsedClick) {
	                    el.firstElementChild.onclick = carrotquest.messenger._collapsedClick;
	                }*/
	            }
	        });
	        $mobileMenu.append($closeButton);
	        $mobileMenu.append($innerParent);
	        $mobileMenu.append($innerMenu);
	        $mobileMenu.append($ordMenu);
	        $mobileMenu.append($cityBlock);
	        $mobileMenu.append($cart);
	
	        if (!$cart.hasClass('mini-cart--empty')) {
	            var $cartLink = $('.cart-preview').find('.cart-preview__cart-link').clone();
	            $cartLink.removeClass().addClass('btn-def btn-def--block btn-def--fullwhite');
	
	            $mobileMenu.append($cartLink);
	        }
	
	        var $container = $('.main-container');
	        $container.append($mobileMenu);
	
	        return $mobileMenu;
	    }
	
	    $('.js-btn-mobilemenu').click(function (e) {
	        e.stopPropagation();
	        var $container = $(this).closest('.main-container');
	
	        var $mobileMenu = createMobileMenu();
	
	        if ($mobileMenu.hasClass('mobilemenu--shown')) {
	            $container.removeClass('main-container--shifted-left');
	            $container.css('min-height', '0');
	            $mobileMenu.removeClass('mobilemenu--shown');
	        } else {
	            setTimeout(function () {
	                $container.addClass('main-container--shifted-left');
	                $mobileMenu.addClass('mobilemenu--shown');
	                $mobileMenu.addClass('mobilemenu--autoheight');
	                if ($mobileMenu.height() > $container.height()) $container.css('min-height', $mobileMenu.height() + 'px');
	                $mobileMenu.removeClass('mobilemenu--autoheight');
	            }, 25);
	        }
	    });
	
	    $('.js-btn-mobilesearch').click(function (e) {
	        e.stopPropagation();
	
	        var divSearch = $('div.simple-search-form__mobile');
	        if (divSearch.length > 0) {
	            divSearch.remove();
	            $('main.page-content').css('margin-top', 0);
	        } else {
	            setTimeout(function () {
	                $.ajax({
	                    url: '/ajax/component/bitrix:search.form/mobile/',
	                    data: { PAGE: '/search/' },
	                    success: function success(response) {
	                        if (response['code'] == 200) {
	                            var search = $(response['html']);
	                            if (search[0].tagName !== 'FONT') {
	                                $('header.header > .header__wrapper').append(search);
	                                $('main.page-content').css('margin-top', search.outerHeight() + 'px');
	                            } else {
	                                console.log(search.text());
	                            }
	                        } else {
	                            console.log(response['message']);
	                        }
	                    }
	                });
	            }, 25);
	        }
	    });
	
	    $(document).on('click', '.main-container--shifted-left .container', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var $container = $(this).closest('.main-container');
	        var $mobileMenu = $('.mobilemenu');
	        $container.removeClass('main-container--shifted-left');
	        $container.css('min-height', '0');
	
	        $mobileMenu.removeClass('mobilemenu--shown');
	    });
	
	    $(document).on('click', '.js-closemobile', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var $container = $('.main-container.main-container--shifted-left');
	        var $mobileMenu = $('.mobilemenu');
	        $container.removeClass('main-container--shifted-left');
	        $container.css('min-height', '0');
	
	        $mobileMenu.removeClass('mobilemenu--shown');
	    });
	
	    $(document).on('click', '.mobilemenu__menu-head', function () {
	        var $this = $(this);
	        if ($this.hasClass('mobilemenu__menu-head--open')) {
	            $this.removeClass('mobilemenu__menu-head--open');
	            $this.addClass('mobilemenu__menu-head--close');
	            $('.js-menu-inner-show').hide();
	        } else {
	            $this.removeClass('mobilemenu__menu-head--close');
	            $this.addClass('mobilemenu__menu-head--open');
	            $('.js-menu-inner-show').show();
	        }
	    });
	
	    $(document).on('click', '.js-mobilemenu-show-children', function (e) {
	        e.preventDefault();
	
	        var $this = $(this);
	        var $thisItem = $this.closest('.mobilemenu__menu-item');
	        var $children = $thisItem.find('.mobilemenu__list--children');
	
	        if ($children.is(':visible')) {
	            $children.slideUp(300, function () {
	                updateBaseHeight();
	                $this.siblings('.mobilemenu__link--parent').removeClass('mobilemenu__link--opened');
	                $this.removeClass('mobilemenu__arrow-icon--opened');
	            });
	        } else {
	            $children.slideDown({
	                start: function start() {
	                    updateBaseHeight();
	                    $(this).css({
	                        display: "flex"
	                    });
	                }
	            });
	            $this.siblings('.mobilemenu__link--parent').addClass('mobilemenu__link--opened');
	            $this.addClass('mobilemenu__arrow-icon--opened');
	        }
	    });
	
	    $(document).on('click', '.js-mobilemenu-show-children-a', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var $thisItem = $this.closest('.mobilemenu__menu-item');
	        var $children = $thisItem.find('.mobilemenu__list--children');
	
	        if ($children.is(':visible')) {
	            $children.slideUp(300, function () {
	                updateBaseHeight();
	                $this.removeClass('mobilemenu__link--opened');
	                $this.parent().find('.mobilemenu__arrow-icon').removeClass('mobilemenu__arrow-icon--opened');
	            });
	        } else {
	            $children.slideDown({
	                start: function start() {
	                    updateBaseHeight();
	                    $(this).css({
	                        display: "flex"
	                    });
	                }
	            });
	            $this.addClass('mobilemenu__link--opened');
	            $this.parent().find('.mobilemenu__arrow-icon').addClass('mobilemenu__arrow-icon--opened');
	        }
	    });
	});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */,
/* 425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */,
/* 427 */,
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(52);
	__webpack_require__(429);
	__webpack_require__(309);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    function onResizeCartPreview() {
	        var $cartPreview = $('.cart-preview');
	        var $miniCartScroll = $cartPreview.find('.js-cart-items-scrollbar');
	        var $miniCart = $('.mini-cart.header__cart');
	
	        var $wrapper = $miniCart.closest('.wrapper');
	
	        //обновление вертикального скролла при изменении ширины сайта
	        // т.е. перешли из режима десктопа в мобильный и наоборот
	        if ($cartPreview.hasClass('cart-preview--shown')) {
	            if (window.innerWidth >= size.desktop) {
	                $miniCartScroll.mCustomScrollbar({
	                    axis: 'y'
	                });
	
	                var posWrapper = $wrapper.width() / 2;
	                var posWindow = window.innerWidth / 2;
	                var pos = Math.min(posWrapper, posWindow);
	                pos -= $cartPreview.innerWidth() + 1;
	                $cartPreview.css('margin-left', pos + 'px');
	            } else {
	                $miniCartScroll.mCustomScrollbar('destroy');
	            }
	        }
	    }
	
	    $(document).on('click', '.js-show-cart-preview', function () {
	        if ($('.js-cart-preview').html() == '') {
	            $.ajax({
	                url: '/ajax/component/maximaster:small.basket.widget/cart-preview/',
	                async: false,
	                success: function success(data) {
	                    $('.js-cart-preview').html(data['html']);
	                }
	            });
	        }
	
	        var $cartPreview = $('.cart-preview');
	        var $container = $cartPreview.closest('.main-container');
	        var $miniCart = $('.mini-cart.header__cart');
	
	        //надо сделать копию корзины из шапки, чтобы тень была единая вокруг
	        //корзины в шапке и самом блоке выпадающей корзины (на десктопе)
	        var $miniCartCopy = $miniCart.clone();
	        $miniCartCopy.removeClass('header__cart js-show-cart-preview mini-cart--active');
	        $cartPreview.find('.cart-preview__cart-copy').html($miniCartCopy);
	
	        $container.toggleClass('main-container--shifted-right');
	        $cartPreview.toggleClass('cart-preview--shown');
	        $miniCart.toggleClass('mini-cart--active');
	
	        $cartPreview.addClass('cart-preview--autoheight');
	        if ($cartPreview.innerHeight() > $container.height()) $container.css('min-height', $cartPreview.innerHeight() + 'px');
	        $cartPreview.removeClass('cart-preview--autoheight');
	
	        onResizeCartPreview();
	    });
	
	    debounce.setResizeDebounce(onResizeCartPreview);
	
	    $(document).on('click', '.main-container--shifted-right .container, .js-close-cart-preview', function (e) {
	        var $target = $(e.target);
	        var $cartPreview = $('.cart-preview');
	        var $container = $cartPreview.closest('.main-container');
	
	        if (!$(this).hasClass('js-close-cart-preview') && ($target.is($cartPreview) || $target.closest('.cart-preview').length > 0 || $target.is('.mini-cart') || $target.closest('.mini-cart').length > 0)) return;
	
	        e.stopPropagation();
	        e.preventDefault();
	
	        $container.removeClass('main-container--shifted-right');
	        $('.mini-cart.mini-cart--active').removeClass('mini-cart--active');
	        $cartPreview.removeClass('cart-preview--shown');
	        $container.css('min-height', '0');
	    });
	});

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */,
/* 431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */,
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(434);
	
	var size = __webpack_require__(55);
	
	$(function () {
	    var tooltips = {
	        getTooltipContentTest: function getTooltipContentTest() {
	            return '<div class="tooltipster__title">Преимущества регистрации</div>' + '<ol class="reg-benefits reg-benefits--black-text">' + '<li class="reg-benefits__item">Если вы косметолог, Вы можете покупать товары по <b>ОПТОВОЙ ЦЕНЕ!</b></li>' + '<li class="reg-benefits__item"><b>1000 РУБЛЕЙ</b> в&nbsp;подарок на первую покупку</li>' + '<li class="reg-benefits__item">Зарегистрируйтесь и получите электронную книгу в <b>ПОДАРОК!</b></li>' + '</ol>';
	        }
	    };
	
	    var defaultTooptipsOptions = {
	        debug: false,
	        contentAsHTML: true,
	        interactive: true,
	        maxWidth: 18 * size.defaultFontSize,
	        repositionOnScroll: true,
	        side: ['bottom', 'top'],
	        trigger: 'custom',
	        triggerOpen: {
	            mouseenter: true,
	            tap: true
	        },
	        triggerClose: {
	            mouseleave: true,
	            tap: true
	        },
	        updateAnimation: null
	    };
	
	    $(document).on('mouseenter click', '.js-tooltip:not(.tooltipstered)', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	
	        var func = tooltips[$this.data('tooltip-callback')];
	
	        if ($.isFunction(func)) {
	            $this.tooltipster($.extend({}, defaultTooptipsOptions, {
	                content: 'Загрузка...',
	                functionBefore: function functionBefore(instance, helper) {
	                    var $origin = $(helper.origin);
	
	                    if ($origin.data('loaded') !== true) {
	                        instance.content(func());
	                        $origin.data('loaded', true);
	
	                        //$.get('http://example.com/ajax.php', function(data) {
	                        //	instance.content(data);
	                        //	$origin.data('loaded', true);
	                        //});
	                    }
	                }
	            })).tooltipster('open');
	        } else {
	            $this.tooltipster($.extend({}, defaultTooptipsOptions, {
	                content: $this.data('tooltip')
	            })).tooltipster('open');
	        }
	    });
	});

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */,
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	var slickDefaults = __webpack_require__(49);
	var size = __webpack_require__(55);
	
	var event = new _trackerEvents2['default']();
	
	jQuery(function ($) {
	    $('body').on('click', '.js-show-popup-card', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:catalog.element/popup/?POPUP=Y&ELEMENT_CODE=' + $(this).data('elem_code') + '&NO_BASKET=' + $(this).data('no-basket'),
	            success: function success(result) {
	                var cardHtml = result.html;
	                $.prompt(cardHtml, {
	                    buttons: {},
	                    persistent: false, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        prompt: 'prompt--product',
	                        form: 'prompt__form--special',
	                        close: 'jqiclose--cross'
	                    },
	                    statechanged: function statechanged() {
	                        var $jqi = $('.jqi');
	                        var $card = $jqi.find('.product-card');
	                        if ($card.length > 0) setProductCard($card);
	
	                        event.onShowProductCardPopup();
	                    }
	                });
	            }
	        });
	        return false;
	    });
	
	    function setProductCard($card) {
	        if ($card == undefined) $card = $('.product-card');
	
	        var $cardPreviews = $card.find('.js-slick-previews:visible');
	        var $cardPreviewsCompact = $card.find('.js-slick-previews-compact:visible');
	
	        if ($cardPreviews.length > 0) {
	            $cardPreviews.slick($.extend({}, slickDefaults.params, {
	                slidesToShow: 4,
	                vertical: false,
	                verticalSwiping: false,
	                responsive: [{
	                    breakpoint: size.tabletBig,
	                    settings: { slidesToShow: 3 }
	                }, {
	                    breakpoint: size.tablet,
	                    settings: {
	                        slidesToShow: 4,
	                        vertical: true,
	                        verticalSwiping: true
	                    }
	                }]
	            }));
	        }
	
	        if ($cardPreviewsCompact.length > 0) {
	            $cardPreviewsCompact.slick($.extend({}, slickDefaults.params, {
	                slidesToShow: 4,
	                vertical: true,
	                verticalSwiping: true,
	                responsive: [{
	                    breakpoint: size.desktop,
	                    settings: {
	                        slidesToShow: 4,
	                        vertical: false,
	                        verticalSwiping: false
	                    }
	                }, {
	                    breakpoint: size.tabletBig,
	                    settings: {
	                        slidesToShow: 3,
	                        vertical: false,
	                        verticalSwiping: false
	                    }
	                }, {
	                    breakpoint: size.tablet,
	                    settings: {
	                        slidesToShow: 4,
	                        vertical: true,
	                        verticalSwiping: true
	                    }
	                }]
	            }));
	        }
	    }
	});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Array$from = __webpack_require__(236)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var evEmitter = __webpack_require__(438);
	
	var trackers = new _trackerTracker2['default']();
	jQuery(function ($) {
	    /**
	     * Добавляет товар в избранное, необходимо передавать data-аттрибут product-id с ИД товара
	     */
	    $('body').on('click', '.js-add-favorite', function (e) {
	        var $selectorFavorite = $(this);
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/favorite/add/',
	            data: 'PRODUCT_ID=' + $(this).data('product-id'),
	            success: function success(result) {
	                //Закрашиваем сердечки
	                if (result.code === 200) {
	                    //Для списка товаров
	                    if ($selectorFavorite.hasClass('heart') && $selectorFavorite.hasClass('product__fav')) {
	                        $selectorFavorite.addClass('heart--active');
	                        $selectorFavorite.addClass('product__fav--active');
	                        $selectorFavorite.addClass('js-remove-favorite');
	                        $selectorFavorite.removeClass('js-add-favorite');
	                    } else {
	                        //Для карточки товара
	                        $('span.heart').addClass('heart--active');
	                        $('span.heart').addClass('js-remove-favorite');
	                        $('span.heart').removeClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').removeClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').addClass('js-remove-favorite');
	                    }
	                    trackers.onAddToFav({
	                        fbpixel: {
	                            value: parseInt(document.querySelector('.product-card__price-value').textContent.replace(' ', ''))
	                        }
	                    });
	                    var list = document.getElementsByClassName('breadcrumbs__text');
	                    trackers.onPMbtnFavorite({ param: _Array$from(list).slice(-1)[0].innerHTML });
	                    evEmitter.emitEvent('addToFavorites');
	                } else if (result.code === 403) {
	                    //Показываем окно авторизации
	                    $('.js-jqi-show-login').trigger('click');
	                }
	            }
	        });
	    });
	
	    /**
	     * Убирает товар из избранного, необходимо передавать data-аттрибут product-id с ИД товара
	     */
	    $('body').on('click', '.js-remove-favorite', function (e) {
	        var $selectorFavorite = $(this);
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/favorite/remove/',
	            data: 'PRODUCT_ID=' + $(this).data('product-id'),
	            success: function success(result) {
	                //Закрашиваем сердечки
	                if (result.code === 200) {
	                    //Для списка товаров
	                    if ($selectorFavorite.hasClass('heart--active') && $selectorFavorite.hasClass('product__fav--active')) {
	                        $selectorFavorite.removeClass('heart--active');
	                        $selectorFavorite.removeClass('product__fav--active');
	                        $selectorFavorite.removeClass('js-remove-favorite');
	                        $selectorFavorite.addClass('js-add-favorite');
	                    } else {
	                        //Для карточки товара
	                        $('span.heart').removeClass('heart--active');
	                        $('span.heart').removeClass('js-remove-favorite');
	                        $('span.heart').addClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').addClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').removeClass('js-remove-favorite');
	                    }
	                }
	            }
	        });
	    });
	});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var eventEmitter = __webpack_require__(439);
	
	var events = new eventEmitter();
	
	if (false) {
	    (function () {
	        var called = 'Event called: ';
	        /**
	         * Событие на смену местоположения
	         *
	         * @param data
	         * @param data.id Код местоположения (Bitrix Местоположения 2.0)
	         * @param data.name Название местоположения
	         * @param data.element Node текущего элемента
	         */
	        events.on('setLocation', function (data) {
	            console.log(called + 'setLocation, ', data);
	        });
	    })();
	}
	
	exports['default'] = events;
	module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.0.3
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var i = 0;
	  var listener = listeners[i];
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  while ( listener ) {
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	    // get next listener
	    i += isOnce ? 0 : 1;
	    listener = listeners[i];
	  }
	
	  return this;
	};
	
	return EvEmitter;
	
	}));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(441);
	
	(function () {
	    var body = $('html, body');
	    var scrollTop = $('.scrolltop');
	    var contStyleName = '.scrolltop__container';
	
	    body.on('mouseenter', contStyleName, function () {
	        $(this).stop().animate({ opacity: '0.75' }, 200);
	    });
	
	    body.on('mouseleave', contStyleName, function () {
	        $(this).stop().animate({ opacity: '0.35' }, 200);
	    });
	
	    body.on('click', contStyleName, function () {
	        body.animate({ scrollTop: 0 }, 300);
	        return false;
	    });
	
	    $(window).scroll(function () {
	        if ($(this).scrollTop() > (screen.height / 2 | 0)) {
	            scrollTop.show();
	            $(contStyleName).stop().animate({ opacity: '0.35' }, 600);
	            return;
	        }
	
	        $(contStyleName).stop().animate({ opacity: '0' }, 600);
	        scrollTop.fadeOut(600, function () {
	            scrollTop.hide();
	        });
	    });
	})();

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */,
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _googleCaptcha = __webpack_require__(444);
	
	var _googleCaptcha2 = _interopRequireDefault(_googleCaptcha);
	
	__webpack_require__(297);
	var form = __webpack_require__(315);
	
	var size = __webpack_require__(55);
	
	var autoComplete = __webpack_require__(449);
	
	var captcha = undefined,
	    bxCaptchaSid = undefined;
	
	var trackers = new _trackerTracker2['default']();
	
	var changeState = function changeState(v) {
	    if (v == 'login') {
	        $.prompt.goToState('loginForm');
	    } else if (v == 'reg') {
	        trackers.onPMbtnReg();
	        $.prompt.goToState(curRegForm);
	    } else if (v == 'passrecovery') {
	        $.prompt.goToState('passRecoveryForm');
	    } else if (v == 'thankyou') {
	        $.prompt.goToState('thankYouForm');
	    } else {
	        return 'nogo';
	    }
	};
	
	var curRegForm = 'regForm';
	
	var registration = $('.js-registration-head');
	var authPromptHeader = registration.find('.js-prompt-header').remove().html();
	var thankYouPrompt = $('.js-thankyou-prompt').html();
	
	var authPrompt = {
	    loginForm: {
	        html: $('.js-auth-component').remove().html(),
	        submit: function submit(e, v, m) {
	            // РКН блоктрует google и отсутствие grecaptcha ломает авторизацию
	            window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	
	            if (!captcha) {
	                captcha = new _googleCaptcha2['default']('.captcha-field', grecaptcha);
	            }
	
	            var changeStateRes = changeState(v);
	            if (changeStateRes == 'nogo') {
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        login_email: { required: true, email: true },
	                        login_password: { required: true },
	                        login_remember_me: {}
	                    },
	                    messages: {
	                        login_email: {
	                            required: 'Не указан e-mail',
	                            email: 'Указан неверный e-mail'
	                        },
	                        login_password: { required: 'Указан неверный пароль' }
	                    },
	                    submitHandler: function submitHandler() {
	                        var email = $('.jqistate input[name=login_email]').val();
	                        var password = $('.jqistate input[name=login_password]').val();
	                        var remember = $('.jqistate input[name=login_remember_me]').is(':checked');
	                        var sessid = $('.jqistate input[name=sessid]').val();
	
	                        if (captcha.key && !captcha.exists()) {
	                            captcha.render();
	                        }
	
	                        if (captcha.rendered() && !captcha.completed()) {
	                            $('.js-login_error').text('Необходимо выполнить captcha');
	                            return;
	                        }
	
	                        var sendObj = {
	                            email: email,
	                            password: password,
	                            isRemember: remember,
	                            sessid: sessid
	                        };
	
	                        if (bxCaptchaSid) {
	                            sendObj = _Object$assign(sendObj, {
	                                'g-recaptcha-response': captcha.completed() || '',
	                                captcha_sid: bxCaptchaSid,
	                                captcha_word: Math.random().toString(36).substr(2, 5).toUpperCase()
	                            });
	                        }
	                        var loader = new _modulesPreloader2['default']();
	                        loader.show();
	
	                        $.ajax({
	                            method: 'POST',
	                            url: '/ajax/action/personal_authorize/get_authorization_data/',
	                            data: sendObj,
	                            async: false,
	                            success: function success(response) {
	                                loader.hide(0);
	                                if (response['code'] !== 200) {
	                                    $('.js-login_error').text(response['message']);
	                                    $('.jqistate input[name=login_password]').val('');
	
	                                    bxCaptchaSid = response['data']['BX_CAPTCHA_CODE'];
	
	                                    if (response['data']['CAPTCHA_CODE'] && !captcha.rendered()) {
	                                        captcha.key = response['data']['CAPTCHA_CODE'];
	                                        captcha.render();
	                                        return;
	                                    }
	
	                                    if (captcha.rendered()) {
	                                        captcha.reset();
	                                    }
	                                } else {
	                                    location.replace(location.href);
	                                }
	                            },
	                            error: function error() {
	                                loader.hide(0);
	                            }
	                        });
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	                $('.js-login_error').text('');
	            }
	            e.preventDefault();
	        }
	    },
	    regForm: {
	        html: authPromptHeader + registration.find('.js-reg-component').html(),
	        submit: function submit(e, v, m) {
	            var changeStateRes = changeState(v);
	            curRegForm = 'regForm';
	            if (changeStateRes == 'nogo') {
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        EMAIL: {
	                            required: true,
	                            email: true,
	                            remote: {
	                                url: '/ajax/action/personal_registration/checkEmailTaken/',
	                                type: 'get',
	                                dataType: 'json',
	                                dataFilter: function dataFilter(response) {
	                                    var result = true;
	                                    if (response) {
	                                        var json = $.parseJSON(response);
	                                        if (json.data[0] === 'false') {
	                                            result = false;
	                                        }
	                                    }
	                                    return result;
	                                }
	                            }
	                        },
	                        PASSWORD: {
	                            required: true,
	                            minlength: 6
	                        },
	                        WORK_CITY: { required: true },
	                        UF_PHONE: { required: true, phoneMask: true },
	                        NAME: { required: true },
	                        reg_user_type: { required: true }
	                    },
	                    messages: {
	                        EMAIL: {
	                            required: 'Не указан e-mail',
	                            email: 'Указан неверный e-mail',
	                            remote: 'Пользователь с таким email уже существует'
	                        },
	                        PASSWORD: {
	                            required: 'Не указан пароль',
	                            minlength: 'Длина пароля - не менее 6 символов'
	                        },
	                        WORK_CITY: { required: 'Не указан город' },
	                        UF_PHONE: {
	                            required: 'Не указан телефон',
	                            phoneMask: 'Указан неверный телефон'
	                        },
	                        NAME: { required: 'Не указано имя' },
	                        reg_user_type: { required: 'Не выбран тип' }
	                    },
	                    submitHandler: function submitHandler() {
	                        var currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
	                        var recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';
	
	                        if (!recaptchaResponse) {
	                            $('.js-server_errors').html('Необходимо выполнить captcha!' + '<br>').addClass('form__error-msg');
	                            return;
	                        }
	
	                        var responseField = $('<input/>', {
	                            type: 'text',
	                            name: 'g-recaptcha-response',
	                            val: recaptchaResponse
	                        });
	
	                        var dataRegForm = $.prompt.getState('regForm').find('.js-reg-form');
	                        var regResult = $.merge($.merge(dataRegForm, $.prompt.getState('regForm').find('[name=reg_user_type]')), responseField);
	                        var userType = $.prompt.getState('regForm').find('[name=reg_user_type]').val();
	
	                        var loader = new _modulesPreloader2['default']();
	                        loader.show();
	
	                        $.ajax({
	                            url: '/ajax/action/personal_registration/registration/',
	                            data: regResult,
	                            type: 'POST',
	                            success: function success(response) {
	                                loader.hide(0);
	                                if (response['code'] == 200) {
	                                    var _trackers = new _trackerTracker2['default']();
	                                    _trackers.onSignUpEnd({ gtm: 'registrationDone' });
	                                    if (userType === 'individual') {
	                                        $('.js-thankyou-wholesale').remove();
	                                    } else {
	                                        $('.js-thankyou-retail').remove();
	                                    }
	                                    $('.jqiclose').remove();
	                                    $('.jqiform').css('padding-bottom', 0);
	                                    grecaptcha.reset(currentCaptchaId);
	                                    _trackers.onPMfrmReg();
	                                    changeState('thankyou');
	                                } else {
	                                    $.each(response['data']['errors'], function () {
	                                        $('.js-server_errors').html(this + '<br>').addClass('form__error-msg');
	                                        bxCaptchaSid = response['data']['BX_CAPTCHA_CODE'];
	                                        $('input[name="captcha_sid"]').val(bxCaptchaSid);
	                                        grecaptcha.reset(currentCaptchaId);
	                                    });
	                                }
	                            },
	                            error: function error() {
	                                loader.hide(0);
	                            }
	                        });
	                    }
	                });
	
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	            e.preventDefault();
	        }
	    },
	    passRecoveryForm: {
	        html: $('.js-forgotpasswd-component').remove().html(),
	        submit: function submit(e, v, m) {
	            var changeStateRes = changeState(v);
	            if (changeStateRes == 'nogo') {
	                var $form = m.closest('form');
	
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        USER_EMAIL: { required: true, email: true }
	                    },
	                    messages: {
	                        USER_EMAIL: {
	                            required: 'Не указан e-mail',
	                            email: 'Указан неверный e-mail'
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        var email = $('.jqistate input[name="USER_EMAIL"]').val();
	                        var inputs = $.prompt.getState('passRecoveryForm').find(':input');
	                        inputs = inputs.serialize();
	                        var recoveryResult = undefined;
	                        var code = undefined;
	                        $.ajax({
	                            url: '/ajax/action/personal_forgotpasswd/check_user/?email=' + email,
	                            async: false,
	                            complete: function complete(response) {
	                                recoveryResult = response.responseJSON['data'];
	                                code = response.responseJSON['code'];
	                            }
	                        });
	                        if (code !== 200) {
	                            $('.login_email_error-js').text(recoveryResult['message']).addClass('form__error-msg');
	                        } else {
	                            $.ajax({
	                                type: 'POST',
	                                data: inputs,
	                                success: function success() {
	                                    $.prompt.getState('passRecoveryForm').find('.form').html(recoveryResult['message']);
	                                    $.prompt.position();
	                                }
	                            });
	                        }
	                    }
	                });
	
	                $form.validate($params);
	            }
	            e.preventDefault();
	        }
	    },
	    thankYouForm: {
	        html: thankYouPrompt,
	        submit: function submit(e) {
	            e.preventDefault();
	            location.replace(location.href);
	        }
	    }
	};
	
	module.exports = authPrompt;
	
	jQuery(function () {
	    $(document).on('click', '.js-jqi-show-login', function (e) {
	        e.preventDefault();
	        $.prompt(authPrompt, {
	            initialState: 'loginForm',
	
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'regForm') {
	                    return;
	                }
	
	                window.Recaptchafree.render();
	            }
	        });
	    });
	
	    $(document).on('click', '.js-jqi-show-reg', function (e) {
	        e.preventDefault();
	        trackers.onSignUp();
	        trackers.onPMbtnReg();
	        $.prompt(authPrompt, {
	            initialState: 'regForm',
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'regForm') {
	                    return;
	                }
	
	                window.Recaptchafree.render();
	            }
	        });
	    });
	
	    $(document).on('click', '.js-jqi-show-passrecovery', function (e) {
	        e.preventDefault();
	        $.prompt(authPrompt, { initialState: 'passRecoveryForm' });
	    });
	
	    $(document).on('click', '.js-expand-reg-promo', function () {
	        var $regPromoBlock = $(this).closest('.prompt__reg-promo');
	        $regPromoBlock.addClass('prompt__reg-promo--shown');
	    });
	
	    $(document).on('click', '.js-mobile-auth-btn', function (e) {
	        e.preventDefault();
	
	        if (window.innerWidth < size.desktop) {
	            $.prompt(authPrompt, {
	                initialState: 'loginForm',
	                statechanging: function statechanging(e, from, to) {
	                    if (to !== 'regForm') {
	                        return;
	                    }
	
	                    window.Recaptchafree.render();
	                }
	            });
	        }
	    });
	
	    $(document).on('click', '.js-mobile-user-btn', function () {
	        var userFormHtml = '';
	        $.ajax({
	            url: '/ajax/component/maximaster:personal.widget/user/',
	            async: false,
	            success: function success(data) {
	                userFormHtml = data['html'];
	            }
	        });
	
	        var userPrompt = {
	            userForm: {
	                html: userFormHtml
	            }
	        };
	
	        if (window.innerWidth < size.desktop) {
	            $.prompt(userPrompt, {
	                initialState: 'userForm',
	                statechanging: function statechanging(e, from, to) {
	                    if (to !== 'regForm') {
	                        return;
	                    }
	
	                    window.Recaptchafree.render();
	                }
	            });
	        }
	    });
	
	    $(document).on('click', '.js-user-logout-btn', function () {
	        $.ajax({
	            url: '/ajax/action/personal_authorize/logout/',
	            success: function success() {
	                location.replace(location.href);
	            }
	        });
	    });
	
	    $(document).on('focus', '.js-autocomplete', function () {
	        autoComplete.setAutocomplete($('.js-autocomplete'));
	    });
	});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Number$isInteger = __webpack_require__(445)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var ReCaptcha = (function () {
	    function ReCaptcha(selector, captcha) {
	        _classCallCheck(this, ReCaptcha);
	
	        this.selector = selector;
	        this.captcha = captcha;
	        this.captchaId = null;
	        this.siteKey = null;
	    }
	
	    _createClass(ReCaptcha, [{
	        key: 'render',
	        value: function render(callback) {
	            if (!this.siteKey) {
	                console.error('cannot render captcha, siteKey not found');
	                return;
	            }
	
	            var config = { sitekey: this.siteKey };
	
	            if (callback) {
	                config['callback'] = callback;
	            }
	
	            this.captchaId = this.captcha.render(this.elem, config);
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            if (!this.rendered()) {
	                console.error('cannot reset captcha, captcha not rendered');
	                return;
	            }
	
	            this.captcha.reset(this.captchaId);
	        }
	    }, {
	        key: 'rendered',
	        value: function rendered() {
	            return _Number$isInteger(this.captchaId);
	        }
	    }, {
	        key: 'exists',
	        value: function exists() {
	            if (!this.elem) {
	                return false;
	            }
	
	            return this.elem.firstElementChild && this.rendered();
	        }
	    }, {
	        key: 'completed',
	        value: function completed() {
	            if (!this.rendered()) {
	                return false;
	            }
	
	            return this.captcha.getResponse(this.captchaId);
	        }
	    }, {
	        key: 'key',
	        set: function set(key) {
	            this.siteKey = key;
	        },
	        get: function get() {
	            return this.siteKey;
	        }
	    }, {
	        key: 'elem',
	        get: function get() {
	            var elem = document.querySelector(this.selector);
	
	            if (!elem) {
	                console.error('element ' + this.selector + ' not exists');
	            }
	
	            return elem;
	        }
	    }]);
	
	    return ReCaptcha;
	})();
	
	exports['default'] = ReCaptcha;
	module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(446), __esModule: true };

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(447);
	module.exports = __webpack_require__(61).Number.isInteger;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(59);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(448) });


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(67);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	/**
	 * @type EvEmitter
	 */
	
	var _modulesEvents = __webpack_require__(438);
	
	var _modulesEvents2 = _interopRequireDefault(_modulesEvents);
	
	__webpack_require__(450);
	__webpack_require__(451);
	__webpack_require__(309);
	
	jQuery(function () {
	    var autocompleteParams = {
	        cities: {
	            lookup: [] // deprecated
	        },
	        location: {
	            lookup: function lookup(query, done) {
	                $.post('/ajax/action/location/search/', {
	                    query: query
	                }, function (result) {
	                    var items = {
	                        suggestions: []
	                    };
	                    if (result.message == 'ok') {
	                        result.data.forEach(function (item) {
	                            items.suggestions.push({
	                                data: item,
	                                value: item.name
	                            });
	                        });
	                    }
	                    done(items);
	                });
	            },
	            onSelect: function onSelect(suggestion) {
	                suggestion.data.element = this;
	                _modulesEvents2['default'].emitEvent('setLocation', [suggestion.data]);
	            },
	            triggerSelectOnValidInput: false,
	            minChars: 3,
	            showNoSuggestionNotice: true,
	            noSuggestionNotice: 'Город не найден'
	        }
	    };
	
	    var setAutocomplete = function setAutocomplete($items) {
	        $items.each(function () {
	            var $this = $(this);
	
	            var lookupParam = $this.data('autocompelte-source');
	
	            var options = {
	                minChars: 1,
	                additionalContainerClass: '.mCSB_container',
	                appendTo: $this.parent(),
	                onSearchComplete: function onSearchComplete() {
	                    $('.autocomplete-suggestions').mCustomScrollbar({
	                        axis: 'y',
	                        scrollbarPosition: 'inside',
	                        advanced: {
	                            updateOnContentResize: true
	                        },
	                        live: true
	                    });
	                }
	            };
	
	            // isObject http://stackoverflow.com/a/14706877
	            if (autocompleteParams[lookupParam] === Object(autocompleteParams[lookupParam])) {
	                options = _Object$assign({}, options, autocompleteParams[lookupParam]);
	            }
	
	            $this.autocomplete(options);
	        });
	    };
	
	    setAutocomplete($('.js-autocomplete'));
	
	    module.exports.setAutocomplete = setAutocomplete;
	});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	*  Ajax Autocomplete for jQuery, version 1.2.24
	*  (c) 2015 Tomas Kirda
	*
	*  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
	*  For details, see the web site: https://github.com/devbridge/jQuery-Autocomplete
	*/
	
	/*jslint  browser: true, white: true, plusplus: true, vars: true */
	/*global define, window, document, jQuery, exports, require */
	
	// Expose plugin as an AMD module if AMD loader is present:
	(function (factory) {
	    'use strict';
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof require === 'function') {
	        // Browserify
	        factory(require('jquery'));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	    'use strict';
	
	    var
	        utils = (function () {
	            return {
	                escapeRegExChars: function (value) {
	                    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	                },
	                createNode: function (containerClass) {
	                    var div = document.createElement('div');
	                    div.className = containerClass;
	                    div.style.position = 'absolute';
	                    div.style.display = 'none';
	                    return div;
	                }
	            };
	        }()),
	
	        keys = {
	            ESC: 27,
	            TAB: 9,
	            RETURN: 13,
	            LEFT: 37,
	            UP: 38,
	            RIGHT: 39,
	            DOWN: 40
	        };
	
	    function Autocomplete(el, options) {
	        var noop = function () { },
	            that = this,
	            defaults = {
	                ajaxSettings: {},
	                autoSelectFirst: false,
	                appendTo: document.body,
	                serviceUrl: null,
	                lookup: null,
	                onSelect: null,
	                width: 'auto',
	                minChars: 1,
	                maxHeight: 300,
	                deferRequestBy: 0,
	                params: {},
	                formatResult: Autocomplete.formatResult,
	                delimiter: null,
	                zIndex: 9999,
	                type: 'GET',
	                noCache: false,
	                onSearchStart: noop,
	                onSearchComplete: noop,
	                onSearchError: noop,
	                preserveInput: false,
	                containerClass: 'autocomplete-suggestions',
	                tabDisabled: false,
	                dataType: 'text',
	                currentRequest: null,
	                triggerSelectOnValidInput: true,
	                preventBadQueries: true,
	                lookupFilter: function (suggestion, originalQuery, queryLowerCase) {
	                    return suggestion.value.toLowerCase().indexOf(queryLowerCase) !== -1;
	                },
	                paramName: 'query',
	                transformResult: function (response) {
	                    return typeof response === 'string' ? $.parseJSON(response) : response;
	                },
	                showNoSuggestionNotice: false,
	                noSuggestionNotice: 'No results',
	                orientation: 'bottom',
	                forceFixPosition: false,
	                additionalContainerClass: ''
	            };
	
	        // Shared variables:
	        that.element = el;
	        that.el = $(el);
	        that.suggestions = [];
	        that.badQueries = [];
	        that.selectedIndex = -1;
	        that.currentValue = that.element.value;
	        that.intervalId = 0;
	        that.cachedResponse = {};
	        that.onChangeInterval = null;
	        that.onChange = null;
	        that.isLocal = false;
	        that.suggestionsContainer = null;
	        that.noSuggestionsContainer = null;
	        that.options = $.extend({}, defaults, options);
	        that.classes = {
	            selected: 'autocomplete-selected',
	            suggestion: 'autocomplete-suggestion'
	        };
	        that.hint = null;
	        that.hintValue = '';
	        that.selection = null;
	
	        // Initialize and set options:
	        that.initialize();
	        that.setOptions(options);
	    }
	
	    Autocomplete.utils = utils;
	
	    $.Autocomplete = Autocomplete;
	
	    Autocomplete.formatResult = function (suggestion, currentValue) {
	        var pattern = '(' + utils.escapeRegExChars(currentValue) + ')';
	        
	        return suggestion.value
	            .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;')
	            .replace(/"/g, '&quot;')
	            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
	    };
	
	    Autocomplete.prototype = {
	
	        killerFn: null,
	
	        initialize: function () {
	            var that = this,
	                suggestionSelector = '.' + that.classes.suggestion,
	                selected = that.classes.selected,
	                options = that.options,
	                container;
	
	            // Remove autocomplete attribute to prevent native suggestions:
	            that.element.setAttribute('autocomplete', 'off');
	
	            that.killerFn = function (e) {
	                if ($(e.target).closest('.' + that.options.containerClass).length === 0) {
	                    that.killSuggestions();
	                    that.disableKillerFn();
	                }
	            };
	
	            // html() deals with many types: htmlString or Element or Array or jQuery
	            that.noSuggestionsContainer = $('<div class="autocomplete-no-suggestion"></div>')
	                                          .html(this.options.noSuggestionNotice).get(0);
	
	            that.suggestionsContainer = Autocomplete.utils.createNode(options.containerClass);
	
	            container = $(that.suggestionsContainer);
	
	            container.appendTo(options.appendTo);
	
	            // Only set width if it was provided:
	            if (options.width !== 'auto') {
	                container.width(options.width);
	            }
	
	            // Listen for mouse over event on suggestions list:
	            container.on('mouseover.autocomplete', suggestionSelector, function () {
	                that.activate($(this).data('index'));
	            });
	
	            // Deselect active element when mouse leaves suggestions container:
	            container.on('mouseout.autocomplete', function () {
	                that.selectedIndex = -1;
	                container.children('.' + selected).removeClass(selected);
	            });
	
	            // Listen for click event on suggestions list:
	            container.on('click.autocomplete', suggestionSelector, function () {
	                that.select($(this).data('index'));
	            });
	
	            that.fixPositionCapture = function () {
	                if (that.visible) {
	                    that.fixPosition();
	                }
	            };
	
	            $(window).on('resize.autocomplete', that.fixPositionCapture);
	
	            that.el.on('keydown.autocomplete', function (e) { that.onKeyPress(e); });
	            that.el.on('keyup.autocomplete', function (e) { that.onKeyUp(e); });
	            that.el.on('blur.autocomplete', function () { that.onBlur(); });
	            that.el.on('focus.autocomplete', function () { that.onFocus(); });
	            that.el.on('change.autocomplete', function (e) { that.onKeyUp(e); });
	            that.el.on('input.autocomplete', function (e) { that.onKeyUp(e); });
	        },
	
	        onFocus: function () {
	            var that = this;
	            that.fixPosition();
	            if (that.options.minChars === 0 && that.el.val().length === 0) {
	                that.onValueChange();
	            }
	        },
	
	        onBlur: function () {
	            this.enableKillerFn();
	        },
	        
	        abortAjax: function () {
	            var that = this;
	            if (that.currentRequest) {
	                that.currentRequest.abort();
	                that.currentRequest = null;
	            }
	        },
	
	        setOptions: function (suppliedOptions) {
	            var that = this,
	                options = that.options;
	
	            $.extend(options, suppliedOptions);
	
	            that.isLocal = $.isArray(options.lookup);
	
	            if (that.isLocal) {
	                options.lookup = that.verifySuggestionsFormat(options.lookup);
	            }
	
	            options.orientation = that.validateOrientation(options.orientation, 'bottom');
	
	            // Adjust height, width and z-index:
	            $(that.suggestionsContainer).css({
	                'max-height': options.maxHeight + 'px',
	                'width': options.width + 'px',
	                'z-index': options.zIndex
	            });
	        },
	
	
	        clearCache: function () {
	            this.cachedResponse = {};
	            this.badQueries = [];
	        },
	
	        clear: function () {
	            this.clearCache();
	            this.currentValue = '';
	            this.suggestions = [];
	        },
	
	        disable: function () {
	            var that = this;
	            that.disabled = true;
	            clearInterval(that.onChangeInterval);
	            that.abortAjax();
	        },
	
	        enable: function () {
	            this.disabled = false;
	        },
	
	        fixPosition: function () {
	            // Use only when container has already its content
	
	            var that = this,
	                $container = $(that.suggestionsContainer),
	                containerParent = $container.parent().get(0);
	            // Fix position automatically when appended to body.
	            // In other cases force parameter must be given.
	            if (containerParent !== document.body && !that.options.forceFixPosition) {
	                return;
	            }
	
	            // Choose orientation
	            var orientation = that.options.orientation,
	                containerHeight = $container.outerHeight(),
	                height = that.el.outerHeight(),
	                offset = that.el.offset(),
	                styles = { 'top': offset.top, 'left': offset.left };
	
	            if (orientation === 'auto') {
	                var viewPortHeight = $(window).height(),
	                    scrollTop = $(window).scrollTop(),
	                    topOverflow = -scrollTop + offset.top - containerHeight,
	                    bottomOverflow = scrollTop + viewPortHeight - (offset.top + height + containerHeight);
	
	                orientation = (Math.max(topOverflow, bottomOverflow) === topOverflow) ? 'top' : 'bottom';
	            }
	
	            if (orientation === 'top') {
	                styles.top += -containerHeight;
	            } else {
	                styles.top += height;
	            }
	
	            // If container is not positioned to body,
	            // correct its position using offset parent offset
	            if(containerParent !== document.body) {
	                var opacity = $container.css('opacity'),
	                    parentOffsetDiff;
	
	                    if (!that.visible){
	                        $container.css('opacity', 0).show();
	                    }
	
	                parentOffsetDiff = $container.offsetParent().offset();
	                styles.top -= parentOffsetDiff.top;
	                styles.left -= parentOffsetDiff.left;
	
	                if (!that.visible){
	                    $container.css('opacity', opacity).hide();
	                }
	            }
	
	            // -2px to account for suggestions border.
	            if (that.options.width === 'auto') {
	                styles.width = (that.el.outerWidth() - 2) + 'px';
	            }
	
	            $container.css(styles);
	        },
	
	        enableKillerFn: function () {
	            var that = this;
	            $(document).on('click.autocomplete', that.killerFn);
	        },
	
	        disableKillerFn: function () {
	            var that = this;
	            $(document).off('click.autocomplete', that.killerFn);
	        },
	
	        killSuggestions: function () {
	            var that = this;
	            that.stopKillSuggestions();
	            that.intervalId = window.setInterval(function () {
	                if (that.visible) {
	                    that.el.val(that.currentValue);
	                    that.hide();
	                }
	                
	                that.stopKillSuggestions();
	            }, 50);
	        },
	
	        stopKillSuggestions: function () {
	            window.clearInterval(this.intervalId);
	        },
	
	        isCursorAtEnd: function () {
	            var that = this,
	                valLength = that.el.val().length,
	                selectionStart = that.element.selectionStart,
	                range;
	
	            if (typeof selectionStart === 'number') {
	                return selectionStart === valLength;
	            }
	            if (document.selection) {
	                range = document.selection.createRange();
	                range.moveStart('character', -valLength);
	                return valLength === range.text.length;
	            }
	            return true;
	        },
	
	        onKeyPress: function (e) {
	            var that = this;
	
	            // If suggestions are hidden and user presses arrow down, display suggestions:
	            if (!that.disabled && !that.visible && e.which === keys.DOWN && that.currentValue) {
	                that.suggest();
	                return;
	            }
	
	            if (that.disabled || !that.visible) {
	                return;
	            }
	
	            switch (e.which) {
	                case keys.ESC:
	                    that.el.val(that.currentValue);
	                    that.hide();
	                    break;
	                case keys.RIGHT:
	                    if (that.hint && that.options.onHint && that.isCursorAtEnd()) {
	                        that.selectHint();
	                        break;
	                    }
	                    return;
	                case keys.TAB:
	                    if (that.hint && that.options.onHint) {
	                        that.selectHint();
	                        return;
	                    }
	                    if (that.selectedIndex === -1) {
	                        that.hide();
	                        return;
	                    }
	                    that.select(that.selectedIndex);
	                    if (that.options.tabDisabled === false) {
	                        return;
	                    }
	                    break;
	                case keys.RETURN:
	                    if (that.selectedIndex === -1) {
	                        that.hide();
	                        return;
	                    }
	                    that.select(that.selectedIndex);
	                    break;
	                case keys.UP:
	                    that.moveUp();
	                    break;
	                case keys.DOWN:
	                    that.moveDown();
	                    break;
	                default:
	                    return;
	            }
	
	            // Cancel event if function did not return:
	            e.stopImmediatePropagation();
	            e.preventDefault();
	        },
	
	        onKeyUp: function (e) {
	            var that = this;
	
	            if (that.disabled) {
	                return;
	            }
	
	            switch (e.which) {
	                case keys.UP:
	                case keys.DOWN:
	                    return;
	            }
	
	            clearInterval(that.onChangeInterval);
	
	            if (that.currentValue !== that.el.val()) {
	                that.findBestHint();
	                if (that.options.deferRequestBy > 0) {
	                    // Defer lookup in case when value changes very quickly:
	                    that.onChangeInterval = setInterval(function () {
	                        that.onValueChange();
	                    }, that.options.deferRequestBy);
	                } else {
	                    that.onValueChange();
	                }
	            }
	        },
	
	        onValueChange: function () {
	            var that = this,
	                options = that.options,
	                value = that.el.val(),
	                query = that.getQuery(value);
	
	            if (that.selection && that.currentValue !== query) {
	                that.selection = null;
	                (options.onInvalidateSelection || $.noop).call(that.element);
	            }
	
	            clearInterval(that.onChangeInterval);
	            that.currentValue = value;
	            that.selectedIndex = -1;
	
	            // Check existing suggestion for the match before proceeding:
	            if (options.triggerSelectOnValidInput && that.isExactMatch(query)) {
	                that.select(0);
	                return;
	            }
	
	            if (query.length < options.minChars) {
	                that.hide();
	            } else {
	                that.getSuggestions(query);
	            }
	        },
	
	        isExactMatch: function (query) {
	            var suggestions = this.suggestions;
	
	            return (suggestions.length === 1 && suggestions[0].value.toLowerCase() === query.toLowerCase());
	        },
	
	        getQuery: function (value) {
	            var delimiter = this.options.delimiter,
	                parts;
	
	            if (!delimiter) {
	                return value;
	            }
	            parts = value.split(delimiter);
	            return $.trim(parts[parts.length - 1]);
	        },
	
	        getSuggestionsLocal: function (query) {
	            var that = this,
	                options = that.options,
	                queryLowerCase = query.toLowerCase(),
	                filter = options.lookupFilter,
	                limit = parseInt(options.lookupLimit, 10),
	                data;
	
	            data = {
	                suggestions: $.grep(options.lookup, function (suggestion) {
	                    return filter(suggestion, query, queryLowerCase);
	                })
	            };
	
	            if (limit && data.suggestions.length > limit) {
	                data.suggestions = data.suggestions.slice(0, limit);
	            }
	
	            return data;
	        },
	
	        getSuggestions: function (q) {
	            var response,
	                that = this,
	                options = that.options,
	                serviceUrl = options.serviceUrl,
	                params,
	                cacheKey,
	                ajaxSettings;
	
	            options.params[options.paramName] = q;
	            params = options.ignoreParams ? null : options.params;
	
	            if (options.onSearchStart.call(that.element, options.params) === false) {
	                return;
	            }
	
	            if ($.isFunction(options.lookup)){
	                options.lookup(q, function (data) {
	                    that.suggestions = data.suggestions;
	                    that.suggest();
	                    options.onSearchComplete.call(that.element, q, data.suggestions);
	                });
	                return;
	            }
	
	            if (that.isLocal) {
	                response = that.getSuggestionsLocal(q);
	            } else {
	                if ($.isFunction(serviceUrl)) {
	                    serviceUrl = serviceUrl.call(that.element, q);
	                }
	                cacheKey = serviceUrl + '?' + $.param(params || {});
	                response = that.cachedResponse[cacheKey];
	            }
	
	            if (response && $.isArray(response.suggestions)) {
	                that.suggestions = response.suggestions;
	                that.suggest();
	                options.onSearchComplete.call(that.element, q, response.suggestions);
	            } else if (!that.isBadQuery(q)) {
	                that.abortAjax();
	
	                ajaxSettings = {
	                    url: serviceUrl,
	                    data: params,
	                    type: options.type,
	                    dataType: options.dataType
	                };
	
	                $.extend(ajaxSettings, options.ajaxSettings);
	
	                that.currentRequest = $.ajax(ajaxSettings).done(function (data) {
	                    var result;
	                    that.currentRequest = null;
	                    result = options.transformResult(data, q);
	                    that.processResponse(result, q, cacheKey);
	                    options.onSearchComplete.call(that.element, q, result.suggestions);
	                }).fail(function (jqXHR, textStatus, errorThrown) {
	                    options.onSearchError.call(that.element, q, jqXHR, textStatus, errorThrown);
	                });
	            } else {
	                options.onSearchComplete.call(that.element, q, []);
	            }
	        },
	
	        isBadQuery: function (q) {
	            if (!this.options.preventBadQueries){
	                return false;
	            }
	
	            var badQueries = this.badQueries,
	                i = badQueries.length;
	
	            while (i--) {
	                if (q.indexOf(badQueries[i]) === 0) {
	                    return true;
	                }
	            }
	
	            return false;
	        },
	
	        hide: function () {
	            var that = this,
	                container = $(that.suggestionsContainer);
	
	            if ($.isFunction(that.options.onHide) && that.visible) {
	                that.options.onHide.call(that.element, container);
	            }
	
	            that.visible = false;
	            that.selectedIndex = -1;
	            clearInterval(that.onChangeInterval);
	            $(that.suggestionsContainer).hide();
	            that.signalHint(null);
	        },
	
	        suggest: function () {
	            if (this.suggestions.length === 0) {
	                if (this.options.showNoSuggestionNotice) {
	                    this.noSuggestions();
	                } else {
	                    this.hide();
	                }
	                return;
	            }
	
	            var that = this,
	                options = that.options,
	                groupBy = options.groupBy,
	                formatResult = options.formatResult,
	                value = that.getQuery(that.currentValue),
	                className = that.classes.suggestion,
	                classSelected = that.classes.selected,
	                container = $(that.suggestionsContainer),
	                noSuggestionsContainer = $(that.noSuggestionsContainer),
	                beforeRender = options.beforeRender,
	                html = '',
	                category,
	                formatGroup = function (suggestion, index) {
	                        var currentCategory = suggestion.data[groupBy];
	
	                        if (category === currentCategory){
	                            return '';
	                        }
	
	                        category = currentCategory;
	
	                        return '<div class="autocomplete-group"><strong>' + category + '</strong></div>';
	                    };
	
	            if (options.triggerSelectOnValidInput && that.isExactMatch(value)) {
	                that.select(0);
	                return;
	            }
	
	            // Build suggestions inner HTML:
	            $.each(that.suggestions, function (i, suggestion) {
	                if (groupBy){
	                    html += formatGroup(suggestion, value, i);
	                }
	
	                html += '<div class="' + className + '" data-index="' + i + '">' + formatResult(suggestion, value) + '</div>';
	            });
	
	            this.adjustContainerWidth();
	
	            noSuggestionsContainer.detach();
	
	            if (container.find(this.options.additionalContainerClass).length > 0)
	                container.find(this.options.additionalContainerClass).html(html);
	            else
	                container.html(html);
	
	            if ($.isFunction(beforeRender)) {
	                beforeRender.call(that.element, container);
	            }
	
	            that.fixPosition();
	            container.show();
	
	            // Select first value by default:
	            if (options.autoSelectFirst) {
	                that.selectedIndex = 0;
	                container.scrollTop(0);
	                container.children('.' + className).first().addClass(classSelected);
	            }
	
	            that.visible = true;
	            that.findBestHint();
	        },
	
	        noSuggestions: function() {
	             var that = this,
	                 container = $(that.suggestionsContainer),
	                 noSuggestionsContainer = $(that.noSuggestionsContainer);
	
	            this.adjustContainerWidth();
	
	            // Some explicit steps. Be careful here as it easy to get
	            // noSuggestionsContainer removed from DOM if not detached properly.
	            noSuggestionsContainer.detach();
	            container.empty(); // clean suggestions if any
	            container.append(noSuggestionsContainer);
	
	            that.fixPosition();
	
	            container.show();
	            that.visible = true;
	        },
	
	        adjustContainerWidth: function() {
	            var that = this,
	                options = that.options,
	                width,
	                container = $(that.suggestionsContainer);
	
	            // If width is auto, adjust width before displaying suggestions,
	            // because if instance was created before input had width, it will be zero.
	            // Also it adjusts if input width has changed.
	            // -2px to account for suggestions border.
	            if (options.width === 'auto') {
	                width = that.el.outerWidth() - 2;
	                container.width(width > 0 ? width : 300);
	            }
	        },
	
	        findBestHint: function () {
	            var that = this,
	                value = that.el.val().toLowerCase(),
	                bestMatch = null;
	
	            if (!value) {
	                return;
	            }
	
	            $.each(that.suggestions, function (i, suggestion) {
	                var foundMatch = suggestion.value.toLowerCase().indexOf(value) === 0;
	                if (foundMatch) {
	                    bestMatch = suggestion;
	                }
	                return !foundMatch;
	            });
	
	            that.signalHint(bestMatch);
	        },
	
	        signalHint: function (suggestion) {
	            var hintValue = '',
	                that = this;
	            if (suggestion) {
	                hintValue = that.currentValue + suggestion.value.substr(that.currentValue.length);
	            }
	            if (that.hintValue !== hintValue) {
	                that.hintValue = hintValue;
	                that.hint = suggestion;
	                (this.options.onHint || $.noop)(hintValue);
	            }
	        },
	
	        verifySuggestionsFormat: function (suggestions) {
	            // If suggestions is string array, convert them to supported format:
	            if (suggestions.length && typeof suggestions[0] === 'string') {
	                return $.map(suggestions, function (value) {
	                    return { value: value, data: null };
	                });
	            }
	
	            return suggestions;
	        },
	
	        validateOrientation: function(orientation, fallback) {
	            orientation = $.trim(orientation || '').toLowerCase();
	
	            if($.inArray(orientation, ['auto', 'bottom', 'top']) === -1){
	                orientation = fallback;
	            }
	
	            return orientation;
	        },
	
	        processResponse: function (result, originalQuery, cacheKey) {
	            var that = this,
	                options = that.options;
	
	            result.suggestions = that.verifySuggestionsFormat(result.suggestions);
	
	            // Cache results if cache is not disabled:
	            if (!options.noCache) {
	                that.cachedResponse[cacheKey] = result;
	                if (options.preventBadQueries && result.suggestions.length === 0) {
	                    that.badQueries.push(originalQuery);
	                }
	            }
	
	            // Return if originalQuery is not matching current query:
	            if (originalQuery !== that.getQuery(that.currentValue)) {
	                return;
	            }
	
	            that.suggestions = result.suggestions;
	            that.suggest();
	        },
	
	        activate: function (index) {
	            var that = this,
	                activeItem,
	                selected = that.classes.selected,
	                container = $(that.suggestionsContainer),
	                children = container.find('.' + that.classes.suggestion);
	
	            container.find('.' + selected).removeClass(selected);
	
	            that.selectedIndex = index;
	
	            if (that.selectedIndex !== -1 && children.length > that.selectedIndex) {
	                activeItem = children.get(that.selectedIndex);
	                $(activeItem).addClass(selected);
	                return activeItem;
	            }
	
	            return null;
	        },
	
	        selectHint: function () {
	            var that = this,
	                i = $.inArray(that.hint, that.suggestions);
	
	            that.select(i);
	        },
	
	        select: function (i) {
	            var that = this;
	            that.hide();
	            that.onSelect(i);
	        },
	
	        moveUp: function () {
	            var that = this;
	
	            if (that.selectedIndex === -1) {
	                return;
	            }
	
	            if (that.selectedIndex === 0) {
	                $(that.suggestionsContainer).children().first().removeClass(that.classes.selected);
	                that.selectedIndex = -1;
	                that.el.val(that.currentValue);
	                that.findBestHint();
	                return;
	            }
	
	            that.adjustScroll(that.selectedIndex - 1);
	        },
	
	        moveDown: function () {
	            var that = this;
	
	            if (that.selectedIndex === (that.suggestions.length - 1)) {
	                return;
	            }
	
	            that.adjustScroll(that.selectedIndex + 1);
	        },
	
	        adjustScroll: function (index) {
	            var that = this,
	                activeItem = that.activate(index);
	
	            if (!activeItem) {
	                return;
	            }
	
	            var offsetTop,
	                upperBound,
	                lowerBound,
	                heightDelta = $(activeItem).outerHeight();
	
	            offsetTop = activeItem.offsetTop;
	            upperBound = $(that.suggestionsContainer).scrollTop();
	            lowerBound = upperBound + that.options.maxHeight - heightDelta;
	
	            if (offsetTop < upperBound) {
	                $(that.suggestionsContainer).scrollTop(offsetTop);
	            } else if (offsetTop > lowerBound) {
	                $(that.suggestionsContainer).scrollTop(offsetTop - that.options.maxHeight + heightDelta);
	            }
	
	            if (!that.options.preserveInput) {
	                that.el.val(that.getValue(that.suggestions[index].value));
	            }
	            that.signalHint(null);
	        },
	
	        onSelect: function (index) {
	            var that = this,
	                onSelectCallback = that.options.onSelect,
	                suggestion = that.suggestions[index];
	
	            that.currentValue = that.getValue(suggestion.value);
	
	            if (that.currentValue !== that.el.val() && !that.options.preserveInput) {
	                that.el.val(that.currentValue);
	            }
	
	            that.signalHint(null);
	            that.suggestions = [];
	            that.selection = suggestion;
	
	            if ($.isFunction(onSelectCallback)) {
	                onSelectCallback.call(that.element, suggestion);
	            }
	        },
	
	        getValue: function (value) {
	            var that = this,
	                delimiter = that.options.delimiter,
	                currentValue,
	                parts;
	
	            if (!delimiter) {
	                return value;
	            }
	
	            currentValue = that.currentValue;
	            parts = currentValue.split(delimiter);
	
	            if (parts.length === 1) {
	                return value;
	            }
	
	            return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
	        },
	
	        dispose: function () {
	            var that = this;
	            that.el.off('.autocomplete').removeData('autocomplete');
	            that.disableKillerFn();
	            $(window).off('resize.autocomplete', that.fixPositionCapture);
	            $(that.suggestionsContainer).remove();
	        }
	    };
	
	    // Create chainable jQuery plugin:
	    $.fn.autocomplete = $.fn.devbridgeAutocomplete = function (options, args) {
	        var dataKey = 'autocomplete';
	        // If function invoked without argument return
	        // instance of the first matched element:
	        if (arguments.length === 0) {
	            return this.first().data(dataKey);
	        }
	
	        return this.each(function () {
	            var inputElement = $(this),
	                instance = inputElement.data(dataKey);
	
	            if (typeof options === 'string') {
	                if (instance && typeof instance[options] === 'function') {
	                    instance[options](args);
	                }
	            } else {
	                // If instance already exists, destroy it:
	                if (instance && instance.dispose) {
	                    instance.dispose();
	                }
	                instance = new Autocomplete(this, options);
	                inputElement.data(dataKey, instance);
	            }
	        });
	    };
	}));


/***/ }),
/* 451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(297);
	var Url = __webpack_require__(454);
	
	jQuery(function () {
	    $(document).on('click', '.js-city-select', function (e) {
	        e.preventDefault();
	        var citiesHtml = $('.js-city-list-container').html();
	        $.prompt(citiesHtml, {
	            buttons: {},
	            persistent: false, //чтобы можно было закрыть при клике по оверлею
	            classes: {
	                prompt: 'prompt--middle-large',
	                form: 'prompt__form-special',
	                close: 'jqiclose--cross'
	            }
	        });
	    });
	
	    $(document).on('click', '.cities-list__link', function () {
	        var currentUrl = new Url();
	        if (currentUrl.query.city) {
	            delete currentUrl.query.city;
	            $(this).attr('href', currentUrl.toString());
	        }
	        var date = new Date(new Date().getTime() + 99999999);
	        document.cookie = 'BITRIX_SM_region_code=' + $(this).data('code') + '; expires=' + date.toUTCString() + '; path=/';
	
	        var urlSetRegion = '/ajax/action/region_widget/set_region/';
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', urlSetRegion, false);
	        xhr.send();
	        if (xhr.status !== 200) {
	            console.error(urlSetRegion + ' ' + xhr.statusText);
	        }
	    });
	});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global, process) {!function(t){"use strict";var y=/^[a-z]+:/,d=/[-a-z0-9]+(\.[-a-z0-9])*:\d+/i,v=/\/\/(.*?)(?::(.*?))?@/,r=/^win/i,g=/:$/,m=/^\?/,q=/^#/,w=/(.*\/)/,A=/^\/{2,}/,I=/(^\/?)/,e=/'/g,o=/%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,n=/%([cd][0-9a-f])%([89ab][0-9a-f])/gi,i=/%([0-7][0-9a-f])/gi,s=/\+/g,a=/^\w:$/,C=/[^/#?]/;var p,S="undefined"==typeof window&&"undefined"!=typeof global&&"function"=="function",b=!S&&t.navigator&&t.navigator.userAgent&&~t.navigator.userAgent.indexOf("MSIE"),x=S?t.require:null,j={protocol:"protocol",host:"hostname",port:"port",path:"pathname",query:"search",hash:"hash"},z={ftp:21,gopher:70,http:80,https:443,ws:80,wss:443};function E(){return S?p=p||"file://"+(process.platform.match(r)?"/":"")+x("fs").realpathSync("."):"about:srcdoc"===document.location.href?self.parent.document.location.href:document.location.href}function h(t,r,e){var o,n,i;r=r||E(),S?o=x("url").parse(r):(o=document.createElement("a")).href=r;var a,s,p=(s={path:!0,query:!0,hash:!0},(a=r)&&y.test(a)&&(s.protocol=!0,s.host=!0,d.test(a)&&(s.port=!0),v.test(a)&&(s.user=!0,s.pass=!0)),s);for(n in i=r.match(v)||[],j)p[n]?t[n]=o[j[n]]||"":t[n]="";if(t.protocol=t.protocol.replace(g,""),t.query=t.query.replace(m,""),t.hash=F(t.hash.replace(q,"")),t.user=F(i[1]||""),t.pass=F(i[2]||""),t.port=z[t.protocol]==t.port||0==t.port?"":t.port,!p.protocol&&C.test(r.charAt(0))&&(t.path=r.split("?")[0].split("#")[0]),!p.protocol&&e){var h=new L(E().match(w)[0]),u=h.path.split("/"),c=t.path.split("/"),f=["protocol","user","pass","host","port"],l=f.length;for(u.pop(),n=0;n<l;n++)t[f[n]]=h[f[n]];for(;".."===c[0];)u.pop(),c.shift();t.path=("/"!==r.charAt(0)?u.join("/"):"")+"/"+c.join("/")}t.path=t.path.replace(A,"/"),b&&(t.path=t.path.replace(I,"/")),t.paths(t.paths()),t.query=new U(t.query)}function u(t){return encodeURIComponent(t).replace(e,"%27")}function F(t){return(t=(t=(t=t.replace(s," ")).replace(o,function(t,r,e,o){var n=parseInt(r,16)-224,i=parseInt(e,16)-128;if(0==n&&i<32)return t;var a=(n<<12)+(i<<6)+(parseInt(o,16)-128);return 65535<a?t:String.fromCharCode(a)})).replace(n,function(t,r,e){var o=parseInt(r,16)-192;if(o<2)return t;var n=parseInt(e,16)-128;return String.fromCharCode((o<<6)+n)})).replace(i,function(t,r){return String.fromCharCode(parseInt(r,16))})}function U(t){for(var r=t.split("&"),e=0,o=r.length;e<o;e++){var n=r[e].split("="),i=decodeURIComponent(n[0].replace(s," "));if(i){var a=void 0!==n[1]?F(n[1]):null;void 0===this[i]?this[i]=a:(this[i]instanceof Array||(this[i]=[this[i]]),this[i].push(a))}}}function L(t,r){h(this,t,!r)}U.prototype.toString=function(){var t,r,e="",o=u;for(t in this){var n=this[t];if(!(n instanceof Function||void 0===n))if(n instanceof Array){var i=n.length;if(!i){e+=(e?"&":"")+o(t)+"=";continue}for(r=0;r<i;r++){var a=n[r];void 0!==a&&(e+=e?"&":"",e+=o(t)+(null===a?"":"="+o(a)))}}else e+=e?"&":"",e+=o(t)+(null===n?"":"="+o(n))}return e},L.prototype.clearQuery=function(){for(var t in this.query)this.query[t]instanceof Function||delete this.query[t];return this},L.prototype.queryLength=function(){var t=0;for(var r in this.query)this.query[r]instanceof Function||t++;return t},L.prototype.isEmptyQuery=function(){return 0===this.queryLength()},L.prototype.paths=function(t){var r,e="",o=0;if(t&&t.length&&t+""!==t){for(this.isAbsolute()&&(e="/"),r=t.length;o<r;o++)t[o]=!o&&a.test(t[o])?t[o]:u(t[o]);this.path=e+t.join("/")}for(o=0,r=(t=("/"===this.path.charAt(0)?this.path.slice(1):this.path).split("/")).length;o<r;o++)t[o]=F(t[o]);return t},L.prototype.encode=u,L.prototype.decode=F,L.prototype.isAbsolute=function(){return this.protocol||"/"===this.path.charAt(0)},L.prototype.toString=function(){return(this.protocol&&this.protocol+"://")+(this.user&&u(this.user)+(this.pass&&":"+u(this.pass))+"@")+(this.host&&this.host)+(this.port&&":"+this.port)+(this.path&&this.path)+(this.query.toString()&&"?"+this.query)+(this.hash&&"#"+u(this.hash))},t[t.exports?"exports":"Url"]=L}("undefined"!=typeof module&&module.exports?module:window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(455)(module), (function() { return this; }()), __webpack_require__(456)))

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 456 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery.validator.addMethod('phoneMask', function (value, element) {
	    return this.optional(element) || /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/.test(value);
	}, 'Указан неверный телефон');
	
	/*jQuery.validator.addMethod("require_from_group", function(value, element, options) {
		var validator = this;
		var selector = options[1];
		var validOrNot = $(selector, element.form).filter(function() {
				return validator.elementValue(this);
			}).length >= options[0];
	
		if(!$(element).data('being_validated')) {
			var fields = $(selector, element.form);
			fields.data('being_validated', true);
			fields.valid();
			fields.data('being_validated', false);
		}
		return validOrNot;
	}, jQuery.validator.format("Заполните как минимум {0} из этих полей."));*/
	
	$.validator.addMethod('require_from_group', function (value, element, options) {
	    var $fields = $(options[1], element.form),
	        $fieldsFirst = $fields.eq(0),
	        validator = $fieldsFirst.data('valid_req_grp') ? $fieldsFirst.data('valid_req_grp') : $.extend({}, this),
	        isValid = $fields.filter(function () {
	        return validator.elementValue(this);
	    }).length >= options[0];
	
	    // Store the cloned validator for future validation
	    $fieldsFirst.data('valid_req_grp', validator);
	
	    // If element isn't being validated, run each require_from_group field's validation rules
	    if (!$(element).data('being_validated')) {
	        $fields.data('being_validated', true);
	        $fields.each(function () {
	            validator.element(this);
	        });
	        $fields.data('being_validated', false);
	    }
	    return isValid;
	}, $.validator.format('Please fill at least {0} of these fields.'));
	
	$.validator.addMethod('all_req', function (value, element, options) {
	    var isValid = false;
	
	    var $fields = $(options[0], element.form);
	    var count = $fields.length;
	
	    $fields.each(function () {
	        if (this.value !== '') {
	            count--;
	        }
	    });
	
	    if (count == 0 || count == $fields.length) isValid = true;else if (value !== '') isValid = true;
	
	    return isValid;
	}, $.validator.format('Заполните либо все, либо ни одного поля'));
	
	/* Проверка контрольных разрядов ИНН  - используется в методе INN_RUS */
	var getControlSum = function getControlSum(value, position) {
	    var res = -1;
	    if (position < value.length - 2 || position > 11) {
	        return res;
	    }
	    var test = [2, 4, 10, 3, 5, 9, 4, 6, 8];
	    if (position > test.length) {
	        test.unshift(7);
	    }
	    if (position > test.length) {
	        test.unshift(3);
	    }
	
	    var arr = [];
	    for (var i = 0; i < value.length; i++) {
	        arr.push(parseInt(value[i]));
	    }
	
	    var summ = 0;
	    for (i = 0; i < test.length; i++) {
	        summ += test[i] * arr[i];
	    }
	
	    res = summ % 11;
	    res = res % 10;
	
	    if (res === 10) {
	        res = 0;
	    }
	
	    return res;
	};
	/* Формат КПП и ИНН в соответствии с Приказом ФНС РФ от 29.06.2012 № ММВ-7-6/435@ */
	jQuery.validator.addMethod('KPP_RUS', function (value) {
	    return (/^[\d]{4}[\dA-Z]{2}[\d]{3}$/.test(value) || value === ''
	    );
	}, 'Enter valid KPP');
	jQuery.validator.addMethod('INN_RUS', function (value) {
	    var res = /^[\d]{10}$/.test(value) || /^[\d]{12}$/.test(value);
	    if (!res) {
	        return res;
	    }
	
	    switch (value.length) {
	        case 10:
	            res = parseInt(value[9]) === getControlSum(value, 9);
	            break;
	        case 12:
	            res = parseInt(value[10]) === getControlSum(value, 10) && parseInt(value[11]) === getControlSum(value, 11);
	            break;
	        default:
	            res = false;
	            break;
	    }
	
	    return res;
	}, 'Enter valid INN');

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(297);
	var form = __webpack_require__(315);
	
	jQuery(function () {
	    var specialRegGiftPromptHtml = '<div class="special-action special-action--blue">' + '<img class="special-action__bg-img" src="local/assets/img/bg-reg-gift.jpg" alt="1000 РУБЛЕЙ за регистрацию" />' + '<div class="special-action__content">' + '<div class="special-action__box special-action__box--white">' + '<span class="special-action__box-big-text">1000 рублей</span> <span class="special-action__box-normal-text">за регистрацию</span>' + '</div>' + '<div class="form form--fullwidth">' + '<div class="form__field icon-field icon-field--man">' + '<div class="icon-field icon-field--man">' + '<input type="email" name="quick_reg_email" placeholder="Введите e-mail" class="form__input form__input--shade icon-field__input" />' + '</div>' + '</div>' + '<div class="form__field jqibuttons">' + '<button class="btn-def btn-def--pink btn-def--w100" value="quick-reg">Зарегистрироваться</button>' + '</div>' + '</div>' + '</div>' + '</div>';
	
	    var specialRegBenefitsPromptHtml = '<div class="special-action special-action--dark-pink">' + '<img class="special-action__bg-img" src="local/assets/img/bg-reg-gift-2.jpg" alt="1000 РУБЛЕЙ за регистрацию" />' + '<div class="special-action__content">' + '<ol class="reg-benefits reg-benefits--compact">' + '<li class="reg-benefits__item">Если вы косметолог, Вы можете покупать товары по <b>ОПТОВОЙ ЦЕНЕ!</b></li>' + '<li class="reg-benefits__item"><b>1000 РУБЛЕЙ</b> в&nbsp;подарок на первую покупку</li>' + '<li class="reg-benefits__item">Зарегистрируйтесь и получите электронную книгу в <b>ПОДАРОК!</b></li>' + '</ol>' + '<div class="form form--fullwidth">' + '<div class="form__field icon-field icon-field--man">' + '<div class="icon-field icon-field--man">' + '<input type="email" name="quick_reg_email" placeholder="Введите e-mail" class="form__input form__input--shade icon-field__input" />' + '</div>' + '</div>' + '<div class="form__field form__field--nomargin jqibuttons">' + '<button class="btn-def btn-def--w100" value="quick-reg">Зарегистрироваться</button>' + '</div>' + '</div>' + '</div>' + '</div>';
	
	    function promoSubmit(e, v, m) {
	        e.preventDefault();
	        var $params = $.extend({}, form.formValidateDefaults, {
	            rules: {
	                quick_reg_email: { required: true, email: true }
	            },
	            messages: {
	                quick_reg_email: {
	                    required: 'Не указан e-mail',
	                    email: 'Указан неверный e-mail'
	                }
	            },
	            submitHandler: function submitHandler() {
	                //form.submit();
	
	                // данные формы:
	                // console.log(f);
	
	                //тест. все поля заполнены верно
	                $.prompt.getState('state0').find('.form').html('<p>Регистрация</p>');
	                //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                // чтобы не казалось, будто он совсем пропал с экрана
	                $.prompt.position();
	                //$.prompt.close();
	            }
	        });
	        var $form = m.closest('form');
	        $form.validate($params);
	    }
	
	    $('.js-show-reg-gift-popup').click(function (e) {
	        e.preventDefault();
	
	        $.prompt(specialRegGiftPromptHtml, {
	            buttons: {},
	            persistent: false, //чтобы можно было закрыть при клике по оверлею
	            classes: {
	                prompt: 'prompt--large',
	                form: 'prompt__form-special',
	                close: 'jqiclose--cross jqiclose--pink-cross'
	            },
	            submit: promoSubmit
	        });
	    });
	
	    $('.js-show-reg-benefits-popup').click(function (e) {
	        e.preventDefault();
	
	        $.prompt(specialRegBenefitsPromptHtml, {
	            buttons: {},
	            persistent: false, //чтобы можно было закрыть при клике по оверлею
	            classes: {
	                prompt: 'prompt--large',
	                form: 'prompt__form-special',
	                close: 'jqiclose--cross jqiclose--pink-cross'
	            },
	            submit: promoSubmit
	        });
	    });
	});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _googleCaptcha = __webpack_require__(444);
	
	var _googleCaptcha2 = _interopRequireDefault(_googleCaptcha);
	
	__webpack_require__(462);
	var form = __webpack_require__(315);
	
	var captcha = undefined,
	    bxCaptchaSid = undefined;
	
	jQuery(function ($) {
	    var trackers = new _trackerTracker2['default']();
	    var contactsPrompt = {
	        callback: {
	            html: $('.js-callback-forms').remove().html(),
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var callbackForm = m.closest('form');
	                trackers.onCallBackButton();
	                var params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        callback_phone: {
	                            required: true,
	                            phoneMask: true
	                        }
	                    },
	                    messages: {
	                        callback_phone: {
	                            required: $.validator.messages.callback_phone.required,
	                            phoneMask: $.validator.messages.callback_phone.phoneMask
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	                        var currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
	                        var recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';
	                        if (!recaptchaResponse) {
	                            $('.captcha-field-callback .form__captcha-error').html('Необходимо выполнить captcha!' + '<br>').addClass('form__error-msg');
	                            return;
	                        } else {
	                            (function () {
	                                var loader = new _modulesPreloader2['default']();
	                                loader.show();
	                                $.ajax({
	                                    type: 'POST',
	                                    url: '/ajax/action/callback_form/callback/',
	                                    data: callbackForm.serialize(),
	                                    dataType: 'json',
	                                    success: function success(response) {
	                                        loader.hide();
	                                        if (response.code == 200) {
	                                            $.prompt.goToState('successCallbackMessage');
	                                            trackers.onCallBackRequestSend();
	                                            trackers.onPMfrmCallMe();
	                                        } else {
	                                            var errorDiv = $('<div/>', {
	                                                'class': 'form__error-msg',
	                                                text: response.message
	                                            });
	                                            callbackForm.find('.form').prepend(errorDiv);
	                                        }
	                                    }
	                                });
	                            })();
	                        }
	                    }
	                });
	
	                callbackForm.validate(params);
	            }
	        },
	
	        successCallbackMessage: {
	            html: function html() {
	                var ajax = new XMLHttpRequest();
	                ajax.open('GET', '/ajax/template/maximaster:callback.form/success/', false);
	                ajax.send();
	                return ajax.responseText;
	            }
	        },
	
	        successFeedbackMessage: {
	            html: function html() {
	                var ajax = new XMLHttpRequest();
	                ajax.open('GET', '/ajax/template/maximaster:feedback.form/success/', false);
	                ajax.send();
	                return ajax.responseText;
	            }
	        }
	    };
	
	    $(document).on('click', '.callback__btn', function (e) {
	        e.preventDefault();
	        trackers.onCallBackFormShow();
	        $.prompt(contactsPrompt, {
	            initialState: 'callback',
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'callback') {
	                    return;
	                }
	                window.Recaptchafree.render();
	            }
	        });
	    });
	
	    $(document).on('click', '.callback__menu', function (e) {
	        e.preventDefault();
	        trackers.onCallBackFormShow();
	        trackers.onPMbtnCallMe();
	        window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	        $.prompt(contactsPrompt, {
	            initialState: 'callback',
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'callback') {
	                    return;
	                }
	                window.Recaptchafree.render();
	            }
	        });
	    });
	
	    $('.js-feedback-form').submit(function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var params = $.extend({}, form.formValidateDefaults, {
	            rules: {
	                feedback_name: { required: true },
	                feedback_city: { required: true },
	                feedback_phone: {
	                    phoneMask: true
	                }
	            },
	            messages: {
	                feedback_name: {
	                    required: $.validator.messages.feedback_name.required
	                },
	                feedback_city: {
	                    required: $.validator.messages.feedback_city.required
	                },
	                feedback_phone: {
	                    phoneMask: $.validator.messages.feedback_phone.phoneMask
	                }
	            },
	            submitHandler: function submitHandler() {
	                var currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
	                var recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';
	                $('.form__captcha-error').removeClass('form__error-msg');
	                $('.form__captcha-error').html(' ');
	                if (!recaptchaResponse) {
	                    $('.form__captcha-error').html('Необходимо выполнить captcha!' + '<br>').addClass('form__error-msg');
	                    return;
	                }
	                $.ajax({
	                    type: 'POST',
	                    url: '/ajax/action/feedback_form/feedback/',
	                    data: $this.serialize(),
	                    dataType: 'json',
	                    success: function success(response) {
	                        if (response.code == 200) {
	                            $('.js-form-reset').trigger('click');
	                            $this.find('.form__input--correct').each(function (i, element) {
	                                $(element).removeClass('form__input--correct');
	                            });
	                            trackers.onPMfrmCallMeContact();
	
	                            $.prompt(contactsPrompt, {
	                                initialState: 'successFeedbackMessage'
	                            });
	                        } else {
	                            var errorDiv = $('<div/>', {
	                                'class': 'form__error-msg',
	                                text: response.message
	                            });
	                            $this.find('.form__head-label').after(errorDiv);
	                        }
	                    }
	                });
	            }
	        });
	        $this.validate(params);
	        $this.valid();
	    });
	});

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */,
/* 467 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery(function () {
	    $('.social-block-on-pages').click(function () {
	        var classActive = $('.social-block-on-pages_hidden').hasClass('active');
	        if (classActive == true) {
	            $('.social-block-on-pages_hidden').removeClass('active');
	        } else {
	            $('.social-block-on-pages_hidden').addClass('active');
	        }
	    });
	});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(469);
	
	__webpack_require__(172);
	__webpack_require__(471);
	
	var slickDefaults = __webpack_require__(49);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    function setProductCard($card) {
	        if ($card == undefined) $card = $('.product-card');
	
	        var $cardPreviews = $card.find('.js-slick-previews:visible');
	        var $cardPreviewsCompact = $card.find('.js-slick-previews-compact:visible');
	
	        if ($cardPreviews.length > 0) {
	            $cardPreviews.slick($.extend({}, slickDefaults.params, {
	                slidesToShow: 3,
	                vertical: true,
	                verticalSwiping: true,
	                responsive: [{
	                    breakpoint: size.tabletBig,
	                    settings: { slidesToShow: 3 }
	                }, {
	                    breakpoint: size.tablet,
	                    settings: {
	                        slidesToShow: 3,
	                        vertical: true,
	                        verticalSwiping: true
	                    }
	                }]
	            }));
	        }
	
	        /* if ($cardPreviewsCompact.length > 0) {
	             $cardPreviewsCompact.slick(
	                 $.extend({}, slickDefaults.params, {
	                     slidesToShow: 4,
	                     vertical: true,
	                     verticalSwiping: true,
	                     responsive: [
	                         {
	                             breakpoint: size.desktop,
	                             settings: {
	                                 slidesToShow: 4,
	                                 vertical: false,
	                                 verticalSwiping: false
	                             }
	                         },
	                         {
	                             breakpoint: size.tabletBig,
	                             settings: {
	                                 slidesToShow: 3,
	                                 vertical: false,
	                                 verticalSwiping: false
	                             }
	                         },
	                         {
	                             breakpoint: size.tablet,
	                             settings: {
	                                 slidesToShow: 4,
	                                 vertical: true,
	                                 verticalSwiping: true
	                             }
	                         }
	                     ]
	                 })
	             );
	         }*/
	    }
	
	    setProductCard();
	
	    $(document).on('click', '.js-change-main-img', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var $mainImg = $this.closest('.product-card').find('#product-card-main-img');
	        var bigImgSrc = $this.data('big-img');
	
	        var classCurrent = 'product-card__previews-item--current';
	
	        $this.closest('.product-card__previews').find('.' + classCurrent).removeClass(classCurrent);
	
	        $this.addClass(classCurrent);
	
	        var img = new Image();
	        img.onload = function () {
	            $mainImg.fadeOut(300, function () {
	                $mainImg.removeClass('item--pdf');
	                if ($this.hasClass('product-detail__images-slider-item--pdf')) {
	                    $mainImg.attr('data-href', $this.attr('href'));
	                    $mainImg.addClass('item--pdf');
	                }
	                $mainImg.attr('src', bigImgSrc);
	                $mainImg.fadeIn(300);
	            });
	        };
	        img.src = bigImgSrc;
	    });
	
	    $(document).on('click', '.item--pdf', function (e) {
	        var $this = $(this);
	        window.open($this.attr('data-href'));
	    });
	});

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */,
/* 471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */,
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	__webpack_require__(297);
	__webpack_require__(388);
	__webpack_require__(474);
	
	var event = new _trackerEvents2['default']();
	
	var Basket = __webpack_require__(220);
	
	jQuery(function () {
	    var trackers = new _trackerTracker2['default']();
	    //закрытие popup окна по клику на кнопку вернуться к покупкам
	    $('body').on('click', 'button.js-close-btn', function (e) {
	        e.preventDefault();
	        $.prompt.close();
	    });
	
	    //Кнопка добавить в корзину
	    $('body').on('click', '.js-add-2-cart', function (e) {
	        e.preventDefault();
	        var iQuantity = $('input[name="product_quantity"]').val();
	
	        trackers.getTracker('gtm').onAddToCart();
	
	        if (!$.isNumeric(iQuantity)) {
	            iQuantity = 1;
	        }
	        var productId = $(this).data('product-id');
	        var $this = $(this);
	        var data = {
	            product_id: productId,
	            quantity: iQuantity
	        };
	
	        var product_name = $this.parent().parent().find('.product__name').data('name');
	
	        $.ajax({
	            url: '/ajax/action/basket_add_popup/add_to_basket_without_popup/',
	            data: data,
	            success: function success(result) {
	                $this.removeClass('js-add-2-cart');
	                $this.text(result.data.BUTTON_TEXT.toUpperCase());
	                if ($this.hasClass('product-card__btn')) {
	                    $this.attr('href', result.data.PATH_TO_BASKET);
	                    $('.js-product-quantity').hide();
	                }
	                if ($this.hasClass('product__btn')) {
	                    $this.removeClass('product__btn-buy');
	                    $this.addClass('product__btn-detail');
	                    $this.addClass('js-go-to-basket');
	                    $this.attr('data-href', result.data.PATH_TO_BASKET);
	                }
	
	                window.smartBuyTracker.basketItemAdded({ id: productId });
	                trackers.onPMbtnAddToCart({ param: product_name });
	                window.updateMiniBasket();
	                window.pushNewCartItem(productId, iQuantity);
	
	                // кидает ошибку, пока закоментим
	                //event.onAddToCardProduct($this);
	            }
	        });
	    });
	
	    //Кнопка добавить в корзину в шаблоне Протокол
	    $('body').on('click', '.js-add-2-cart--protocol', function (e) {
	        e.preventDefault();
	        var iQuantity = $('input[name="product_quantity"]').val();
	
	        trackers.getTracker('gtm').onAddToCart();
	
	        if (!$.isNumeric(iQuantity)) {
	            iQuantity = 1;
	        }
	        var productId = $(this).data('product-id');
	
	        var productIds = [];
	        if (productId.length) {
	            productIds = productId.split(',');
	        } else {
	            productIds.push(productId);
	        }
	
	        var $this = $(this);
	        $.each(productIds, function (key, value) {
	            var data = {
	                product_id: value,
	                quantity: iQuantity
	            };
	
	            var product_name = $this.parent().parent().find('.product__name').data('name');
	
	            $.ajax({
	                url: '/ajax/action/basket_add_popup/add_to_basket_without_popup/',
	                data: data,
	                success: function success(result) {
	                    if ($this.hasClass('product-card__btn')) {
	                        $this.attr('href', result.data.PATH_TO_BASKET);
	                        $('.js-product-quantity').hide();
	                    }
	                    if ($this.hasClass('product__btn')) {
	                        $this.removeClass('product__btn-buy');
	                        $this.addClass('product__btn-detail');
	                        $this.addClass('js-go-to-basket');
	                        $this.attr('data-href', result.data.PATH_TO_BASKET);
	                    }
	
	                    trackers.onPMbtnAddToCart({ param: product_name });
	                    window.updateMiniBasket();
	                    window.smartBuyTracker.basketItemAdded({ id: productId });
	                }
	            });
	        });
	        $this.removeClass('js-add-2-cart');
	        $this.text('В корзине');
	        event.onAddToCardProduct($this);
	    });
	
	    //Кнопка комплексной покупки
	    $('body').on('click', '.js-complex-buy', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:basket.add.popup/complex/?POPUP=Y&COMPLEX=Y&PRODUCT_ID=' + $(this).data('product-id'),
	            success: function success(result) {
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: false, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        prompt: 'prompt--large',
	                        form: 'prompt__form-special',
	                        close: 'jqiclose--cross'
	                    },
	                    submit: function submit(e) {
	                        e.preventDefault();
	                        window.updateMiniBasket();
	                    }
	                });
	            }
	        });
	    });
	
	    //Добавление в корзину при изменинии кол-ва в инпуте
	    $('body').on('change', 'input.js-quantity-input-basket', function () {
	        var basket = new Basket();
	        basket.updateProductQuantity($(this).data('product-id'), $(this).val(), $(this).data('parent-product-id'));
	    });
	
	    //Добавление в корзину при изменении кол-ва кнопками
	    $('body').on('click', '.quantity__btn', function () {
	        if ($(this).hasClass('js-quantity-minus-basket') || $(this).hasClass('js-quantity-plus-basket')) {
	            var iQuantity = $('input[name="QUANTITY_' + $(this).data('product-id') + '"]').val();
	            if ($(this).hasClass('js-quantity-plus')) {
	                iQuantity++;
	            } else if ($(this).hasClass('js-quantity-minus') && iQuantity > 0) {
	                iQuantity--;
	            }
	            var basket = new Basket();
	            basket.updateProductQuantity($(this).data('product-id'), iQuantity, $(this).data('parent-product-id'));
	        }
	    });
	
	    //Кнопка уведомить при поступлении товара
	    $(document).on('click', '.js-cart-inform', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:element.arrival.inform/.default/',
	            data: {
	                ELEMENT_ID: $(this).data('product-id')
	            },
	            success: function success(result) {
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: false, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        prompt: 'prompt--large',
	                        form: 'prompt__form-special',
	                        close: 'jqiclose--cross'
	                    },
	                    submit: function submit(e) {
	                        e.preventDefault();
	                        $.ajax({
	                            url: '/ajax/action/element_arrival_inform/add_to_sch_list/',
	                            data: $('form.jqiform').serialize(),
	                            success: function success(result) {
	                                $('#subscribe__content').html(result.html);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	
	    $('.js-beautician-price-request-tooltip').tooltipster({
	        content: $('.js-beautician-price-request-tooltip-content').html(),
	        interactive: true,
	        contentAsHTML: true,
	        position: 'bottom',
	        maxWidth: 320,
	        minWidth: 320,
	
	        repositionOnScroll: true,
	        side: ['bottom', 'top'],
	        trigger: 'custom',
	        triggerOpen: {
	            mouseenter: true,
	            tap: true
	        },
	        triggerClose: {
	            mouseleave: true,
	            tap: true
	        },
	        updateAnimation: null
	    });
	
	    $(document).on('click', '.js-beautician-price-request', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:widget.beautician.price.request/.default/',
	            data: {
	                ELEMENT_ID: $(this).data('product-id')
	            },
	            success: function success(result) {
	                $('.js-beautician-price-request-tooltip').tooltipster('hide');
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: true, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        form: 'beautician-price-request-form'
	                    },
	                    submit: function submit(e, v, m, form) {
	                        e.preventDefault();
	
	                        var preLoader = new _modulesPreloader2['default']();
	                        preLoader.show();
	
	                        var files = $('.js-attach-file-input-controll')[0].files;
	                        var formData = new FormData();
	                        for (var _name in form) {
	                            formData.append(_name, form[_name]);
	                        }
	
	                        for (var k = 0; k <= files.length; k++) {
	                            if (files[k]) {
	                                formData.append('ATTACH_FILES[]', files[k]);
	                            }
	                        }
	
	                        $.ajax({
	                            url: '/ajax/action/widget_beautician_price_request/submit_form/',
	                            data: formData,
	                            processData: false,
	                            contentType: false,
	                            type: 'POST',
	                            cache: false,
	                            success: function success(response) {
	                                preLoader.hide();
	                                if (response['code'] === 400) {
	                                    $('.js-beautician-price-request-error').html(response.message);
	                                    return;
	                                }
	                                $('.js-beautician-price-request-container').html(response.html);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	
	    $(document).on('click', '.js-btn-detail', function (e) {
	        e.preventDefault();
	        var element = e.target;
	        window.location = element.getAttribute('data-href');
	    });
	
	    $(document).on('click', '.js-go-to-basket', function (e) {
	        e.preventDefault();
	        var element = e.target;
	        window.location = element.getAttribute('data-href');
	    });
	
	    $(document).on('click', '.js-close-window', function (e) {
	        e.preventDefault();
	        $.prompt.close();
	    });
	});

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var trackers = new _trackerTracker2['default']();
	
	var pushNewCartItem = function pushNewCartItem(productId, quantity) {
	    var ajaxData = {
	        productId: productId,
	        quantity: quantity
	    };
	    $.ajax({
	        url: '/ajax/action/basket_add_popup/get_data_layer/',
	        type: 'post',
	        async: false,
	        data: ajaxData,
	        success: function success(result) {
	            if (result.data.productData !== undefined) {
	                trackers.onAddToCart({
	                    fbpixel: {
	                        content_name: result.data.productData.name,
	                        value: result.data.productData.price
	                    },
	                    gtm: {
	                        ecommerce: {
	                            add: {
	                                products: [result.data.productData]
	                            }
	                        }
	                    }
	                });
	            }
	        },
	        error: function error() {
	            console.log('Error getDataLayer');
	        }
	    });
	};
	
	window.pushNewCartItem = pushNewCartItem;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	__webpack_require__(476);
	
	var Quantity = (function () {
	    /**
	     * В конструктор передается изменямый элемент
	     * @param element {HTMLElement}
	     */
	
	    function Quantity(element) {
	        _classCallCheck(this, Quantity);
	
	        this.element = $(element);
	        this.block = this.element.closest('.js-quantity-block');
	        this.input = this.block.find('.quantity__value');
	    }
	
	    /**
	     * Изменить количество
	     * @param callback {Function}
	     * @returns {boolean}
	     */
	
	    _createClass(Quantity, [{
	        key: 'change',
	        value: function change(callback) {
	            if (this.block.hasClass('js-quantity-block-disabled')) return false;
	
	            var curValue = parseInt(this.input.val());
	            if (isNaN(curValue)) {
	                curValue = 0;
	            }
	
	            if (callback === undefined || callback(this.input, curValue)) {
	                this.input.val(curValue);
	            }
	        }
	
	        /**
	         * Увеличить количество
	         * @param callback {Function}
	         * @returns {boolean}
	         */
	    }, {
	        key: 'plus',
	        value: function plus(callback) {
	            if (this.block.hasClass('js-quantity-block-disabled')) return false;
	
	            var curValue = parseInt(this.input.val());
	            curValue += 1;
	
	            if (callback === undefined || callback(this.input, curValue)) {
	                this.input.val(curValue);
	            }
	        }
	
	        /**
	         * Уменьшить количество
	         * @param callback {Function}
	         * @returns {boolean}
	         */
	    }, {
	        key: 'minus',
	        value: function minus(callback) {
	            if (this.block.hasClass('js-quantity-block-disabled')) return false;
	
	            var curValue = parseInt(this.input.val());
	            curValue -= 1;
	
	            if (curValue < 0) curValue = 0;
	
	            if (callback === undefined || callback(this.input, curValue)) {
	                this.input.val(curValue);
	            }
	        }
	    }]);
	
	    return Quantity;
	})();
	
	module.exports = Quantity;
	
	jQuery(function () {
	    $('.js-quantity-block').each(function () {
	        var $block = $(this);
	        var $btnMinus = $block.find('.quantity__minus');
	        var $btnPlus = $block.find('.quantity__plus');
	
	        //чтобы при быстром кликаньи по кнопкам не срабатывало выделение текста в инпуте
	        $btnMinus.add($btnPlus).mousedown(function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            return false;
	        });
	
	        if ($block.hasClass('js-quantity-block-disabled')) return false;
	    });
	
	    $(document).on('change', '.js-quantity-input', function () {
	        var quantity = new Quantity(this);
	        quantity.change();
	    });
	
	    $(document).on('click', '.js-quantity-plus', function () {
	        var quantity = new Quantity(this);
	        quantity.plus();
	    });
	
	    $(document).on('click', '.js-quantity-minus', function () {
	        var quantity = new Quantity(this);
	        quantity.minus();
	    });
	});

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//import {PopupMessage} from '../popup/popup';
	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _modulesFunctions = __webpack_require__(163);
	
	var _modulesFunctions2 = _interopRequireDefault(_modulesFunctions);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesTrackerRetailrocket = __webpack_require__(479);
	
	__webpack_require__(297);
	
	var autoComplete = __webpack_require__(449);
	var styleSelects = __webpack_require__(306);
	
	/**
	 *  Класс для работы авторизации/регистрации по смс
	 */
	
	var LoginBySms = (function () {
	    function LoginBySms() {
	        _classCallCheck(this, LoginBySms);
	
	        this.loader = new _modulesPreloader2['default']();
	        this.isInit = false;
	        this.timeReset = 60;
	        this.timerId = null;
	        this.retailRocket = new _modulesTrackerRetailrocket.RetailRocket();
	
	        /**
	         * Вот эта переменная нужна чтобы не отправлять запрос
	         * на проверку кода и авторизацию после ввода 4 символов
	         * @type {boolean}
	         */
	        this.isSendLoginBySmsQuery = false;
	    }
	
	    /**
	     *  Подтягивает контент для формы и показывает окно авторизации
	     */
	
	    _createClass(LoginBySms, [{
	        key: 'initElements',
	
	        //PopupMessage.show(result.html);
	
	        /**
	         * Инициализация элементов DOM
	         * @param jqActionLink
	         */
	        value: function initElements(jqActionLink) {
	            if (this.isInit) {
	                return;
	            }
	
	            var _self = this;
	            this.isInit = true;
	            this.jqActionLink = jqActionLink;
	            this.loginMainContainer = jqActionLink.parents('.js-login-by-sms-main-container');
	            this.recoveryMainContainer = this.loginMainContainer.next();
	
	            this.jqMode = this.loginMainContainer.find('.js-mode');
	            this.jqTestSmsCode = this.loginMainContainer.find('.js-test-code');
	
	            this.jqInputPhoneNumber = this.loginMainContainer.find('.js-phone');
	
	            this.jqInputNameContainer = this.loginMainContainer.find('.js-name-container');
	            this.jqInputName = this.jqInputNameContainer.find('input');
	
	            this.jqInputLastNameContainer = this.loginMainContainer.find('.js-last-name-container');
	            this.jqInputLastName = this.jqInputLastNameContainer.find('input');
	
	            this.jqInputEmailContainer = this.loginMainContainer.find('.js-email-container');
	            this.jqInputEmail = this.jqInputEmailContainer.find('input');
	
	            this.jqInputLocationContainer = this.loginMainContainer.find('.js-last-location-container');
	            this.jqInputLocation = this.jqInputLocationContainer.find('input');
	
	            this.jqSelectUserTypeContainer = this.loginMainContainer.find('.js-last-user-type-container');
	            this.jqSelectUserType = this.jqSelectUserTypeContainer.find('select');
	
	            this.jqCodeContainer = this.loginMainContainer.find('.js-code-container');
	            this.jqCodeContainerTimerText = this.loginMainContainer.find('.js-code-timer-text-container');
	
	            this.jqTimer = this.loginMainContainer.find('.js-timer');
	
	            this.jqInputSmsCode = this.jqCodeContainer.find('input');
	
	            this.jqErrorContainer = this.loginMainContainer.find('.js-error-container');
	
	            /**
	             * Если это форма заказ в 1 клик
	             * @type {boolean}
	             */
	            this.isOneClick = this.loginMainContainer.find('.js-onle-click').val() === 'Y';
	            this.productId = this.loginMainContainer.find('.js-onle-click-product').val();
	
	            /**
	             *  Вот это событие для вставки кода смс на мобиле
	             */
	            this.jqInputSmsCode.on('input', function (e) {
	                var code = $(this).val();
	                if (code.length === 4) {
	                    if (_self.isSendLoginBySmsQuery === true) {
	                        return;
	                    }
	
	                    var phoneNumber = $.trim(_self.jqInputPhoneNumber.val());
	                    _self.login(phoneNumber, code);
	                    event.preventDefault();
	                }
	            });
	
	            this.jqInputSmsCode.on('keydown', function (event) {
	                _self.hideErrorInput($(this));
	
	                // Разрешаем: backspace, delete, tab и escape
	                if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 ||
	                // Разрешаем: Ctrl+A
	                event.keyCode === 65 && event.ctrlKey === true ||
	                /*(event.keyCode === 86 && event.ctrlKey === true) ||*/
	                // Разрешаем: home, end, влево, вправо
	                event.keyCode >= 35 && event.keyCode <= 39) {
	                    // Ничего не делаем
	                    return;
	                } else {
	                    var code = $(this).val();
	                    if (code.length === 4) {
	                        event.preventDefault();
	                        return;
	                    }
	
	                    // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
	                    if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
	                        event.preventDefault();
	                    }
	                }
	            });
	
	            this.jqInputSmsCode.on('keyup', function () {
	                if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 ||
	                // Разрешаем: Ctrl+A
	                event.keyCode === 65 && event.ctrlKey === true || event.keyCode === 86 && event.ctrlKey === true ||
	                // Разрешаем: home, end, влево, вправо
	                event.keyCode >= 35 && event.keyCode <= 39) {
	                    // Ничего не делаем
	                    return;
	                }
	
	                var code = $(this).val();
	
	                if (code.length === 4) {
	                    if (_self.isSendLoginBySmsQuery === true) {
	                        return;
	                    }
	
	                    var phoneNumber = $.trim(_self.jqInputPhoneNumber.val());
	                    _self.login(phoneNumber, code);
	                }
	            });
	        }
	
	        /**
	         * Запрос смс кода
	         * @param jqActionLink
	         */
	    }, {
	        key: 'getSmsCode',
	        value: function getSmsCode(jqActionLink) {
	            this.initElements(jqActionLink);
	
	            var _self = this;
	
	            var phoneNumber = $.trim(this.jqInputPhoneNumber.val());
	            if (phoneNumber.length === 0) {
	                return;
	            }
	
	            var mode = this.jqMode.val();
	
	            var ajaxPath = undefined,
	                dataParams = undefined;
	            if (mode === 'AUT') {
	                // https://www.smartbuy.ru/ajax/action/basket_add_popup/get_data_layer/
	                //ajaxPath = '/ajax/action/maximaster:widget.login.by.sms/get_sms_code/';
	                ajaxPath = '/ajax/action/widget_login_by_sms/get_sms_code/';
	                dataParams = {
	                    phone: phoneNumber,
	                    isOneClick: _self.isOneClick ? 'Y' : 'N'
	                };
	            }
	
	            if (mode === 'REGISTER') {
	                //ajaxPath = '/ajax/action/maximaster:widget.login.by.sms/registration/';
	                ajaxPath = '/ajax/action/widget_login_by_sms/registration/';
	                dataParams = {
	                    phone: phoneNumber,
	                    name: $.trim(this.jqInputName.val()),
	                    last_name: $.trim(this.jqInputLastName.val()),
	                    email: $.trim(this.jqInputEmail.val()),
	                    location: $.trim(this.jqInputLocation.val()),
	                    userType: $.trim(this.jqSelectUserType.val()),
	                    isOneClick: _self.isOneClick ? 'Y' : 'N'
	                };
	            }
	
	            this.loader.show();
	
	            $.ajax({
	                url: ajaxPath,
	                type: 'POST',
	                data: dataParams,
	                success: function success(result) {
	                    _self.loader.hide();
	
	                    _self.jqErrorContainer.empty();
	                    _self.hideErrorInput(_self.jqInputName);
	                    _self.hideErrorInput(_self.jqInputLastName);
	                    _self.hideErrorInput(_self.jqInputEmail);
	                    _self.hideErrorInput(_self.jqInputLocation);
	
	                    var data = result.data;
	
	                    if (result.code === 401) {
	                        /**
	                         *  Если при попытке регистрации возникли ошиьки
	                         *  показываем их
	                         */
	                        if (data.mode === 'RIGISTR_ERROR_FIELDS') {
	                            var errors = data.errors;
	                            var count = errors.length;
	                            if (count > 0) {
	                                for (var i = 0; i < count; i++) {
	                                    if (errors[i].TYPE === 'INPUT_NAME_ERROR') {
	                                        _self.showErrorInput(_self.jqInputName);
	                                    }
	
	                                    if (errors[i].TYPE === 'INPUT_LAST_NAME_ERROR') {
	                                        _self.showErrorInput(_self.jqInputLastName);
	                                    }
	
	                                    if (errors[i].TYPE === 'INPUT_EMAIL') {
	                                        _self.showErrorInput(_self.jqInputEmail);
	                                    }
	
	                                    if (errors[i].TYPE === 'INPUT_LOCATION') {
	                                        _self.showErrorInput(_self.jqInputLocation);
	                                    }
	
	                                    if (errors[i].TYPE === 'ERROR_EMAIL_ACCOUNT') {
	                                        _self.jqErrorContainer.html(errors[i].TEXT);
	                                    }
	                                }
	                            }
	
	                            return;
	                        }
	
	                        _self.jqErrorContainer.html(data.error);
	
	                        return;
	                    }
	
	                    var mode = result.data.mode;
	                    switch (mode) {
	                        /**
	                         *  Пользователь существует, ждем ввод кода СМС
	                         */
	                        case 'SET_SMS_CODE':
	                            _self.jqCodeContainer.show();
	                            _self.jqInputSmsCode.focus();
	                            _self.jqCodeContainerTimerText.show();
	                            _self.jqInputPhoneNumber.prop('disabled', true);
	                            _self.jqActionLink.addClass('button--disable-login').attr('data-disabled', 'Y');
	                            _self.timerSecond(_self.timeReset, 'aut');
	
	                            /**
	                             *  @todo убрать на проде
	                             */
	                            //_self.jqTestSmsCode.val(result.data.code);
	
	                            break;
	
	                        /**
	                         *  Если в ответе пришла метка на регистрацию
	                         *  показываем дополнительные поля и устанавливем типа
	                         *  следущего запроса  REGISTER
	                         */
	                        case 'SHOW_REGISTER_FIELDS':
	                            _self.jqInputPhoneNumber.prop('disabled', true);
	                            _self.jqInputNameContainer.show();
	                            _self.jqInputLastNameContainer.show();
	                            _self.jqInputEmailContainer.show();
	                            _self.jqInputLocationContainer.show();
	                            _self.jqSelectUserTypeContainer.show();
	                            _self.jqMode.val('REGISTER');
	                            styleSelects.styleSelects($('.js-styled-select'));
	                            //window.beautyShopTracker.registerPageViewed();
	
	                            break;
	
	                        case 'REGISTER_RESULT':
	                            _self.jqCodeContainer.show();
	                            _self.jqCodeContainerTimerText.show();
	                            _self.jqInputName.prop('disabled', true);
	                            _self.jqInputLastName.prop('disabled', true);
	                            _self.jqInputEmail.prop('disabled', true);
	                            _self.jqInputPhoneNumber.prop('disabled', true);
	                            _self.jqInputLocation.prop('disabled', true);
	                            _self.jqSelectUserType.prop('disabled', true);
	
	                            _self.jqActionLink.addClass('button--disable-login').attr('data-disabled', 'Y');
	
	                            _self.timerSecond(_self.timeReset, 'reg');
	
	                            _self.retailRocket.setProfile({
	                                email: dataParams.email,
	                                phone: dataParams.phone,
	                                isAgreedToReceiveMarketingMail: true
	                            });
	
	                            /**
	                             *  @todo убрать на проде
	                             */
	                            //_self.jqTestSmsCode.val(result.data.code);
	
	                            break;
	                    }
	                }
	            });
	        }
	
	        /**
	         * Заказ в один клик
	         * @param data
	         */
	    }, {
	        key: 'orderOneClick',
	        value: function orderOneClick(data) {
	            $.ajax({
	                //url: '/ajax/action/maximaster:widget.order/ajaxOneClickLoginBySms/',
	                //url: '/ajax/action/widget_order/ajaxOneClickLoginBySms/',
	                url: '/ajax/action/order_oneclick/buy/',
	                type: 'POST',
	                data: data,
	                success: function success(result) {
	                    if (result.data['SUCCESS']) {
	                        //window.beautyShopTracker.orderPageOneClickOrderButtonClicked();
	                        //window.beautyShopTracker.subscriptionPopupForms(data.EMAIL);
	                        window.location.href = result.data['ORDER_PAGE'];
	                    } else {
	                        alert(result.data['ERROR']);
	                    }
	                }
	            });
	        }
	
	        /**
	         * Авторизация после получения кода
	         * @param phoneNumber
	         * @param code
	         */
	    }, {
	        key: 'login',
	        value: function login(phoneNumber, code) {
	            var _self = this;
	
	            _self.loader.show();
	            //clearTimeout(this.timerId);
	
	            _self.isSendLoginBySmsQuery = true;
	
	            $.ajax({
	                //url: '/ajax/action/maximaster:widget.login.by.sms/login/',
	                url: '/ajax/action/widget_login_by_sms/login/',
	                type: 'POST',
	                data: {
	                    code: code,
	                    phoneNumber: phoneNumber
	                },
	                success: function success(result) {
	                    _self.isSendLoginBySmsQuery = false;
	                    var action = result.data.ACTION || '';
	                    console.log(action);
	                    if (result.code === 200) {
	                        if (_self.isOneClick) {
	                            var oneClickData = result.data;
	                            var productsParams = [];
	                            productsParams.push({ id: parseInt(_self.productId), quantity: 1 });
	
	                            oneClickData.products = productsParams;
	
	                            _self.orderOneClick(oneClickData);
	                            return;
	                        }
	
	                        if (action === 'AUT') {}
	
	                        if (action === 'REG') {
	                            var trackers = new _trackerTracker2['default']();
	                            trackers.getTracker('gtm').pushEvent('completeRegistration');
	                        }
	
	                        _modulesFunctions2['default'].setCookie('BITRIX_SM_is_aut', 'Y', { expires: 604800, path: '/' });
	
	                        location.reload();
	                    }
	
	                    if (result.code === 400) {
	                        _self.showErrorInput(_self.jqInputSmsCode);
	                        _self.loader.hide();
	                        return;
	                    }
	
	                    if (result.code === 500) {
	                        alert('Ошибка, попробуйте позже, мы уже занимаемся устранением проблемы.');
	                        _self.loader.hide();
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'showErrorInput',
	        value: function showErrorInput(jqInput) {
	            jqInput.parent().prev().show();
	            jqInput.addClass('form__input--error');
	        }
	    }, {
	        key: 'hideErrorInput',
	        value: function hideErrorInput(jqInput) {
	            jqInput.parent().prev().hide();
	            jqInput.removeClass('form__input--error');
	        }
	
	        /**
	         * Таймер для вывода счетчика
	         * @param count - кол-во сек
	         * @param mode - для авторизации и для регистрации
	         */
	    }, {
	        key: 'timerSecond',
	        value: function timerSecond(count, mode) {
	            var _this = this;
	
	            if (count > 0) {
	                (function () {
	                    var _self = _this;
	                    _this.jqTimer.text(count + _this.declOfNum(count, [' секунда', ' секунды', ' секунд']));
	                    _this.timerId = setTimeout(function () {
	                        _self.timerSecond(count - 1, mode);
	                    }, 1000);
	                })();
	            } else {
	                if (mode === 'aut') {
	                    this.resetAutFields();
	                }
	
	                if (mode === 'reg') {
	                    this.resetRegFields();
	                }
	            }
	        }
	    }, {
	        key: 'declOfNum',
	        value: function declOfNum(number, titles) {
	            var cases = [2, 0, 1, 1, 1, 2];
	            return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
	        }
	    }, {
	        key: 'resetAutFields',
	        value: function resetAutFields() {
	            this.jqCodeContainerTimerText.hide();
	            this.jqActionLink.removeClass('button--disable-login').attr('data-disabled', 'N');
	            this.jqInputPhoneNumber.prop('disabled', false);
	        }
	    }, {
	        key: 'resetRegFields',
	        value: function resetRegFields() {
	            this.jqCodeContainerTimerText.hide();
	            this.jqActionLink.removeClass('button--disable-login').attr('data-disabled', 'N');
	        }
	    }, {
	        key: 'getHtmlRecoveryByEmail',
	        value: function getHtmlRecoveryByEmail() {
	            var _self = this;
	
	            $.ajax({
	                url: '/ajax/action/widget_login_by_sms/get_html_recovery_by_email/',
	                type: 'GET',
	                data: {
	                    email: this.jqInputEmail.val()
	                },
	                success: function success(result) {
	                    _self.loginMainContainer.hide();
	                    _self.recoveryMainContainer.show().html(result.html);
	                }
	            });
	        }
	    }, {
	        key: 'showFormLoginBySms',
	        value: function showFormLoginBySms() {
	            this.loginMainContainer.show();
	            this.recoveryMainContainer.hide().empty();
	        }
	    }, {
	        key: 'sendRecoveryEmail',
	        value: function sendRecoveryEmail() {
	            var email = this.recoveryMainContainer.find('.js-email ').val();
	
	            var _self = this;
	
	            this.loader.show();
	
	            $.ajax({
	                url: '/ajax/action/widget_login_by_sms/send_email_for_recovery/',
	                type: 'GET',
	                data: {
	                    email: email
	                },
	                data: {
	                    email: this.jqInputEmail.val()
	                },
	                success: function success(result) {
	                    _self.loader.hide();
	
	                    if (result.code === 401) {
	                        alert('Ошибка, попробуйте позже');
	                        return;
	                    }
	
	                    if (result.code === 200) {
	                        _self.recoveryMainContainer.find('.js-recovery-form-fields-container').hide();
	                        _self.recoveryMainContainer.find('.js-recovery-result-container').show();
	                    }
	                    //_self.loginMainContainer.hide();
	                    //_self.recoveryMainContainer.show().html(result.html);
	                }
	            });
	        }
	    }], [{
	        key: 'showPopup',
	        value: function showPopup() {
	            var isOneClick = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	            var productId = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	            $.ajax({
	                url: '/ajax/component/maximaster:widget.login.by.sms.popup/',
	                type: 'GET',
	                data: {
	                    isOneClick: isOneClick ? 'Y' : 'N',
	                    productId: productId
	                },
	                success: function success(result) {
	                    $.prompt(result.html);
	                }
	            });
	        }
	    }]);
	
	    return LoginBySms;
	})();
	
	exports.LoginBySms = LoginBySms;
	
	jQuery(function () {
	    window.LoginBySms = new LoginBySms();
	
	    /**
	     *  Открытие окна с формой авторизации
	     */
	    $(document).on('click', '.js-login-by-sms-show-popup', function () {
	        LoginBySms.showPopup();
	        window.LoginBySms = new LoginBySms();
	    });
	
	    /**
	     *  Отправка запроса на отправку смс
	     */
	    $(document).on('click', '.js-login-by-sms-action-link', function () {
	        var isDisabled = $(this).attr('data-disabled') === 'Y';
	        if (isDisabled) {
	            return;
	        }
	
	        window.LoginBySms.getSmsCode($(this));
	    });
	
	    /**
	     *  Показ формы для запроса восстановления пароля
	     */
	    $(document).on('click', '.js-recovery-by-email-link', function () {
	        window.LoginBySms.getHtmlRecoveryByEmail();
	        return false;
	    });
	
	    /**
	     *  Переход к форме авторизации
	     */
	    $(document).on('click', '.js-show-login-by-sms-form', function () {
	        window.LoginBySms.showFormLoginBySms();
	        return false;
	    });
	
	    /**
	     *  Отправка сообщения на воссатновление аккаунта
	     */
	    $(document).on('click', '.js-send-recovery-email-link', function () {
	        window.LoginBySms.sendRecoveryEmail();
	        return false;
	    });
	
	    $(document).on('click', '.js-one-click-aut', function () {
	        var productId = $(this).attr('data-product-id');
	        LoginBySms.showPopup(true, productId);
	        window.LoginBySms = new LoginBySms();
	        return false;
	    });
	
	    /**
	     * Это нужно чтобы после авторизации и загрузки страницы выполнить метод
	     * userAuthorizedMain
	     */
	    var isAfterAut = _modulesFunctions2['default'].getCookie('BITRIX_SM_is_aut') === 'Y';
	    if (isAfterAut) {
	        //window.beautyShopTracker.userAuthorizedMain({});
	        _modulesFunctions2['default'].deleteCookie('BITRIX_SM_is_aut');
	    }
	
	    $(document).on('focus', '.js-autocomplete', function () {
	        autoComplete.setAutocomplete($('.js-autocomplete'));
	    });
	});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(111)["default"];
	
	var _classCallCheck = __webpack_require__(116)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var RetailRocket = (function () {
	    function RetailRocket() {
	        _classCallCheck(this, RetailRocket);
	    }
	
	    _createClass(RetailRocket, [{
	        key: "track",
	        value: function track(callback) {
	            (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
	                try {
	                    callback();
	                } catch (e) {
	                    if (false) {
	                        console.log(e);
	                    }
	                }
	            });
	        }
	    }, {
	        key: "viewContentProduct",
	        value: function viewContentProduct(product) {
	            if (!product) {
	                return;
	            }
	
	            var callback = undefined;
	            if (product.is_offers) {
	                callback = function () {
	                    console.log('rr viewContentProduct product offers');
	                    rrApi.groupView(product.offers_id);
	                };
	            } else {
	                callback = function () {
	                    console.log('rr viewContentProduct product');
	                    rrApi.view(product.id);
	                };
	            }
	
	            this.track(callback);
	        }
	    }, {
	        key: "viewContentCategory",
	        value: function viewContentCategory(category) {
	            if (!category) {
	                return;
	            }
	
	            this.track(function () {
	                console.log('rr viewContentCategory');
	                rrApi.categoryView(category.id);
	            });
	        }
	    }, {
	        key: "setProfile",
	        value: function setProfile(params) {
	            if (!params) {
	                return;
	            }
	            console.log(params);
	            this.track(function () {
	                console.log('rr setProfile');
	                rrApi.setProfile(params);
	            });
	        }
	
	        /*
	        subscription(email) {
	            this.track(function() {
	                rrApi.setEmail(email);
	                rrApi.welcomeSequence(email);
	            });
	        }
	         subscriptionPopup(email) {
	            this.track(function() {
	                rrApi.setEmail(email, {EmailPopUp: true});
	                rrApi.welcomeSequence(email);
	            });
	        }
	         oneClick(productId) {
	            this.track(function() {
	                rrApi.addToBasket(productId);
	            });
	        }
	        */
	
	    }, {
	        key: "addToCart",
	        value: function addToCart(product) {
	            this.track(function () {
	                console.log('rr addToCart');
	                rrApi.addToBasket(product.id);
	            });
	        }
	    }, {
	        key: "orderTransaction",
	        value: function orderTransaction(order, basket) {
	            var params = {
	                transaction: order.id,
	                items: this.formatBasket(basket)
	            };
	            this.track(function () {
	                console.log('rr orderTransaction');
	                rrApi.order(params);
	            });
	        }
	
	        /*
	        productAddToFavorite(params) {
	            this.track(function() {
	                rrApi.subscribeonpricedrop(params.email, [params.product]);
	            });
	        }
	        */
	
	    }, {
	        key: "formatBasket",
	        value: function formatBasket(basket) {
	            return basket.map(function (basketItem) {
	                return RetailRocket.formatBasketItem(basketItem);
	            });
	        }
	    }], [{
	        key: "formatBasketItem",
	        value: function formatBasketItem(basketItem) {
	            return {
	                id: basketItem.offer_id || basketItem.id,
	                qnt: parseFloat(basketItem.quantity),
	                price: parseFloat(basketItem.price)
	            };
	        }
	    }]);
	
	    return RetailRocket;
	})();

	exports.RetailRocket = RetailRocket;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */,
/* 482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */,
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! picturefill - v3.0.2 - 2016-02-12
	 * https://scottjehl.github.io/picturefill/
	 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
	 */
	/*! Gecko-Picture - v1.0
	 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
	 * Firefox's early picture implementation (prior to FF41) is static and does
	 * not react to viewport changes. This tiny module fixes this.
	 */
	(function(window) {
		/*jshint eqnull:true */
		var ua = navigator.userAgent;
	
		if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
			addEventListener("resize", (function() {
				var timer;
	
				var dummySrc = document.createElement("source");
	
				var fixRespimg = function(img) {
					var source, sizes;
					var picture = img.parentNode;
	
					if (picture.nodeName.toUpperCase() === "PICTURE") {
						source = dummySrc.cloneNode();
	
						picture.insertBefore(source, picture.firstElementChild);
						setTimeout(function() {
							picture.removeChild(source);
						});
					} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
						img._pfLastSize = img.offsetWidth;
						sizes = img.sizes;
						img.sizes += ",100vw";
						setTimeout(function() {
							img.sizes = sizes;
						});
					}
				};
	
				var findPictureImgs = function() {
					var i;
					var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
					for (i = 0; i < imgs.length; i++) {
						fixRespimg(imgs[i]);
					}
				};
				var onResize = function() {
					clearTimeout(timer);
					timer = setTimeout(findPictureImgs, 99);
				};
				var mq = window.matchMedia && matchMedia("(orientation: landscape)");
				var init = function() {
					onResize();
	
					if (mq && mq.addListener) {
						mq.addListener(onResize);
					}
				};
	
				dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	
				if (/^[c|i]|d$/.test(document.readyState || "")) {
					init();
				} else {
					document.addEventListener("DOMContentLoaded", init);
				}
	
				return onResize;
			})());
		}
	})(window);
	
	/*! Picturefill - v3.0.2
	 * http://scottjehl.github.io/picturefill
	 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
	 *  License: MIT
	 */
	
	(function( window, document, undefined ) {
		// Enable strict mode
		"use strict";
	
		// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
		document.createElement( "picture" );
	
		var warn, eminpx, alwaysCheckWDescriptor, evalId;
		// local object for method references and testing exposure
		var pf = {};
		var isSupportTestReady = false;
		var noop = function() {};
		var image = document.createElement( "img" );
		var getImgAttr = image.getAttribute;
		var setImgAttr = image.setAttribute;
		var removeImgAttr = image.removeAttribute;
		var docElem = document.documentElement;
		var types = {};
		var cfg = {
			//resource selection:
			algorithm: ""
		};
		var srcAttr = "data-pfsrc";
		var srcsetAttr = srcAttr + "set";
		// ua sniffing is done for undetectable img loading features,
		// to do some non crucial perf optimizations
		var ua = navigator.userAgent;
		var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
		var curSrcProp = "currentSrc";
		var regWDesc = /\s+\+?\d+(e\d+)?w/;
		var regSize = /(\([^)]+\))?\s*(.+)/;
		var setOptions = window.picturefillCFG;
		/**
		 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
		 */
		// baseStyle also used by getEmValue (i.e.: width: 1em is important)
		var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
		var fsCss = "font-size:100%!important;";
		var isVwDirty = true;
	
		var cssCache = {};
		var sizeLengthCache = {};
		var DPR = window.devicePixelRatio;
		var units = {
			px: 1,
			"in": 96
		};
		var anchor = document.createElement( "a" );
		/**
		 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
		 * @type {boolean}
		 */
		var alreadyRun = false;
	
		// Reusable, non-"g" Regexes
	
		// (Don't use \s, to avoid matching non-breaking space.)
		var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
		    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
		    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
		    regexTrailingCommas = /[,]+$/,
		    regexNonNegativeInteger = /^\d+$/,
	
		    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
		    // Must include at least one digit.
		    // According to spec tests any decimal point must be followed by a digit.
		    // No leading plus sign is allowed.)
		    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
		    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;
	
		var on = function(obj, evt, fn, capture) {
			if ( obj.addEventListener ) {
				obj.addEventListener(evt, fn, capture || false);
			} else if ( obj.attachEvent ) {
				obj.attachEvent( "on" + evt, fn);
			}
		};
	
		/**
		 * simple memoize function:
		 */
	
		var memoize = function(fn) {
			var cache = {};
			return function(input) {
				if ( !(input in cache) ) {
					cache[ input ] = fn(input);
				}
				return cache[ input ];
			};
		};
	
		// UTILITY FUNCTIONS
	
		// Manual is faster than RegEx
		// http://jsperf.com/whitespace-character/5
		function isSpace(c) {
			return (c === "\u0020" || // space
			        c === "\u0009" || // horizontal tab
			        c === "\u000A" || // new line
			        c === "\u000C" || // form feed
			        c === "\u000D");  // carriage return
		}
	
		/**
		 * gets a mediaquery and returns a boolean or gets a css length and returns a number
		 * @param css mediaqueries or css length
		 * @returns {boolean|number}
		 *
		 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
		 */
		var evalCSS = (function() {
	
			var regLength = /^([\d\.]+)(em|vw|px)$/;
			var replace = function() {
				var args = arguments, index = 0, string = args[0];
				while (++index in args) {
					string = string.replace(args[index], args[++index]);
				}
				return string;
			};
	
			var buildStr = memoize(function(css) {
	
				return "return " + replace((css || "").toLowerCase(),
					// interpret `and`
					/\band\b/g, "&&",
	
					// interpret `,`
					/,/g, "||",
	
					// interpret `min-` as >=
					/min-([a-z-\s]+):/g, "e.$1>=",
	
					// interpret `max-` as <=
					/max-([a-z-\s]+):/g, "e.$1<=",
	
					//calc value
					/calc([^)]+)/g, "($1)",
	
					// interpret css values
					/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
					//make eval less evil
					/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
				) + ";";
			});
	
			return function(css, length) {
				var parsedLength;
				if (!(css in cssCache)) {
					cssCache[css] = false;
					if (length && (parsedLength = css.match( regLength ))) {
						cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
					} else {
						/*jshint evil:true */
						try{
							cssCache[css] = new Function("e", buildStr(css))(units);
						} catch(e) {}
						/*jshint evil:false */
					}
				}
				return cssCache[css];
			};
		})();
	
		var setResolution = function( candidate, sizesattr ) {
			if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
				candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
				candidate.res = candidate.w / candidate.cWidth ;
			} else {
				candidate.res = candidate.d;
			}
			return candidate;
		};
	
		/**
		 *
		 * @param opt
		 */
		var picturefill = function( opt ) {
	
			if (!isSupportTestReady) {return;}
	
			var elements, i, plen;
	
			var options = opt || {};
	
			if ( options.elements && options.elements.nodeType === 1 ) {
				if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
					options.elements =  [ options.elements ];
				} else {
					options.context = options.elements;
					options.elements =  null;
				}
			}
	
			elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );
	
			if ( (plen = elements.length) ) {
	
				pf.setupRun( options );
				alreadyRun = true;
	
				// Loop through all elements
				for ( i = 0; i < plen; i++ ) {
					pf.fillImg(elements[ i ], options);
				}
	
				pf.teardownRun( options );
			}
		};
	
		/**
		 * outputs a warning for the developer
		 * @param {message}
		 * @type {Function}
		 */
		warn = ( window.console && console.warn ) ?
			function( message ) {
				console.warn( message );
			} :
			noop
		;
	
		if ( !(curSrcProp in image) ) {
			curSrcProp = "src";
		}
	
		// Add support for standard mime types.
		types[ "image/jpeg" ] = true;
		types[ "image/gif" ] = true;
		types[ "image/png" ] = true;
	
		function detectTypeSupport( type, typeUri ) {
			// based on Modernizr's lossless img-webp test
			// note: asynchronous
			var image = new window.Image();
			image.onerror = function() {
				types[ type ] = false;
				picturefill();
			};
			image.onload = function() {
				types[ type ] = image.width === 1;
				picturefill();
			};
			image.src = typeUri;
			return "pending";
		}
	
		// test svg support
		types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );
	
		/**
		 * updates the internal vW property with the current viewport width in px
		 */
		function updateMetrics() {
	
			isVwDirty = false;
			DPR = window.devicePixelRatio;
			cssCache = {};
			sizeLengthCache = {};
	
			pf.DPR = DPR || 1;
	
			units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
			units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);
	
			units.vw = units.width / 100;
			units.vh = units.height / 100;
	
			evalId = [ units.height, units.width, DPR ].join("-");
	
			units.em = pf.getEmValue();
			units.rem = units.em;
		}
	
		function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
			var bonusFactor, tooMuch, bonus, meanDensity;
	
			//experimental
			if (cfg.algorithm === "saveData" ){
				if ( lowerValue > 2.7 ) {
					meanDensity = dprValue + 1;
				} else {
					tooMuch = higherValue - dprValue;
					bonusFactor = Math.pow(lowerValue - 0.6, 1.5);
	
					bonus = tooMuch * bonusFactor;
	
					if (isCached) {
						bonus += 0.1 * bonusFactor;
					}
	
					meanDensity = lowerValue + bonus;
				}
			} else {
				meanDensity = (dprValue > 1) ?
					Math.sqrt(lowerValue * higherValue) :
					lowerValue;
			}
	
			return meanDensity > dprValue;
		}
	
		function applyBestCandidate( img ) {
			var srcSetCandidates;
			var matchingSet = pf.getSet( img );
			var evaluated = false;
			if ( matchingSet !== "pending" ) {
				evaluated = evalId;
				if ( matchingSet ) {
					srcSetCandidates = pf.setRes( matchingSet );
					pf.applySetCandidate( srcSetCandidates, img );
				}
			}
			img[ pf.ns ].evaled = evaluated;
		}
	
		function ascendingSort( a, b ) {
			return a.res - b.res;
		}
	
		function setSrcToCur( img, src, set ) {
			var candidate;
			if ( !set && src ) {
				set = img[ pf.ns ].sets;
				set = set && set[set.length - 1];
			}
	
			candidate = getCandidateForSrc(src, set);
	
			if ( candidate ) {
				src = pf.makeUrl(src);
				img[ pf.ns ].curSrc = src;
				img[ pf.ns ].curCan = candidate;
	
				if ( !candidate.res ) {
					setResolution( candidate, candidate.set.sizes );
				}
			}
			return candidate;
		}
	
		function getCandidateForSrc( src, set ) {
			var i, candidate, candidates;
			if ( src && set ) {
				candidates = pf.parseSet( set );
				src = pf.makeUrl(src);
				for ( i = 0; i < candidates.length; i++ ) {
					if ( src === pf.makeUrl(candidates[ i ].url) ) {
						candidate = candidates[ i ];
						break;
					}
				}
			}
			return candidate;
		}
	
		function getAllSourceElements( picture, candidates ) {
			var i, len, source, srcset;
	
			// SPEC mismatch intended for size and perf:
			// actually only source elements preceding the img should be used
			// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
			var sources = picture.getElementsByTagName( "source" );
	
			for ( i = 0, len = sources.length; i < len; i++ ) {
				source = sources[ i ];
				source[ pf.ns ] = true;
				srcset = source.getAttribute( "srcset" );
	
				// if source does not have a srcset attribute, skip
				if ( srcset ) {
					candidates.push( {
						srcset: srcset,
						media: source.getAttribute( "media" ),
						type: source.getAttribute( "type" ),
						sizes: source.getAttribute( "sizes" )
					} );
				}
			}
		}
	
		/**
		 * Srcset Parser
		 * By Alex Bell |  MIT License
		 *
		 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
		 *
		 * Based super duper closely on the reference algorithm at:
		 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
		 */
	
		// 1. Let input be the value passed to this algorithm.
		// (TO-DO : Explain what "set" argument is here. Maybe choose a more
		// descriptive & more searchable name.  Since passing the "set" in really has
		// nothing to do with parsing proper, I would prefer this assignment eventually
		// go in an external fn.)
		function parseSrcset(input, set) {
	
			function collectCharacters(regEx) {
				var chars,
				    match = regEx.exec(input.substring(pos));
				if (match) {
					chars = match[ 0 ];
					pos += chars.length;
					return chars;
				}
			}
	
			var inputLength = input.length,
			    url,
			    descriptors,
			    currentDescriptor,
			    state,
			    c,
	
			    // 2. Let position be a pointer into input, initially pointing at the start
			    //    of the string.
			    pos = 0,
	
			    // 3. Let candidates be an initially empty source set.
			    candidates = [];
	
			/**
			* Adds descriptor properties to a candidate, pushes to the candidates array
			* @return undefined
			*/
			// (Declared outside of the while loop so that it's only created once.
			// (This fn is defined before it is used, in order to pass JSHINT.
			// Unfortunately this breaks the sequencing of the spec comments. :/ )
			function parseDescriptors() {
	
				// 9. Descriptor parser: Let error be no.
				var pError = false,
	
				// 10. Let width be absent.
				// 11. Let density be absent.
				// 12. Let future-compat-h be absent. (We're implementing it now as h)
				    w, d, h, i,
				    candidate = {},
				    desc, lastChar, value, intVal, floatVal;
	
				// 13. For each descriptor in descriptors, run the appropriate set of steps
				// from the following list:
				for (i = 0 ; i < descriptors.length; i++) {
					desc = descriptors[ i ];
	
					lastChar = desc[ desc.length - 1 ];
					value = desc.substring(0, desc.length - 1);
					intVal = parseInt(value, 10);
					floatVal = parseFloat(value);
	
					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0077 LATIN SMALL LETTER W character
					if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {
	
						// If width and density are not both absent, then let error be yes.
						if (w || d) {pError = true;}
	
						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes.
						// Otherwise, let width be the result.
						if (intVal === 0) {pError = true;} else {w = intVal;}
	
					// If the descriptor consists of a valid floating-point number followed by
					// a U+0078 LATIN SMALL LETTER X character
					} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {
	
						// If width, density and future-compat-h are not all absent, then let error
						// be yes.
						if (w || d || h) {pError = true;}
	
						// Apply the rules for parsing floating-point number values to the descriptor.
						// If the result is less than zero, let error be yes. Otherwise, let density
						// be the result.
						if (floatVal < 0) {pError = true;} else {d = floatVal;}
	
					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0068 LATIN SMALL LETTER H character
					} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {
	
						// If height and density are not both absent, then let error be yes.
						if (h || d) {pError = true;}
	
						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes. Otherwise, let future-compat-h
						// be the result.
						if (intVal === 0) {pError = true;} else {h = intVal;}
	
					// Anything else, Let error be yes.
					} else {pError = true;}
				} // (close step 13 for loop)
	
				// 15. If error is still no, then append a new image source to candidates whose
				// URL is url, associated with a width width if not absent and a pixel
				// density density if not absent. Otherwise, there is a parse error.
				if (!pError) {
					candidate.url = url;
	
					if (w) { candidate.w = w;}
					if (d) { candidate.d = d;}
					if (h) { candidate.h = h;}
					if (!h && !d && !w) {candidate.d = 1;}
					if (candidate.d === 1) {set.has1x = true;}
					candidate.set = set;
	
					candidates.push(candidate);
				}
			} // (close parseDescriptors fn)
	
			/**
			* Tokenizes descriptor properties prior to parsing
			* Returns undefined.
			* (Again, this fn is defined before it is used, in order to pass JSHINT.
			* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
			*/
			function tokenize() {
	
				// 8.1. Descriptor tokeniser: Skip whitespace
				collectCharacters(regexLeadingSpaces);
	
				// 8.2. Let current descriptor be the empty string.
				currentDescriptor = "";
	
				// 8.3. Let state be in descriptor.
				state = "in descriptor";
	
				while (true) {
	
					// 8.4. Let c be the character at position.
					c = input.charAt(pos);
	
					//  Do the following depending on the value of state.
					//  For the purpose of this step, "EOF" is a special character representing
					//  that position is past the end of input.
	
					// In descriptor
					if (state === "in descriptor") {
						// Do the following, depending on the value of c:
	
					  // Space character
					  // If current descriptor is not empty, append current descriptor to
					  // descriptors and let current descriptor be the empty string.
					  // Set state to after descriptor.
						if (isSpace(c)) {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
								currentDescriptor = "";
								state = "after descriptor";
							}
	
						// U+002C COMMA (,)
						// Advance position to the next character in input. If current descriptor
						// is not empty, append current descriptor to descriptors. Jump to the step
						// labeled descriptor parser.
						} else if (c === ",") {
							pos += 1;
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;
	
						// U+0028 LEFT PARENTHESIS (()
						// Append c to current descriptor. Set state to in parens.
						} else if (c === "\u0028") {
							currentDescriptor = currentDescriptor + c;
							state = "in parens";
	
						// EOF
						// If current descriptor is not empty, append current descriptor to
						// descriptors. Jump to the step labeled descriptor parser.
						} else if (c === "") {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;
	
						// Anything else
						// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
					// (end "in descriptor"
	
					// In parens
					} else if (state === "in parens") {
	
						// U+0029 RIGHT PARENTHESIS ())
						// Append c to current descriptor. Set state to in descriptor.
						if (c === ")") {
							currentDescriptor = currentDescriptor + c;
							state = "in descriptor";
	
						// EOF
						// Append current descriptor to descriptors. Jump to the step labeled
						// descriptor parser.
						} else if (c === "") {
							descriptors.push(currentDescriptor);
							parseDescriptors();
							return;
	
						// Anything else
						// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
	
					// After descriptor
					} else if (state === "after descriptor") {
	
						// Do the following, depending on the value of c:
						// Space character: Stay in this state.
						if (isSpace(c)) {
	
						// EOF: Jump to the step labeled descriptor parser.
						} else if (c === "") {
							parseDescriptors();
							return;
	
						// Anything else
						// Set state to in descriptor. Set position to the previous character in input.
						} else {
							state = "in descriptor";
							pos -= 1;
	
						}
					}
	
					// Advance position to the next character in input.
					pos += 1;
	
				// Repeat this step.
				} // (close while true loop)
			}
	
			// 4. Splitting loop: Collect a sequence of characters that are space
			//    characters or U+002C COMMA characters. If any U+002C COMMA characters
			//    were collected, that is a parse error.
			while (true) {
				collectCharacters(regexLeadingCommasOrSpaces);
	
				// 5. If position is past the end of input, return candidates and abort these steps.
				if (pos >= inputLength) {
					return candidates; // (we're done, this is the sole return path)
				}
	
				// 6. Collect a sequence of characters that are not space characters,
				//    and let that be url.
				url = collectCharacters(regexLeadingNotSpaces);
	
				// 7. Let descriptors be a new empty list.
				descriptors = [];
	
				// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
				//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
				//         more than one character, that is a parse error.
				if (url.slice(-1) === ",") {
					url = url.replace(regexTrailingCommas, "");
					// (Jump ahead to step 9 to skip tokenization and just push the candidate).
					parseDescriptors();
	
				//	Otherwise, follow these substeps:
				} else {
					tokenize();
				} // (close else of step 8)
	
			// 16. Return to the step labeled splitting loop.
			} // (Close of big while loop.)
		}
	
		/*
		 * Sizes Parser
		 *
		 * By Alex Bell |  MIT License
		 *
		 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
		 *
		 * Reference algorithm at:
		 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
		 *
		 * Most comments are copied in directly from the spec
		 * (except for comments in parens).
		 *
		 * Grammar is:
		 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
		 * <source-size> = <media-condition> <source-size-value>
		 * <source-size-value> = <length>
		 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
		 *
		 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
		 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
		 *
		 * Returns the first valid <css-length> with a media condition that evaluates to true,
		 * or "100vw" if all valid media conditions evaluate to false.
		 *
		 */
	
		function parseSizes(strValue) {
	
			// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
			// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
			// CSS allows a single optional plus or minus sign:
			// http://www.w3.org/TR/CSS2/syndata.html#numbers
			// CSS is ASCII case-insensitive:
			// http://www.w3.org/TR/CSS2/syndata.html#characters )
			// Spec allows exponential notation for <number> type:
			// http://dev.w3.org/csswg/css-values/#numbers
			var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;
	
			// (This is a quick and lenient test. Because of optional unlimited-depth internal
			// grouping parens and strict spacing rules, this could get very complicated.)
			var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;
	
			var i;
			var unparsedSizesList;
			var unparsedSizesListLength;
			var unparsedSize;
			var lastComponentValue;
			var size;
	
			// UTILITY FUNCTIONS
	
			//  (Toy CSS parser. The goals here are:
			//  1) expansive test coverage without the weight of a full CSS parser.
			//  2) Avoiding regex wherever convenient.
			//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
			//  Returns an array of arrays.)
			function parseComponentValues(str) {
				var chrctr;
				var component = "";
				var componentArray = [];
				var listArray = [];
				var parenDepth = 0;
				var pos = 0;
				var inComment = false;
	
				function pushComponent() {
					if (component) {
						componentArray.push(component);
						component = "";
					}
				}
	
				function pushComponentArray() {
					if (componentArray[0]) {
						listArray.push(componentArray);
						componentArray = [];
					}
				}
	
				// (Loop forwards from the beginning of the string.)
				while (true) {
					chrctr = str.charAt(pos);
	
					if (chrctr === "") { // ( End of string reached.)
						pushComponent();
						pushComponentArray();
						return listArray;
					} else if (inComment) {
						if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
							inComment = false;
							pos += 2;
							pushComponent();
							continue;
						} else {
							pos += 1; // (Skip all characters inside comments.)
							continue;
						}
					} else if (isSpace(chrctr)) {
						// (If previous character in loop was also a space, or if
						// at the beginning of the string, do not add space char to
						// component.)
						if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
							pos += 1;
							continue;
						} else if (parenDepth === 0) {
							pushComponent();
							pos +=1;
							continue;
						} else {
							// (Replace any space character with a plain space for legibility.)
							chrctr = " ";
						}
					} else if (chrctr === "(") {
						parenDepth += 1;
					} else if (chrctr === ")") {
						parenDepth -= 1;
					} else if (chrctr === ",") {
						pushComponent();
						pushComponentArray();
						pos += 1;
						continue;
					} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
						inComment = true;
						pos += 2;
						continue;
					}
	
					component = component + chrctr;
					pos += 1;
				}
			}
	
			function isValidNonNegativeSourceSizeValue(s) {
				if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
				if (regexCssCalc.test(s)) {return true;}
				// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
				// "-0 is equivalent to 0 and is not a negative number." which means that
				// unitless zero and unitless negative zero must be accepted as special cases.)
				if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
				return false;
			}
	
			// When asked to parse a sizes attribute from an element, parse a
			// comma-separated list of component values from the value of the element's
			// sizes attribute (or the empty string, if the attribute is absent), and let
			// unparsed sizes list be the result.
			// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values
	
			unparsedSizesList = parseComponentValues(strValue);
			unparsedSizesListLength = unparsedSizesList.length;
	
			// For each unparsed size in unparsed sizes list:
			for (i = 0; i < unparsedSizesListLength; i++) {
				unparsedSize = unparsedSizesList[i];
	
				// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
				// ( parseComponentValues() already omits spaces outside of parens. )
	
				// If unparsed size is now empty, that is a parse error; continue to the next
				// iteration of this algorithm.
				// ( parseComponentValues() won't push an empty array. )
	
				// 2. If the last component value in unparsed size is a valid non-negative
				// <source-size-value>, let size be its value and remove the component value
				// from unparsed size. Any CSS function other than the calc() function is
				// invalid. Otherwise, there is a parse error; continue to the next iteration
				// of this algorithm.
				// http://dev.w3.org/csswg/css-syntax/#parse-component-value
				lastComponentValue = unparsedSize[unparsedSize.length - 1];
	
				if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
					size = lastComponentValue;
					unparsedSize.pop();
				} else {
					continue;
				}
	
				// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
				// size. If unparsed size is now empty, return size and exit this algorithm.
				// If this was not the last item in unparsed sizes list, that is a parse error.
				if (unparsedSize.length === 0) {
					return size;
				}
	
				// 4. Parse the remaining component values in unparsed size as a
				// <media-condition>. If it does not parse correctly, or it does parse
				// correctly but the <media-condition> evaluates to false, continue to the
				// next iteration of this algorithm.
				// (Parsing all possible compound media conditions in JS is heavy, complicated,
				// and the payoff is unclear. Is there ever an situation where the
				// media condition parses incorrectly but still somehow evaluates to true?
				// Can we just rely on the browser/polyfill to do it?)
				unparsedSize = unparsedSize.join(" ");
				if (!(pf.matchesMedia( unparsedSize ) ) ) {
					continue;
				}
	
				// 5. Return size and exit this algorithm.
				return size;
			}
	
			// If the above algorithm exhausts unparsed sizes list without returning a
			// size value, return 100vw.
			return "100vw";
		}
	
		// namespace
		pf.ns = ("pf" + new Date().getTime()).substr(0, 9);
	
		// srcset support test
		pf.supSrcset = "srcset" in image;
		pf.supSizes = "sizes" in image;
		pf.supPicture = !!window.HTMLPictureElement;
	
		// UC browser does claim to support srcset and picture, but not sizes,
		// this extended test reveals the browser does support nothing
		if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
			(function(image2) {
				image.srcset = "data:,a";
				image2.src = "data:,a";
				pf.supSrcset = image.complete === image2.complete;
				pf.supPicture = pf.supSrcset && pf.supPicture;
			})(document.createElement("img"));
		}
	
		// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
		if (pf.supSrcset && !pf.supSizes) {
	
			(function() {
				var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
				var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
				var img = document.createElement("img");
				var test = function() {
					var width = img.width;
	
					if (width === 2) {
						pf.supSizes = true;
					}
	
					alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;
	
					isSupportTestReady = true;
					// force async
					setTimeout(picturefill);
				};
	
				img.onload = test;
				img.onerror = test;
				img.setAttribute("sizes", "9px");
	
				img.srcset = width1 + " 1w," + width2 + " 9w";
				img.src = width1;
			})();
	
		} else {
			isSupportTestReady = true;
		}
	
		// using pf.qsa instead of dom traversing does scale much better,
		// especially on sites mixing responsive and non-responsive images
		pf.selShort = "picture>img,img[srcset]";
		pf.sel = pf.selShort;
		pf.cfg = cfg;
	
		/**
		 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
		 */
		pf.DPR = (DPR  || 1 );
		pf.u = units;
	
		// container of supported mime types that one might need to qualify before using
		pf.types =  types;
	
		pf.setSize = noop;
	
		/**
		 * Gets a string and returns the absolute URL
		 * @param src
		 * @returns {String} absolute URL
		 */
	
		pf.makeUrl = memoize(function(src) {
			anchor.href = src;
			return anchor.href;
		});
	
		/**
		 * Gets a DOM element or document and a selctor and returns the found matches
		 * Can be extended with jQuery/Sizzle for IE7 support
		 * @param context
		 * @param sel
		 * @returns {NodeList|Array}
		 */
		pf.qsa = function(context, sel) {
			return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
		};
	
		/**
		 * Shortcut method for matchMedia ( for easy overriding in tests )
		 * wether native or pf.mMQ is used will be decided lazy on first call
		 * @returns {boolean}
		 */
		pf.matchesMedia = function() {
			if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
				pf.matchesMedia = function( media ) {
					return !media || ( matchMedia( media ).matches );
				};
			} else {
				pf.matchesMedia = pf.mMQ;
			}
	
			return pf.matchesMedia.apply( this, arguments );
		};
	
		/**
		 * A simplified matchMedia implementation for IE8 and IE9
		 * handles only min-width/max-width with px or em values
		 * @param media
		 * @returns {boolean}
		 */
		pf.mMQ = function( media ) {
			return media ? evalCSS(media) : true;
		};
	
		/**
		 * Returns the calculated length in css pixel from the given sourceSizeValue
		 * http://dev.w3.org/csswg/css-values-3/#length-value
		 * intended Spec mismatches:
		 * * Does not check for invalid use of CSS functions
		 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
		 * @param sourceSizeValue
		 * @returns {Number}
		 */
		pf.calcLength = function( sourceSizeValue ) {
	
			var value = evalCSS(sourceSizeValue, true) || false;
			if (value < 0) {
				value = false;
			}
	
			return value;
		};
	
		/**
		 * Takes a type string and checks if its supported
		 */
	
		pf.supportsType = function( type ) {
			return ( type ) ? types[ type ] : true;
		};
	
		/**
		 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
		 * @param sourceSizeStr
		 * @returns {*}
		 */
		pf.parseSize = memoize(function( sourceSizeStr ) {
			var match = ( sourceSizeStr || "" ).match(regSize);
			return {
				media: match && match[1],
				length: match && match[2]
			};
		});
	
		pf.parseSet = function( set ) {
			if ( !set.cands ) {
				set.cands = parseSrcset(set.srcset, set);
			}
			return set.cands;
		};
	
		/**
		 * returns 1em in css px for html/body default size
		 * function taken from respondjs
		 * @returns {*|number}
		 */
		pf.getEmValue = function() {
			var body;
			if ( !eminpx && (body = document.body) ) {
				var div = document.createElement( "div" ),
					originalHTMLCSS = docElem.style.cssText,
					originalBodyCSS = body.style.cssText;
	
				div.style.cssText = baseStyle;
	
				// 1em in a media query is the value of the default font size of the browser
				// reset docElem and body to ensure the correct value is returned
				docElem.style.cssText = fsCss;
				body.style.cssText = fsCss;
	
				body.appendChild( div );
				eminpx = div.offsetWidth;
				body.removeChild( div );
	
				//also update eminpx before returning
				eminpx = parseFloat( eminpx, 10 );
	
				// restore the original values
				docElem.style.cssText = originalHTMLCSS;
				body.style.cssText = originalBodyCSS;
	
			}
			return eminpx || 16;
		};
	
		/**
		 * Takes a string of sizes and returns the width in pixels as a number
		 */
		pf.calcListLength = function( sourceSizeListStr ) {
			// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
			//
			//                           or (min-width:30em) calc(30% - 15px)
			if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
				var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );
	
				sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
			}
	
			return sizeLengthCache[ sourceSizeListStr ];
		};
	
		/**
		 * Takes a candidate object with a srcset property in the form of url/
		 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
		 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
		 *     "images/pic-small.png"
		 * Get an array of image candidates in the form of
		 *      {url: "/foo/bar.png", resolution: 1}
		 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
		 * If sizes is specified, res is calculated
		 */
		pf.setRes = function( set ) {
			var candidates;
			if ( set ) {
	
				candidates = pf.parseSet( set );
	
				for ( var i = 0, len = candidates.length; i < len; i++ ) {
					setResolution( candidates[ i ], set.sizes );
				}
			}
			return candidates;
		};
	
		pf.setRes.res = setResolution;
	
		pf.applySetCandidate = function( candidates, img ) {
			if ( !candidates.length ) {return;}
			var candidate,
				i,
				j,
				length,
				bestCandidate,
				curSrc,
				curCan,
				candidateSrc,
				abortCurSrc;
	
			var imageData = img[ pf.ns ];
			var dpr = pf.DPR;
	
			curSrc = imageData.curSrc || img[curSrcProp];
	
			curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);
	
			// if we have a current source, we might either become lazy or give this source some advantage
			if ( curCan && curCan.set === candidates[ 0 ].set ) {
	
				// if browser can abort image request and the image has a higher pixel density than needed
				// and this image isn't downloaded yet, we skip next part and try to save bandwidth
				abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);
	
				if ( !abortCurSrc ) {
					curCan.cached = true;
	
					// if current candidate is "best", "better" or "okay",
					// set it to bestCandidate
					if ( curCan.res >= dpr ) {
						bestCandidate = curCan;
					}
				}
			}
	
			if ( !bestCandidate ) {
	
				candidates.sort( ascendingSort );
	
				length = candidates.length;
				bestCandidate = candidates[ length - 1 ];
	
				for ( i = 0; i < length; i++ ) {
					candidate = candidates[ i ];
					if ( candidate.res >= dpr ) {
						j = i - 1;
	
						// we have found the perfect candidate,
						// but let's improve this a little bit with some assumptions ;-)
						if (candidates[ j ] &&
							(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
							chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {
	
							bestCandidate = candidates[ j ];
	
						} else {
							bestCandidate = candidate;
						}
						break;
					}
				}
			}
	
			if ( bestCandidate ) {
	
				candidateSrc = pf.makeUrl( bestCandidate.url );
	
				imageData.curSrc = candidateSrc;
				imageData.curCan = bestCandidate;
	
				if ( candidateSrc !== curSrc ) {
					pf.setSrc( img, bestCandidate );
				}
				pf.setSize( img );
			}
		};
	
		pf.setSrc = function( img, bestCandidate ) {
			var origWidth;
			img.src = bestCandidate.url;
	
			// although this is a specific Safari issue, we don't want to take too much different code paths
			if ( bestCandidate.set.type === "image/svg+xml" ) {
				origWidth = img.style.width;
				img.style.width = (img.offsetWidth + 1) + "px";
	
				// next line only should trigger a repaint
				// if... is only done to trick dead code removal
				if ( img.offsetWidth + 1 ) {
					img.style.width = origWidth;
				}
			}
		};
	
		pf.getSet = function( img ) {
			var i, set, supportsType;
			var match = false;
			var sets = img [ pf.ns ].sets;
	
			for ( i = 0; i < sets.length && !match; i++ ) {
				set = sets[i];
	
				if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
					continue;
				}
	
				if ( supportsType === "pending" ) {
					set = supportsType;
				}
	
				match = set;
				break;
			}
	
			return match;
		};
	
		pf.parseSets = function( element, parent, options ) {
			var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;
	
			var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
			var imageData = element[ pf.ns ];
	
			if ( imageData.src === undefined || options.src ) {
				imageData.src = getImgAttr.call( element, "src" );
				if ( imageData.src ) {
					setImgAttr.call( element, srcAttr, imageData.src );
				} else {
					removeImgAttr.call( element, srcAttr );
				}
			}
	
			if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
				srcsetAttribute = getImgAttr.call( element, "srcset" );
				imageData.srcset = srcsetAttribute;
				srcsetParsed = true;
			}
	
			imageData.sets = [];
	
			if ( hasPicture ) {
				imageData.pic = true;
				getAllSourceElements( parent, imageData.sets );
			}
	
			if ( imageData.srcset ) {
				imageSet = {
					srcset: imageData.srcset,
					sizes: getImgAttr.call( element, "sizes" )
				};
	
				imageData.sets.push( imageSet );
	
				isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");
	
				// add normal src as candidate, if source has no w descriptor
				if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
					imageSet.srcset += ", " + imageData.src;
					imageSet.cands.push({
						url: imageData.src,
						d: 1,
						set: imageSet
					});
				}
	
			} else if ( imageData.src ) {
				imageData.sets.push( {
					srcset: imageData.src,
					sizes: null
				} );
			}
	
			imageData.curCan = null;
			imageData.curSrc = undefined;
	
			// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
			// or has a w descriptor (and does not support sizes) set support to false to evaluate
			imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );
	
			if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
				if ( srcsetAttribute ) {
					setImgAttr.call( element, srcsetAttr, srcsetAttribute );
					element.srcset = "";
				} else {
					removeImgAttr.call( element, srcsetAttr );
				}
			}
	
			if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
				if (imageData.src === null) {
					element.removeAttribute("src");
				} else {
					element.src = imageData.src;
				}
			}
	
			imageData.parsed = true;
		};
	
		pf.fillImg = function(element, options) {
			var imageData;
			var extreme = options.reselect || options.reevaluate;
	
			// expando for caching data on the img
			if ( !element[ pf.ns ] ) {
				element[ pf.ns ] = {};
			}
	
			imageData = element[ pf.ns ];
	
			// if the element has already been evaluated, skip it
			// unless `options.reevaluate` is set to true ( this, for example,
			// is set to true when running `picturefill` on `resize` ).
			if ( !extreme && imageData.evaled === evalId ) {
				return;
			}
	
			if ( !imageData.parsed || options.reevaluate ) {
				pf.parseSets( element, element.parentNode, options );
			}
	
			if ( !imageData.supported ) {
				applyBestCandidate( element );
			} else {
				imageData.evaled = evalId;
			}
		};
	
		pf.setupRun = function() {
			if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
				updateMetrics();
			}
		};
	
		// If picture is supported, well, that's awesome.
		if ( pf.supPicture ) {
			picturefill = noop;
			pf.fillImg = noop;
		} else {
	
			 // Set up picture polyfill by polling the document
			(function() {
				var isDomReady;
				var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;
	
				var run = function() {
					var readyState = document.readyState || "";
	
					timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
					if ( document.body ) {
						pf.fillImgs();
						isDomReady = isDomReady || regReady.test(readyState);
						if ( isDomReady ) {
							clearTimeout( timerId );
						}
	
					}
				};
	
				var timerId = setTimeout(run, document.body ? 9 : 99);
	
				// Also attach picturefill on resize and readystatechange
				// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
				var debounce = function(func, wait) {
					var timeout, timestamp;
					var later = function() {
						var last = (new Date()) - timestamp;
	
						if (last < wait) {
							timeout = setTimeout(later, wait - last);
						} else {
							timeout = null;
							func();
						}
					};
	
					return function() {
						timestamp = new Date();
	
						if (!timeout) {
							timeout = setTimeout(later, wait);
						}
					};
				};
				var lastClientWidth = docElem.clientHeight;
				var onResize = function() {
					isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
					lastClientWidth = docElem.clientHeight;
					if ( isVwDirty ) {
						pf.fillImgs();
					}
				};
	
				on( window, "resize", debounce(onResize, 99 ) );
				on( document, "readystatechange", run );
			})();
		}
	
		pf.picturefill = picturefill;
		//use this internally for easy monkey patching/performance testing
		pf.fillImgs = picturefill;
		pf.teardownRun = noop;
	
		/* expose methods for testing */
		picturefill._ = pf;
	
		window.picturefillCFG = {
			pf: pf,
			push: function(args) {
				var name = args.shift();
				if (typeof pf[name] === "function") {
					pf[name].apply(pf, args);
				} else {
					cfg[name] = args[0];
					if (alreadyRun) {
						pf.fillImgs( { reselect: true } );
					}
				}
			}
		};
	
		while (setOptions && setOptions.length) {
			window.picturefillCFG.push(setOptions.shift());
		}
	
		/* expose picturefill */
		window.picturefill = picturefill;
	
		/* expose picturefill */
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// CommonJS, just export
			module.exports = picturefill;
		} else if ( true ) {
			// AMD support
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return picturefill; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		// IE8 evals this sync, so it must be the last thing we do
		if ( !pf.supPicture ) {
			types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
		}
	
	} )( window, document );


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/common.4972672be4423e205957.js